import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  VOID3gxj6tk5isa35 as VOID,
  StringCompanionObject_instance3btc7up7fjjpg as StringCompanionObject_instance,
  Unit_instance3vdlo4e4f5ggx as Unit_instance,
  constructCallableReference23y65rf941mch as constructCallableReference,
  emptyList1g2z5xcrvp2zy as emptyList,
  LazyThreadSafetyMode_PUBLICATION_getInstance20ynwq7b0awd8 as LazyThreadSafetyMode_PUBLICATION_getInstance,
  lazy1261dae0bgscp as lazy,
  asList2ho2pewtsfvv as asList,
  KProperty1ca4yb4wlo496 as KProperty1,
  getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef,
  toString1pkumu07cwy4m as toString,
  getKClassFromExpression348iqjl4fnx2f as getKClassFromExpression,
  IllegalArgumentException2asla15b5jaob as IllegalArgumentException,
  zip2suipyqmdw72q as zip,
  toMap1vec9topfei08 as toMap,
  LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap,
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
  mapCapacity1h45rc3eh9p2l as mapCapacity,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  KtMap140uvy3s5zad8 as KtMap,
  isInterface3d6p8outrmvmk as isInterface,
  captureStack1fzi4aczwc4hg as captureStack,
  ArrayList3it5z8td81qkl as ArrayList,
  collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault,
  _Result___get_value__impl__bjfvqgfu6uyyvgx74d as _Result___get_value__impl__bjfvqg,
  _Result___get_isFailure__impl__jpirivaggyjf2c4e0j as _Result___get_isFailure__impl__jpiriv,
  KClass1cc9rfeybg8hs as KClass,
  Triple1vhi3d0dgpnjb as Triple,
  getKClass3t8tygqu4lcxf as getKClass,
  Paire9pteg33gng7 as Pair,
  Entry2xmjmyutzoq3p as Entry,
  KtMutableMap1kqeifoi36kpz as KtMutableMap,
  HashMap1a0ld5kgwhmhv as HashMap,
  KtSetjrjc7fhfd6b9 as KtSet,
  KtMutableSetwuwn7k5m570a as KtMutableSet,
  LinkedHashSet2tkztfx86kyx2 as LinkedHashSet,
  HashSet2dzve9y63nf0v as HashSet,
  Collection1k04j3hzsbod0 as Collection,
  KtList3hktaavzmj137 as KtList,
  KtMutableList1beimitadwkna as KtMutableList,
  copyToArray2j022khrow2yi as copyToArray,
  Result3t1vadv16kmzk as Result,
  ensureNotNull1e947j3ixpazm as ensureNotNull,
  equals2au1ep9vhcato as equals,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  Iterable1y3qizuf89iou as Iterable,
  isBlank1dvkhjjvox3p0 as isBlank,
  toList383f556t1dixk as toList,
  toHashSet1qrcsl3g8ugc8 as toHashSet,
  toBooleanArray2u3qw7fjwsmuh as toBooleanArray,
  withIndex3s8q7w1g0hyfn as withIndex,
  to2cs3ny02qtbcb as to,
  lazy2hsh8ze7j6ikd as lazy_0,
  contentEqualsaf55p28mnw74 as contentEquals,
  protoOf180f3jzyo7rfj as protoOf,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  Long2qws0ah9gnpki as Long,
  Char19o2r8palgjof as Char,
  createThis2j2avj17cvnv2 as createThis,
  Duration__toIsoString_impl_9h6wsm27lfqp1ek3b1l as Duration__toIsoString_impl_9h6wsm,
  Duration5ynfiptaqcrg as Duration,
  Companion_getInstance4z8fvmvpott5 as Companion_getInstance,
  Instant2s2zyzgfc4947 as Instant,
  Companion_getInstance10dt578q09swj as Companion_getInstance_0,
  Uuid1zxgztb7abqxx as Uuid,
  Companion_getInstance2lw3j8toa9ha6 as Companion_getInstance_1,
  toIntOrNull3w2d066r9pvwm as toIntOrNull,
  hashCodeq5arwsb9dgti as hashCode,
  isArray1hxjqtqy632bc as isArray,
  arrayIterator3lgwvgteckzhv as arrayIterator,
  until1jbpn0z3f8lbg as until,
  step18s9qzr5xwxat as step,
  getValue48kllevslyh6 as getValue,
  longArray288a0fctlmjmj as longArray,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  get_lastIndex1y2f6o9u8hnf7 as get_lastIndex,
  shiftLeft1ck77p6vapyra as shiftLeft,
  bitwiseOr1ita6dahwp8zb as bitwiseOr,
  equalsLong28bsrfhwvd686 as equalsLong,
  invert3i8k5n0dd6oib as invert,
  countTrailingZeroBits1k55x07cygoff as countTrailingZeroBits,
  indexOf3ic8eacwbbrog as indexOf,
  contentToString3ujacv8hqfipd as contentToString,
  Enum3alwj03lh1n41 as Enum,
  joinToString1cxrrlmo0chqs as joinToString,
  getOrNull1d60i0672n7ns as getOrNull,
  toString30pk9tzaqopn as toString_0,
  KTypeParameter1s8efufd4mbj5 as KTypeParameter,
  booleanArray2jdug9b51huk7 as booleanArray,
  emptyMapr06gerzljqtm as emptyMap,
  contentHashCode2i020q5tbeh2s as contentHashCode,
  Companion_getInstance2me39a222cg9k as Companion_getInstance_2,
  isCharArray21auq5hbrg68m as isCharArray,
  charArray2ujmm1qusno00 as charArray,
  DoubleCompanionObject_instance2owjtjg73ep4r as DoubleCompanionObject_instance,
  isDoubleArray1wyh4nyf7pjxn as isDoubleArray,
  FloatCompanionObject_instance1ya67s5frsek3 as FloatCompanionObject_instance,
  isFloatArrayjjscnqphw92j as isFloatArray,
  Companion_getInstance1ztf3w4az04w2 as Companion_getInstance_3,
  isLongArray2hqvh9jsglssi as isLongArray,
  Companion_getInstancehe6v7kxreu2f as Companion_getInstance_4,
  _ULongArray___get_size__impl__ju6dtr294dl6tm51vl0 as _ULongArray___get_size__impl__ju6dtr,
  ULongArray3nd0d80mdwjj8 as ULongArray,
  _ULongArray___init__impl__twm1l33hs41a6eujp5f as _ULongArray___init__impl__twm1l3,
  _ULong___init__impl__c78o9k3fkiaf1q5xsf7 as _ULong___init__impl__c78o9k,
  ULongArray__get_impl_pr71q92wbpzmu6hb05i as ULongArray__get_impl_pr71q9,
  _ULong___get_data__impl__fggpzb35t7vg7og3i8u as _ULong___get_data__impl__fggpzb,
  IntCompanionObject_instanceru1css19onx6 as IntCompanionObject_instance,
  isIntArrayeijsubfngq38 as isIntArray,
  Companion_getInstance2bqk1h54tdzgh as Companion_getInstance_5,
  _UIntArray___get_size__impl__r6l8ci13q5tym30x5f8 as _UIntArray___get_size__impl__r6l8ci,
  UIntArrayrp6cv44n5v4y as UIntArray,
  _UIntArray___init__impl__ghjpc61d4fxfei6kfsc as _UIntArray___init__impl__ghjpc6,
  _UInt___init__impl__l7qpdl2rn8hu5x5mgv2 as _UInt___init__impl__l7qpdl,
  UIntArray__get_impl_gp5kza1vhqxkvvk9rrv as UIntArray__get_impl_gp5kza,
  _UInt___get_data__impl__f0vqqw18g8a2o14g87q as _UInt___get_data__impl__f0vqqw,
  ShortCompanionObject_instance28ym5go6niq9r as ShortCompanionObject_instance,
  isShortArraywz30zxwtqi8h as isShortArray,
  Companion_getInstancehpp5w6ty1u0b as Companion_getInstance_6,
  _UShortArray___get_size__impl__jqto1b26bmy1f82up0s as _UShortArray___get_size__impl__jqto1b,
  UShortArray11avpmknxdgvv as UShortArray,
  _UShortArray___init__impl__9b26ef1072738vvd6x4 as _UShortArray___init__impl__9b26ef,
  _UShort___init__impl__jigrne1zu56ujvuii2n as _UShort___init__impl__jigrne,
  UShortArray__get_impl_fnbhmx33wy68opzjz82 as UShortArray__get_impl_fnbhmx,
  _UShort___get_data__impl__g02451joe1vsk2vach as _UShort___get_data__impl__g0245,
  ByteCompanionObject_instance3kkatsq6s1rq7 as ByteCompanionObject_instance,
  isByteArray4nnzfn1x4o3w as isByteArray,
  Companion_getInstance29en1y99grgx1 as Companion_getInstance_7,
  _UByteArray___get_size__impl__h6pkdv2q8ncjn6v8oz0 as _UByteArray___get_size__impl__h6pkdv,
  UByteArray2qu4d6gwssdf9 as UByteArray,
  _UByteArray___init__impl__ip4y9n1ymkr3h4vpfmg as _UByteArray___init__impl__ip4y9n,
  _UByte___init__impl__g9hnc430zp6cgd9f0jq as _UByte___init__impl__g9hnc4,
  UByteArray__get_impl_t5f3hvbbj411cc05mf as UByteArray__get_impl_t5f3hv,
  _UByte___get_data__impl__jof9qryxuf3cmdpzyk as _UByte___get_data__impl__jof9qr,
  BooleanCompanionObject_instancem7duqvmx6ml6 as BooleanCompanionObject_instance,
  isBooleanArray35llghle4c6w1 as isBooleanArray,
  coerceAtLeast2bkz8m9ik7hep as coerceAtLeast,
  copyOf2p23ljc5f5ea3 as copyOf,
  copyOfgossjg6lh6js as copyOf_0,
  copyOfq9pcgcgbldck as copyOf_1,
  copyOf9mbsebmgnw4t as copyOf_2,
  _ULongArray___get_storage__impl__28e64j17j1wffnse0mq as _ULongArray___get_storage__impl__28e64j,
  _ULongArray___init__impl__twm1l327hyqbmoo3gha as _ULongArray___init__impl__twm1l3_0,
  ULongArray__set_impl_z19mvh7mby1284z6pf as ULongArray__set_impl_z19mvh,
  copyOf3rutauicler23 as copyOf_3,
  _UIntArray___get_storage__impl__92a0v03tsugia02e3ye as _UIntArray___get_storage__impl__92a0v0,
  _UIntArray___init__impl__ghjpc62t4adv3l2o8r9 as _UIntArray___init__impl__ghjpc6_0,
  UIntArray__set_impl_7f2zu23un3gauvkblmo as UIntArray__set_impl_7f2zu2,
  copyOf39s58md6y6rn6 as copyOf_4,
  _UShortArray___get_storage__impl__t2jpv515u9xaqouraih as _UShortArray___get_storage__impl__t2jpv5,
  _UShortArray___init__impl__9b26ef3n6f83gmc4g92 as _UShortArray___init__impl__9b26ef_0,
  UShortArray__set_impl_6d8whp3leme2hhamxoe as UShortArray__set_impl_6d8whp,
  copyOfwy6h3t5vzqpl as copyOf_5,
  _UByteArray___get_storage__impl__d4kcttp6btvbau0f8b as _UByteArray___get_storage__impl__d4kctt,
  _UByteArray___init__impl__ip4y9n15i9if485vlfd as _UByteArray___init__impl__ip4y9n_0,
  UByteArray__set_impl_jvcicn2hmfyga0u5ve0 as UByteArray__set_impl_jvcicn,
  copyOf37mht4mx7mjgh as copyOf_6,
  trimIndent1qytc1wvt8suh as trimIndent,
  Unitkvevlwgzwiuc as Unit,
  charSequenceLength3278n89t01tmv as charSequenceLength,
  lastOrNull1aq5oz189qoe1 as lastOrNull,
  get_lastIndex1yw0x4k50k51w as get_lastIndex_0,
  ULong3f9k7s38t3rfp as ULong,
  UInt1hthisrv6cndi as UInt,
  UBytep4j7r1t64gz1 as UByte,
  UShort26xnqty60t7le as UShort,
  noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException,
  asSequence2lno4vpru4ldl as asSequence,
  get_js1ale1wr4fbvs0 as get_js,
  PrimitiveClasses_getInstance143761yrsca9q as PrimitiveClasses_getInstance,
  findAssociatedObject1kb88g16k1goa as findAssociatedObject,
  IndexOutOfBoundsException1qfr429iumro0 as IndexOutOfBoundsException,
  get_indicesc04v40g017hw as get_indices,
  get_indices377latqcai313 as get_indices_0,
  get_longArrayClass1abke42rvvmr0 as get_longArrayClass,
  mapOf1xd03cq9cnmy8 as mapOf,
  Companion_instance1co2nkledm2ru as Companion_instance,
  _Result___init__impl__xyqfz810za1hm0unrcw as _Result___init__impl__xyqfz8,
  createFailure8paxfkfa5dc7 as createFailure,
} from './kotlin-kotlin-stdlib.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
class Serializable {}
class SerializationStrategy {}
class DeserializationStrategy {}
class KSerializer {}
class AbstractPolymorphicSerializer {
  static tz() {
    return createThis(this);
  }
  wz(encoder, value) {
    var actualSerializer = findPolymorphicSerializer_0(this, encoder, value);
    // Inline function 'kotlinx.serialization.encoding.encodeStructure' call
    var descriptor = this.dz();
    var composite = encoder.p13(descriptor);
    composite.e15(this.dz(), 0, actualSerializer.dz().g10());
    var tmp = this.dz();
    // Inline function 'kotlinx.serialization.internal.cast' call
    var tmp$ret$2 = isInterface(actualSerializer, SerializationStrategy) ? actualSerializer : THROW_CCE();
    composite.g15(tmp, 1, tmp$ret$2, value);
    composite.q13(descriptor);
  }
  ez(encoder, value) {
    return this.wz(encoder, !(value == null) ? value : THROW_CCE());
  }
  fz(decoder) {
    // Inline function 'kotlinx.serialization.encoding.decodeStructure' call
    var descriptor = this.dz();
    var composite = decoder.p13(descriptor);
    var tmp$ret$1;
    $l$block: {
      var klassName = null;
      var value = null;
      if (composite.e14()) {
        tmp$ret$1 = decodeSequentially_0(this, composite);
        break $l$block;
      }
      mainLoop: while (true) {
        var index = composite.f14(this.dz());
        switch (index) {
          case -1:
            break mainLoop;
          case 0:
            klassName = composite.z13(this.dz(), index);
            break;
          case 1:
            var tmp0 = klassName;
            var tmp$ret$2;
            $l$block_0: {
              // Inline function 'kotlin.requireNotNull' call
              if (tmp0 == null) {
                var message = 'Cannot read polymorphic value before its type token';
                throw IllegalArgumentException.h2(toString(message));
              } else {
                tmp$ret$2 = tmp0;
                break $l$block_0;
              }
            }

            klassName = tmp$ret$2;
            var serializer = findPolymorphicSerializer(this, composite, klassName);
            value = composite.c14(this.dz(), index, serializer);
            break;
          default:
            var tmp0_elvis_lhs = klassName;
            throw SerializationException.y10('Invalid index in polymorphic deserialization of ' + (tmp0_elvis_lhs == null ? 'unknown class' : tmp0_elvis_lhs) + ('\n Expected 0, 1 or DECODE_DONE(-1), but found ' + index));
        }
      }
      var tmp0_0 = value;
      var tmp$ret$4;
      $l$block_1: {
        // Inline function 'kotlin.requireNotNull' call
        if (tmp0_0 == null) {
          var message_0 = 'Polymorphic value has not been read for class ' + klassName;
          throw IllegalArgumentException.h2(toString(message_0));
        } else {
          tmp$ret$4 = tmp0_0;
          break $l$block_1;
        }
      }
      var tmp = tmp$ret$4;
      tmp$ret$1 = !(tmp == null) ? tmp : THROW_CCE();
    }
    var result = tmp$ret$1;
    composite.q13(descriptor);
    return result;
  }
  xz(decoder, klassName) {
    return decoder.l10().n15(this.uz(), klassName);
  }
  yz(encoder, value) {
    return encoder.l10().o15(this.uz(), value);
  }
}
class PolymorphicSerializer extends AbstractPolymorphicSerializer {
  constructor(baseClass) {
    return new.target.sz(baseClass);
  }
  static sz(baseClass) {
    var $this = this.tz();
    $this.pz_1 = baseClass;
    $this.qz_1 = emptyList();
    var tmp = $this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.rz_1 = lazy(tmp_0, PolymorphicSerializer$descriptor$delegate$lambda($this));
    return $this;
  }
  uz() {
    return this.pz_1;
  }
  static vz(baseClass, classAnnotations) {
    var $this = this.sz(baseClass);
    $this.qz_1 = asList(classAnnotations);
    return $this;
  }
  dz() {
    var tmp0 = this.rz_1;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('descriptor', 1, tmp, PolymorphicSerializer$_get_descriptor_$ref_8tw9if(), null);
    return tmp0.k3();
  }
  toString() {
    return 'kotlinx.serialization.PolymorphicSerializer(baseClass: ' + toString(this.pz_1) + ')';
  }
}
class SealedClassSerializer$$inlined$groupingBy$1 {
  constructor($this) {
    this.e10_1 = $this;
  }
  n7() {
    return this.e10_1.p1();
  }
  f10(element) {
    return element.k3().dz().g10();
  }
  o7(element) {
    return this.f10(element);
  }
}
class SealedClassSerializer extends AbstractPolymorphicSerializer {
  constructor(serialName, baseClass, subclasses, subclassSerializers) {
    return new.target.h10(serialName, baseClass, subclasses, subclassSerializers);
  }
  static h10(serialName, baseClass, subclasses, subclassSerializers) {
    var $this = this.tz();
    $this.zz_1 = baseClass;
    $this.a10_1 = emptyList();
    var tmp = $this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.b10_1 = lazy(tmp_0, SealedClassSerializer$descriptor$delegate$lambda(serialName, $this));
    if (!(subclasses.length === subclassSerializers.length)) {
      throw IllegalArgumentException.h2('All subclasses of sealed class ' + $this.zz_1.j1() + ' should be marked @Serializable');
    }
    $this.c10_1 = toMap(zip(subclasses, subclassSerializers));
    var tmp_1 = $this;
    // Inline function 'kotlin.collections.groupingBy' call
    var this_0 = $this.c10_1.i3();
    // Inline function 'kotlin.collections.aggregate' call
    var tmp0 = new SealedClassSerializer$$inlined$groupingBy$1(this_0);
    // Inline function 'kotlin.collections.mutableMapOf' call
    // Inline function 'kotlin.collections.aggregateTo' call
    var destination = LinkedHashMap.m7();
    // Inline function 'kotlin.collections.iterator' call
    var _iterator__ex2g4s = tmp0.n7();
    while (_iterator__ex2g4s.q1()) {
      var e = _iterator__ex2g4s.r1();
      var key = tmp0.o7(e);
      var accumulator = destination.w4(key);
      accumulator == null && !destination.u4(key);
      if (!(accumulator == null)) {
        // Inline function 'kotlin.error' call
        var message = "Multiple sealed subclasses of '" + toString($this.zz_1) + "' have the same serial name '" + key + "':" + (" '" + toString(accumulator.j3()) + "', '" + toString(e.j3()) + "'");
        throw IllegalStateException.o(toString(message));
      }
      // Inline function 'kotlin.collections.set' call
      destination.b5(key, e);
    }
    // Inline function 'kotlin.collections.mapValues' call
    // Inline function 'kotlin.collections.mapValuesTo' call
    var destination_0 = LinkedHashMap.cd(mapCapacity(destination.s2()));
    // Inline function 'kotlin.collections.associateByTo' call
    var _iterator__ex2g4s_0 = destination.i3().p1();
    while (_iterator__ex2g4s_0.q1()) {
      var element = _iterator__ex2g4s_0.r1();
      var tmp_2 = element.j3();
      var tmp$ret$12 = element.k3().k3();
      destination_0.b5(tmp_2, tmp$ret$12);
    }
    tmp_1.d10_1 = destination_0;
    return $this;
  }
  uz() {
    return this.zz_1;
  }
  static i10(serialName, baseClass, subclasses, subclassSerializers, classAnnotations) {
    var $this = this.h10(serialName, baseClass, subclasses, subclassSerializers);
    $this.a10_1 = asList(classAnnotations);
    return $this;
  }
  dz() {
    var tmp0 = this.b10_1;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('descriptor', 1, tmp, SealedClassSerializer$_get_descriptor_$ref_m511rz(), null);
    return tmp0.k3();
  }
  xz(decoder, klassName) {
    // Inline function 'kotlin.collections.get' call
    var this_0 = this.d10_1;
    var tmp0_elvis_lhs = (isInterface(this_0, KtMap) ? this_0 : THROW_CCE()).w4(klassName);
    return tmp0_elvis_lhs == null ? super.xz(decoder, klassName) : tmp0_elvis_lhs;
  }
  yz(encoder, value) {
    var tmp0_elvis_lhs = this.c10_1.w4(getKClassFromExpression(value));
    var tmp1_safe_receiver = tmp0_elvis_lhs == null ? super.yz(encoder, value) : tmp0_elvis_lhs;
    var tmp;
    if (tmp1_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlinx.serialization.internal.cast' call
      tmp = isInterface(tmp1_safe_receiver, SerializationStrategy) ? tmp1_safe_receiver : THROW_CCE();
    }
    return tmp;
  }
}
class BinaryFormat {}
class StringFormat {}
class SerializationException extends IllegalArgumentException {
  static a11() {
    var $this = this.re();
    init_kotlinx_serialization_SerializationException($this);
    return $this;
  }
  static y10(message) {
    var $this = this.h2(message);
    init_kotlinx_serialization_SerializationException($this);
    return $this;
  }
  static b11(message, cause) {
    var $this = this.se(message, cause);
    init_kotlinx_serialization_SerializationException($this);
    return $this;
  }
}
class UnknownFieldException extends SerializationException {
  constructor(message) {
    return new.target.t10(message);
  }
  static t10(message) {
    var $this = this.y10(message);
    captureStack($this, $this.s10_1);
    return $this;
  }
  static z10(index) {
    return this.t10('An unknown field for index ' + index);
  }
}
class MissingFieldException extends SerializationException {
  constructor(missingFields, message, cause) {
    return new.target.i11(missingFields, message, cause);
  }
  static i11(missingFields, message, cause) {
    var $this = this.b11(message, cause);
    captureStack($this, $this.h11_1);
    $this.g11_1 = missingFields;
    return $this;
  }
  static j11(missingFields, serialName) {
    return this.i11(missingFields, missingFields.s2() === 1 ? "Field '" + missingFields.u2(0) + "' is required for type with serial name '" + serialName + "', but it was missing" : 'Fields ' + toString(missingFields) + " are required for type with serial name '" + serialName + "', but they were missing", null);
  }
}
class SerialDescriptor {}
function get_isNullable() {
  return false;
}
function get_isInline() {
  return false;
}
function get_annotations() {
  return emptyList();
}
class ContextDescriptor {
  constructor(original, kClass) {
    this.t11_1 = original;
    this.u11_1 = kClass;
    this.v11_1 = this.t11_1.g10() + '<' + this.u11_1.j1() + '>';
  }
  g10() {
    return this.v11_1;
  }
  equals(other) {
    var tmp0_elvis_lhs = other instanceof ContextDescriptor ? other : null;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return false;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var another = tmp;
    return equals(this.t11_1, another.t11_1) && another.u11_1.equals(this.u11_1);
  }
  hashCode() {
    var result = this.u11_1.hashCode();
    result = imul(31, result) + getStringHashCode(this.v11_1) | 0;
    return result;
  }
  toString() {
    return 'ContextDescriptor(kClass: ' + toString(this.u11_1) + ', original: ' + toString(this.t11_1) + ')';
  }
  w11() {
    return this.t11_1.w11();
  }
  p11() {
    return this.t11_1.p11();
  }
  x11() {
    return this.t11_1.x11();
  }
  y11() {
    return this.t11_1.y11();
  }
  z11() {
    return this.t11_1.z11();
  }
  a12(index) {
    return this.t11_1.a12(index);
  }
  b12(name) {
    return this.t11_1.b12(name);
  }
  c12(index) {
    return this.t11_1.c12(index);
  }
  d12(index) {
    return this.t11_1.d12(index);
  }
  e12(index) {
    return this.t11_1.e12(index);
  }
}
class elementNames$1 {
  constructor($this_elementNames) {
    this.g12_1 = $this_elementNames;
    this.f12_1 = $this_elementNames.y11();
  }
  q1() {
    return this.f12_1 > 0;
  }
  r1() {
    var tmp = this.g12_1.y11();
    var _unary__edvuaz = this.f12_1;
    this.f12_1 = _unary__edvuaz - 1 | 0;
    return this.g12_1.a12(tmp - _unary__edvuaz | 0);
  }
}
class elementNames$$inlined$Iterable$1 {
  constructor($this_elementNames) {
    this.h12_1 = $this_elementNames;
  }
  p1() {
    return new elementNames$1(this.h12_1);
  }
}
class elementDescriptors$1 {
  constructor($this_elementDescriptors) {
    this.j12_1 = $this_elementDescriptors;
    this.i12_1 = $this_elementDescriptors.y11();
  }
  q1() {
    return this.i12_1 > 0;
  }
  r1() {
    var tmp = this.j12_1.y11();
    var _unary__edvuaz = this.i12_1;
    this.i12_1 = _unary__edvuaz - 1 | 0;
    return this.j12_1.d12(tmp - _unary__edvuaz | 0);
  }
}
class elementDescriptors$$inlined$Iterable$1 {
  constructor($this_elementDescriptors) {
    this.k12_1 = $this_elementDescriptors;
  }
  p1() {
    return new elementDescriptors$1(this.k12_1);
  }
}
class ClassSerialDescriptorBuilder {
  constructor(serialName) {
    this.gz_1 = serialName;
    this.hz_1 = false;
    this.iz_1 = emptyList();
    this.jz_1 = ArrayList.p2();
    this.kz_1 = HashSet.mb();
    this.lz_1 = ArrayList.p2();
    this.mz_1 = ArrayList.p2();
    this.nz_1 = ArrayList.p2();
  }
  l12(elementName, descriptor, annotations, isOptional) {
    // Inline function 'kotlin.require' call
    if (!this.kz_1.d2(elementName)) {
      var message = "Element with name '" + elementName + "' is already registered in " + this.gz_1;
      throw IllegalArgumentException.h2(toString(message));
    }
    // Inline function 'kotlin.collections.plusAssign' call
    this.jz_1.d2(elementName);
    // Inline function 'kotlin.collections.plusAssign' call
    this.lz_1.d2(descriptor);
    // Inline function 'kotlin.collections.plusAssign' call
    this.mz_1.d2(annotations);
    // Inline function 'kotlin.collections.plusAssign' call
    this.nz_1.d2(isOptional);
  }
  oz(elementName, descriptor, annotations, isOptional, $super) {
    annotations = annotations === VOID ? emptyList() : annotations;
    isOptional = isOptional === VOID ? false : isOptional;
    var tmp;
    if ($super === VOID) {
      this.l12(elementName, descriptor, annotations, isOptional);
      tmp = Unit_instance;
    } else {
      tmp = $super.l12.call(this, elementName, descriptor, annotations, isOptional);
    }
    return tmp;
  }
}
class CachedNames {}
class SerialDescriptorImpl {
  constructor(serialName, kind, elementsCount, typeParameters, builder) {
    this.m12_1 = serialName;
    this.n12_1 = kind;
    this.o12_1 = elementsCount;
    this.p12_1 = builder.iz_1;
    this.q12_1 = toHashSet(builder.jz_1);
    var tmp = this;
    // Inline function 'kotlin.collections.toTypedArray' call
    var this_0 = builder.jz_1;
    tmp.r12_1 = copyToArray(this_0);
    this.s12_1 = compactArray(builder.lz_1);
    var tmp_0 = this;
    // Inline function 'kotlin.collections.toTypedArray' call
    var this_1 = builder.mz_1;
    tmp_0.t12_1 = copyToArray(this_1);
    this.u12_1 = toBooleanArray(builder.nz_1);
    var tmp_1 = this;
    // Inline function 'kotlin.collections.map' call
    var this_2 = withIndex(this.r12_1);
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.n2(collectionSizeOrDefault(this_2, 10));
    var _iterator__ex2g4s = this_2.p1();
    while (_iterator__ex2g4s.q1()) {
      var item = _iterator__ex2g4s.r1();
      var tmp$ret$4 = to(item.im_1, item.hm_1);
      destination.d2(tmp$ret$4);
    }
    tmp_1.v12_1 = toMap(destination);
    this.w12_1 = compactArray(typeParameters);
    var tmp_2 = this;
    tmp_2.x12_1 = lazy_0(SerialDescriptorImpl$_hashCode$delegate$lambda(this));
  }
  g10() {
    return this.m12_1;
  }
  w11() {
    return this.n12_1;
  }
  y11() {
    return this.o12_1;
  }
  z11() {
    return this.p12_1;
  }
  y12() {
    return this.q12_1;
  }
  a12(index) {
    return getChecked(this.r12_1, index);
  }
  b12(name) {
    var tmp0_elvis_lhs = this.v12_1.w4(name);
    return tmp0_elvis_lhs == null ? -3 : tmp0_elvis_lhs;
  }
  c12(index) {
    return getChecked(this.t12_1, index);
  }
  d12(index) {
    return getChecked(this.s12_1, index);
  }
  e12(index) {
    return getChecked_0(this.u12_1, index);
  }
  equals(other) {
    var tmp$ret$0;
    $l$block_5: {
      // Inline function 'kotlinx.serialization.internal.equalsImpl' call
      if (this === other) {
        tmp$ret$0 = true;
        break $l$block_5;
      }
      if (!(other instanceof SerialDescriptorImpl)) {
        tmp$ret$0 = false;
        break $l$block_5;
      }
      if (!(this.g10() === other.g10())) {
        tmp$ret$0 = false;
        break $l$block_5;
      }
      if (!contentEquals(this.w12_1, other.w12_1)) {
        tmp$ret$0 = false;
        break $l$block_5;
      }
      if (!(this.y11() === other.y11())) {
        tmp$ret$0 = false;
        break $l$block_5;
      }
      var inductionVariable = 0;
      var last = this.y11();
      if (inductionVariable < last)
        do {
          var index = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          if (!(this.d12(index).g10() === other.d12(index).g10())) {
            tmp$ret$0 = false;
            break $l$block_5;
          }
          if (!equals(this.d12(index).w11(), other.d12(index).w11())) {
            tmp$ret$0 = false;
            break $l$block_5;
          }
        }
         while (inductionVariable < last);
      tmp$ret$0 = true;
    }
    return tmp$ret$0;
  }
  hashCode() {
    return _get__hashCode__tgwhef(this);
  }
  toString() {
    return toStringImpl(this);
  }
}
class SerialKind {
  toString() {
    return ensureNotNull(getKClassFromExpression(this).j1());
  }
  hashCode() {
    return getStringHashCode(this.toString());
  }
}
class PrimitiveKind extends SerialKind {}
class BOOLEAN extends PrimitiveKind {
  constructor() {
    BOOLEAN_instance = null;
    super();
    BOOLEAN_instance = this;
  }
}
class BYTE extends PrimitiveKind {
  constructor() {
    BYTE_instance = null;
    super();
    BYTE_instance = this;
  }
}
class CHAR extends PrimitiveKind {
  constructor() {
    CHAR_instance = null;
    super();
    CHAR_instance = this;
  }
}
class SHORT extends PrimitiveKind {
  constructor() {
    SHORT_instance = null;
    super();
    SHORT_instance = this;
  }
}
class INT extends PrimitiveKind {
  constructor() {
    INT_instance = null;
    super();
    INT_instance = this;
  }
}
class LONG extends PrimitiveKind {
  constructor() {
    LONG_instance = null;
    super();
    LONG_instance = this;
  }
}
class FLOAT extends PrimitiveKind {
  constructor() {
    FLOAT_instance = null;
    super();
    FLOAT_instance = this;
  }
}
class DOUBLE extends PrimitiveKind {
  constructor() {
    DOUBLE_instance = null;
    super();
    DOUBLE_instance = this;
  }
}
class STRING extends PrimitiveKind {
  constructor() {
    STRING_instance = null;
    super();
    STRING_instance = this;
  }
}
class PolymorphicKind extends SerialKind {}
class SEALED extends PolymorphicKind {
  constructor() {
    SEALED_instance = null;
    super();
    SEALED_instance = this;
  }
}
class OPEN extends PolymorphicKind {
  constructor() {
    OPEN_instance = null;
    super();
    OPEN_instance = this;
  }
}
class ENUM extends SerialKind {
  constructor() {
    ENUM_instance = null;
    super();
    ENUM_instance = this;
  }
}
class CONTEXTUAL extends SerialKind {
  constructor() {
    CONTEXTUAL_instance = null;
    super();
    CONTEXTUAL_instance = this;
  }
}
class StructureKind extends SerialKind {}
class CLASS extends StructureKind {
  constructor() {
    CLASS_instance = null;
    super();
    CLASS_instance = this;
  }
}
class LIST extends StructureKind {
  constructor() {
    LIST_instance = null;
    super();
    LIST_instance = this;
  }
}
class MAP extends StructureKind {
  constructor() {
    MAP_instance = null;
    super();
    MAP_instance = this;
  }
}
class OBJECT extends StructureKind {
  constructor() {
    OBJECT_instance = null;
    super();
    OBJECT_instance = this;
  }
}
class Decoder {}
function decodeSerializableValue(deserializer) {
  return deserializer.fz(this);
}
class CompositeDecoder {}
function decodeSequentially() {
  return false;
}
function decodeCollectionSize(descriptor) {
  return -1;
}
function decodeSerializableElement$default(descriptor, index, deserializer, previousValue, $super) {
  previousValue = previousValue === VOID ? null : previousValue;
  return $super === VOID ? this.b14(descriptor, index, deserializer, previousValue) : $super.b14.call(this, descriptor, index, deserializer, previousValue);
}
class AbstractDecoder {
  z12() {
    throw SerializationException.y10(toString(getKClassFromExpression(this)) + " can't retrieve untyped values");
  }
  a13() {
    return true;
  }
  b13() {
    return null;
  }
  c13() {
    var tmp = this.z12();
    return typeof tmp === 'boolean' ? tmp : THROW_CCE();
  }
  d13() {
    var tmp = this.z12();
    return typeof tmp === 'number' ? tmp : THROW_CCE();
  }
  e13() {
    var tmp = this.z12();
    return typeof tmp === 'number' ? tmp : THROW_CCE();
  }
  f13() {
    var tmp = this.z12();
    return typeof tmp === 'number' ? tmp : THROW_CCE();
  }
  g13() {
    var tmp = this.z12();
    return tmp instanceof Long ? tmp : THROW_CCE();
  }
  h13() {
    var tmp = this.z12();
    return typeof tmp === 'number' ? tmp : THROW_CCE();
  }
  i13() {
    var tmp = this.z12();
    return typeof tmp === 'number' ? tmp : THROW_CCE();
  }
  j13() {
    var tmp = this.z12();
    return tmp instanceof Char ? tmp.f4_1 : THROW_CCE();
  }
  k13() {
    var tmp = this.z12();
    return typeof tmp === 'string' ? tmp : THROW_CCE();
  }
  l13(enumDescriptor) {
    var tmp = this.z12();
    return typeof tmp === 'number' ? tmp : THROW_CCE();
  }
  m13(descriptor) {
    return this;
  }
  n13(deserializer, previousValue) {
    return this.o13(deserializer);
  }
  p13(descriptor) {
    return this;
  }
  q13(descriptor) {
  }
  r13(descriptor, index) {
    return this.c13();
  }
  s13(descriptor, index) {
    return this.d13();
  }
  t13(descriptor, index) {
    return this.e13();
  }
  u13(descriptor, index) {
    return this.f13();
  }
  v13(descriptor, index) {
    return this.g13();
  }
  w13(descriptor, index) {
    return this.h13();
  }
  x13(descriptor, index) {
    return this.i13();
  }
  y13(descriptor, index) {
    return this.j13();
  }
  z13(descriptor, index) {
    return this.k13();
  }
  a14(descriptor, index) {
    return this.m13(descriptor.d12(index));
  }
  b14(descriptor, index, deserializer, previousValue) {
    return this.n13(deserializer, previousValue);
  }
  d14(descriptor, index, deserializer, previousValue) {
    // Inline function 'kotlinx.serialization.encoding.decodeIfNullable' call
    var isNullabilitySupported = deserializer.dz().p11();
    var tmp;
    if (isNullabilitySupported || this.a13()) {
      tmp = this.n13(deserializer, previousValue);
    } else {
      tmp = this.b13();
    }
    return tmp;
  }
}
class Encoder {}
function encodeNotNullMark() {
}
function beginCollection(descriptor, collectionSize) {
  return this.p13(descriptor);
}
function encodeSerializableValue(serializer, value) {
  serializer.ez(this, value);
}
function encodeNullableSerializableValue(serializer, value) {
  var isNullabilitySupported = serializer.dz().p11();
  if (isNullabilitySupported) {
    return this.h15(isInterface(serializer, SerializationStrategy) ? serializer : THROW_CCE(), value);
  }
  if (value == null) {
    this.k14();
  } else {
    this.k15();
    this.h15(serializer, value);
  }
}
class CompositeEncoder {}
function shouldEncodeElementDefault(descriptor, index) {
  return true;
}
class AbstractEncoder {
  static h14() {
    return createThis(this);
  }
  p13(descriptor) {
    return this;
  }
  q13(descriptor) {
  }
  i14(descriptor, index) {
    return true;
  }
  j14(value) {
    throw SerializationException.y10('Non-serializable ' + toString(getKClassFromExpression(value)) + ' is not supported by ' + toString(getKClassFromExpression(this)) + ' encoder');
  }
  k14() {
    throw SerializationException.y10("'null' is not supported by default");
  }
  l14(value) {
    return this.j14(value);
  }
  m14(value) {
    return this.j14(value);
  }
  n14(value) {
    return this.j14(value);
  }
  o14(value) {
    return this.j14(value);
  }
  p14(value) {
    return this.j14(value);
  }
  q14(value) {
    return this.j14(value);
  }
  r14(value) {
    return this.j14(value);
  }
  s14(value) {
    return this.j14(new Char(value));
  }
  t14(value) {
    return this.j14(value);
  }
  u14(enumDescriptor, index) {
    return this.j14(index);
  }
  v14(descriptor) {
    return this;
  }
  w14(descriptor, index, value) {
    if (this.i14(descriptor, index)) {
      this.l14(value);
    }
  }
  x14(descriptor, index, value) {
    if (this.i14(descriptor, index)) {
      this.m14(value);
    }
  }
  y14(descriptor, index, value) {
    if (this.i14(descriptor, index)) {
      this.n14(value);
    }
  }
  z14(descriptor, index, value) {
    if (this.i14(descriptor, index)) {
      this.o14(value);
    }
  }
  a15(descriptor, index, value) {
    if (this.i14(descriptor, index)) {
      this.p14(value);
    }
  }
  b15(descriptor, index, value) {
    if (this.i14(descriptor, index)) {
      this.q14(value);
    }
  }
  c15(descriptor, index, value) {
    if (this.i14(descriptor, index)) {
      this.r14(value);
    }
  }
  d15(descriptor, index, value) {
    if (this.i14(descriptor, index)) {
      this.s14(value);
    }
  }
  e15(descriptor, index, value) {
    if (this.i14(descriptor, index)) {
      this.t14(value);
    }
  }
  f15(descriptor, index) {
    return this.i14(descriptor, index) ? this.v14(descriptor.d12(index)) : NoOpEncoder_getInstance();
  }
  g15(descriptor, index, serializer, value) {
    if (this.i14(descriptor, index)) {
      this.h15(serializer, value);
    }
  }
  i15(descriptor, index, serializer, value) {
    if (this.i14(descriptor, index)) {
      this.j15(serializer, value);
    }
  }
}
class NothingSerializer {
  constructor() {
    NothingSerializer_instance = this;
    this.p15_1 = NothingSerialDescriptor_getInstance();
  }
  dz() {
    return this.p15_1;
  }
  q15(encoder, value) {
    throw SerializationException.y10("'kotlin.Nothing' cannot be serialized");
  }
  ez(encoder, value) {
    var tmp;
    if (false) {
      tmp = value;
    } else {
      tmp = THROW_CCE();
    }
    return this.q15(encoder, tmp);
  }
  fz(decoder) {
    throw SerializationException.y10("'kotlin.Nothing' does not have instances");
  }
}
class DurationSerializer {
  constructor() {
    DurationSerializer_instance = this;
    this.r15_1 = new PrimitiveSerialDescriptor('kotlin.time.Duration', STRING_getInstance());
  }
  dz() {
    return this.r15_1;
  }
  s15(encoder, value) {
    encoder.t14(Duration__toIsoString_impl_9h6wsm(value));
  }
  ez(encoder, value) {
    return this.s15(encoder, value instanceof Duration ? value.ik_1 : THROW_CCE());
  }
  t15(decoder) {
    return Companion_getInstance().zu(decoder.k13());
  }
  fz(decoder) {
    return new Duration(this.t15(decoder));
  }
}
class InstantSerializer {
  constructor() {
    InstantSerializer_instance = this;
    this.u15_1 = new PrimitiveSerialDescriptor('kotlin.time.Instant', STRING_getInstance());
  }
  dz() {
    return this.u15_1;
  }
  v15(encoder, value) {
    encoder.t14(value.toString());
  }
  ez(encoder, value) {
    return this.v15(encoder, value instanceof Instant ? value : THROW_CCE());
  }
  fz(decoder) {
    return Companion_getInstance_0().kv(decoder.k13());
  }
}
class UuidSerializer {
  constructor() {
    UuidSerializer_instance = this;
    this.w15_1 = new PrimitiveSerialDescriptor('kotlin.uuid.Uuid', STRING_getInstance());
  }
  dz() {
    return this.w15_1;
  }
  x15(encoder, value) {
    encoder.t14(value.toString());
  }
  ez(encoder, value) {
    return this.x15(encoder, value instanceof Uuid ? value : THROW_CCE());
  }
  fz(decoder) {
    return Companion_getInstance_1().gx(decoder.k13());
  }
}
class ListLikeDescriptor {
  constructor(elementDescriptor) {
    this.a16_1 = elementDescriptor;
    this.b16_1 = 1;
  }
  w11() {
    return LIST_getInstance();
  }
  y11() {
    return this.b16_1;
  }
  a12(index) {
    return index.toString();
  }
  b12(name) {
    var tmp0_elvis_lhs = toIntOrNull(name);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      throw IllegalArgumentException.h2(name + ' is not a valid list index');
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  e12(index) {
    // Inline function 'kotlin.require' call
    if (!(index >= 0)) {
      var message = 'Illegal index ' + index + ', ' + this.g10() + ' expects only non-negative indices';
      throw IllegalArgumentException.h2(toString(message));
    }
    return false;
  }
  c12(index) {
    // Inline function 'kotlin.require' call
    if (!(index >= 0)) {
      var message = 'Illegal index ' + index + ', ' + this.g10() + ' expects only non-negative indices';
      throw IllegalArgumentException.h2(toString(message));
    }
    return emptyList();
  }
  d12(index) {
    // Inline function 'kotlin.require' call
    if (!(index >= 0)) {
      var message = 'Illegal index ' + index + ', ' + this.g10() + ' expects only non-negative indices';
      throw IllegalArgumentException.h2(toString(message));
    }
    return this.a16_1;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ListLikeDescriptor))
      return false;
    if (equals(this.a16_1, other.a16_1) && this.g10() === other.g10())
      return true;
    return false;
  }
  hashCode() {
    return imul(hashCode(this.a16_1), 31) + getStringHashCode(this.g10()) | 0;
  }
  toString() {
    return this.g10() + '(' + toString(this.a16_1) + ')';
  }
}
class ArrayListClassDesc extends ListLikeDescriptor {
  g10() {
    return 'kotlin.collections.ArrayList';
  }
}
class LinkedHashSetClassDesc extends ListLikeDescriptor {
  g10() {
    return 'kotlin.collections.LinkedHashSet';
  }
}
class MapLikeDescriptor {
  constructor(serialName, keyDescriptor, valueDescriptor) {
    this.e16_1 = serialName;
    this.f16_1 = keyDescriptor;
    this.g16_1 = valueDescriptor;
    this.h16_1 = 2;
  }
  g10() {
    return this.e16_1;
  }
  w11() {
    return MAP_getInstance();
  }
  y11() {
    return this.h16_1;
  }
  a12(index) {
    return index.toString();
  }
  b12(name) {
    var tmp0_elvis_lhs = toIntOrNull(name);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      throw IllegalArgumentException.h2(name + ' is not a valid map index');
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  e12(index) {
    // Inline function 'kotlin.require' call
    if (!(index >= 0)) {
      var message = 'Illegal index ' + index + ', ' + this.g10() + ' expects only non-negative indices';
      throw IllegalArgumentException.h2(toString(message));
    }
    return false;
  }
  c12(index) {
    // Inline function 'kotlin.require' call
    if (!(index >= 0)) {
      var message = 'Illegal index ' + index + ', ' + this.g10() + ' expects only non-negative indices';
      throw IllegalArgumentException.h2(toString(message));
    }
    return emptyList();
  }
  d12(index) {
    // Inline function 'kotlin.require' call
    if (!(index >= 0)) {
      var message = 'Illegal index ' + index + ', ' + this.g10() + ' expects only non-negative indices';
      throw IllegalArgumentException.h2(toString(message));
    }
    var tmp;
    switch (index % 2 | 0) {
      case 0:
        tmp = this.f16_1;
        break;
      case 1:
        tmp = this.g16_1;
        break;
      default:
        // Inline function 'kotlin.error' call

        var message_0 = 'Unreached';
        throw IllegalStateException.o(toString(message_0));
    }
    return tmp;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof MapLikeDescriptor))
      return false;
    if (!(this.g10() === other.g10()))
      return false;
    if (!equals(this.f16_1, other.f16_1))
      return false;
    if (!equals(this.g16_1, other.g16_1))
      return false;
    return true;
  }
  hashCode() {
    var result = getStringHashCode(this.g10());
    result = imul(31, result) + hashCode(this.f16_1) | 0;
    result = imul(31, result) + hashCode(this.g16_1) | 0;
    return result;
  }
  toString() {
    return this.g10() + '(' + toString(this.f16_1) + ', ' + toString(this.g16_1) + ')';
  }
}
class LinkedHashMapClassDesc extends MapLikeDescriptor {
  constructor(keyDesc, valueDesc) {
    super('kotlin.collections.LinkedHashMap', keyDesc, valueDesc);
  }
}
class HashSetClassDesc extends ListLikeDescriptor {
  g10() {
    return 'kotlin.collections.HashSet';
  }
}
class HashMapClassDesc extends MapLikeDescriptor {
  constructor(keyDesc, valueDesc) {
    super('kotlin.collections.HashMap', keyDesc, valueDesc);
  }
}
class ArrayClassDesc extends ListLikeDescriptor {
  g10() {
    return 'kotlin.Array';
  }
}
class PrimitiveArrayDescriptor extends ListLikeDescriptor {
  constructor(primitive) {
    super(primitive);
    this.o16_1 = primitive.g10() + 'Array';
  }
  g10() {
    return this.o16_1;
  }
}
class AbstractCollectionSerializer {
  k17(decoder, previous) {
    var tmp1_elvis_lhs = previous == null ? null : this.x16(previous);
    var builder = tmp1_elvis_lhs == null ? this.r16() : tmp1_elvis_lhs;
    var startIndex = this.t16(builder);
    var compositeDecoder = decoder.p13(this.dz());
    if (compositeDecoder.e14()) {
      this.h17(compositeDecoder, builder, startIndex, readSize(this, compositeDecoder, builder));
    } else {
      $l$loop: while (true) {
        var index = compositeDecoder.f14(this.dz());
        if (index === -1)
          break $l$loop;
        this.j17(compositeDecoder, startIndex + index | 0, builder);
      }
    }
    compositeDecoder.q13(this.dz());
    return this.v16(builder);
  }
  fz(decoder) {
    return this.k17(decoder, null);
  }
  j17(decoder, index, builder, checkIndex, $super) {
    checkIndex = checkIndex === VOID ? true : checkIndex;
    var tmp;
    if ($super === VOID) {
      this.i17(decoder, index, builder, checkIndex);
      tmp = Unit_instance;
    } else {
      tmp = $super.i17.call(this, decoder, index, builder, checkIndex);
    }
    return tmp;
  }
}
class CollectionLikeSerializer extends AbstractCollectionSerializer {
  constructor(elementSerializer) {
    super();
    this.f17_1 = elementSerializer;
  }
  g17(encoder, value) {
    var size = this.w17(value);
    // Inline function 'kotlinx.serialization.encoding.encodeCollection' call
    var descriptor = this.dz();
    var composite = encoder.l15(descriptor, size);
    var iterator = this.y17(value);
    var inductionVariable = 0;
    if (inductionVariable < size)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        composite.g15(this.dz(), index, this.f17_1, iterator.r1());
      }
       while (inductionVariable < size);
    composite.q13(descriptor);
  }
  ez(encoder, value) {
    return this.g17(encoder, value);
  }
  h17(decoder, builder, startIndex, size) {
    // Inline function 'kotlin.require' call
    if (!(size >= 0)) {
      var message = 'Size must be known in advance when using READ_ALL';
      throw IllegalArgumentException.h2(toString(message));
    }
    var inductionVariable = 0;
    if (inductionVariable < size)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this.i17(decoder, startIndex + index | 0, builder, false);
      }
       while (inductionVariable < size);
  }
  i17(decoder, index, builder, checkIndex) {
    this.b17(builder, index, decoder.c14(this.dz(), index, this.f17_1));
  }
}
class CollectionSerializer extends CollectionLikeSerializer {
  d17(_this__u8e3s4) {
    return _this__u8e3s4.s2();
  }
  w17(_this__u8e3s4) {
    return this.d17((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, Collection) : false) ? _this__u8e3s4 : THROW_CCE());
  }
  e17(_this__u8e3s4) {
    return _this__u8e3s4.p1();
  }
  y17(_this__u8e3s4) {
    return this.e17((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, Collection) : false) ? _this__u8e3s4 : THROW_CCE());
  }
}
class ArrayListSerializer extends CollectionSerializer {
  constructor(element) {
    super(element);
    this.q16_1 = new ArrayListClassDesc(element.dz());
  }
  dz() {
    return this.q16_1;
  }
  r16() {
    // Inline function 'kotlin.collections.arrayListOf' call
    return ArrayList.p2();
  }
  s16(_this__u8e3s4) {
    return _this__u8e3s4.s2();
  }
  t16(_this__u8e3s4) {
    return this.s16(_this__u8e3s4 instanceof ArrayList ? _this__u8e3s4 : THROW_CCE());
  }
  u16(_this__u8e3s4) {
    return _this__u8e3s4;
  }
  v16(_this__u8e3s4) {
    return this.u16(_this__u8e3s4 instanceof ArrayList ? _this__u8e3s4 : THROW_CCE());
  }
  w16(_this__u8e3s4) {
    var tmp0_elvis_lhs = _this__u8e3s4 instanceof ArrayList ? _this__u8e3s4 : null;
    return tmp0_elvis_lhs == null ? ArrayList.r2(_this__u8e3s4) : tmp0_elvis_lhs;
  }
  x16(_this__u8e3s4) {
    return this.w16((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, KtList) : false) ? _this__u8e3s4 : THROW_CCE());
  }
  y16(_this__u8e3s4, size) {
    return _this__u8e3s4.i9(size);
  }
  z16(_this__u8e3s4, size) {
    return this.y16(_this__u8e3s4 instanceof ArrayList ? _this__u8e3s4 : THROW_CCE(), size);
  }
  a17(_this__u8e3s4, index, element) {
    _this__u8e3s4.f5(index, element);
  }
  b17(_this__u8e3s4, index, element) {
    return this.a17(_this__u8e3s4 instanceof ArrayList ? _this__u8e3s4 : THROW_CCE(), index, element);
  }
}
class LinkedHashSetSerializer extends CollectionSerializer {
  constructor(eSerializer) {
    super(eSerializer);
    this.m17_1 = new LinkedHashSetClassDesc(eSerializer.dz());
  }
  dz() {
    return this.m17_1;
  }
  r16() {
    // Inline function 'kotlin.collections.linkedSetOf' call
    return LinkedHashSet.v2();
  }
  n17(_this__u8e3s4) {
    return _this__u8e3s4.s2();
  }
  t16(_this__u8e3s4) {
    return this.n17(_this__u8e3s4 instanceof LinkedHashSet ? _this__u8e3s4 : THROW_CCE());
  }
  o17(_this__u8e3s4) {
    return _this__u8e3s4;
  }
  v16(_this__u8e3s4) {
    return this.o17(_this__u8e3s4 instanceof LinkedHashSet ? _this__u8e3s4 : THROW_CCE());
  }
  p17(_this__u8e3s4) {
    var tmp0_elvis_lhs = _this__u8e3s4 instanceof LinkedHashSet ? _this__u8e3s4 : null;
    return tmp0_elvis_lhs == null ? LinkedHashSet.z2(_this__u8e3s4) : tmp0_elvis_lhs;
  }
  x16(_this__u8e3s4) {
    return this.p17((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, KtSet) : false) ? _this__u8e3s4 : THROW_CCE());
  }
  q17(_this__u8e3s4, size) {
  }
  z16(_this__u8e3s4, size) {
    return this.q17(_this__u8e3s4 instanceof LinkedHashSet ? _this__u8e3s4 : THROW_CCE(), size);
  }
  r17(_this__u8e3s4, index, element) {
    _this__u8e3s4.d2(element);
  }
  b17(_this__u8e3s4, index, element) {
    return this.r17(_this__u8e3s4 instanceof LinkedHashSet ? _this__u8e3s4 : THROW_CCE(), index, element);
  }
}
class MapLikeSerializer extends AbstractCollectionSerializer {
  constructor(keySerializer, valueSerializer) {
    super();
    this.d18_1 = keySerializer;
    this.e18_1 = valueSerializer;
  }
  f18(decoder, builder, startIndex, size) {
    // Inline function 'kotlin.require' call
    if (!(size >= 0)) {
      var message = 'Size must be known in advance when using READ_ALL';
      throw IllegalArgumentException.h2(toString(message));
    }
    var progression = step(until(0, imul(size, 2)), 2);
    var inductionVariable = progression.n3_1;
    var last = progression.o3_1;
    var step_0 = progression.p3_1;
    if (step_0 > 0 && inductionVariable <= last || (step_0 < 0 && last <= inductionVariable))
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + step_0 | 0;
        this.g18(decoder, startIndex + index | 0, builder, false);
      }
       while (!(index === last));
  }
  h17(decoder, builder, startIndex, size) {
    return this.f18(decoder, (!(builder == null) ? isInterface(builder, KtMutableMap) : false) ? builder : THROW_CCE(), startIndex, size);
  }
  g18(decoder, index, builder, checkIndex) {
    var key = decoder.c14(this.dz(), index, this.d18_1);
    var tmp;
    if (checkIndex) {
      // Inline function 'kotlin.also' call
      var this_0 = decoder.f14(this.dz());
      // Inline function 'kotlin.require' call
      if (!(this_0 === (index + 1 | 0))) {
        var message = 'Value must follow key in a map, index for key: ' + index + ', returned index for value: ' + this_0;
        throw IllegalArgumentException.h2(toString(message));
      }
      tmp = this_0;
    } else {
      tmp = index + 1 | 0;
    }
    var vIndex = tmp;
    var tmp_0;
    var tmp_1;
    if (builder.u4(key)) {
      var tmp_2 = this.e18_1.dz().w11();
      tmp_1 = !(tmp_2 instanceof PrimitiveKind);
    } else {
      tmp_1 = false;
    }
    if (tmp_1) {
      tmp_0 = decoder.b14(this.dz(), vIndex, this.e18_1, getValue(builder, key));
    } else {
      tmp_0 = decoder.c14(this.dz(), vIndex, this.e18_1);
    }
    var value = tmp_0;
    // Inline function 'kotlin.collections.set' call
    builder.b5(key, value);
  }
  i17(decoder, index, builder, checkIndex) {
    return this.g18(decoder, index, (!(builder == null) ? isInterface(builder, KtMutableMap) : false) ? builder : THROW_CCE(), checkIndex);
  }
  g17(encoder, value) {
    var size = this.w17(value);
    // Inline function 'kotlinx.serialization.encoding.encodeCollection' call
    var descriptor = this.dz();
    var composite = encoder.l15(descriptor, size);
    var iterator = this.y17(value);
    var index = 0;
    // Inline function 'kotlin.collections.forEach' call
    // Inline function 'kotlin.collections.iterator' call
    var _iterator__ex2g4s = iterator;
    while (_iterator__ex2g4s.q1()) {
      var element = _iterator__ex2g4s.r1();
      // Inline function 'kotlin.collections.component1' call
      var k = element.j3();
      // Inline function 'kotlin.collections.component2' call
      var v = element.k3();
      var tmp = this.dz();
      var _unary__edvuaz = index;
      index = _unary__edvuaz + 1 | 0;
      composite.g15(tmp, _unary__edvuaz, this.d18_1, k);
      var tmp_0 = this.dz();
      var _unary__edvuaz_0 = index;
      index = _unary__edvuaz_0 + 1 | 0;
      composite.g15(tmp_0, _unary__edvuaz_0, this.e18_1, v);
    }
    composite.q13(descriptor);
  }
  ez(encoder, value) {
    return this.g17(encoder, value);
  }
}
class LinkedHashMapSerializer extends MapLikeSerializer {
  constructor(kSerializer, vSerializer) {
    super(kSerializer, vSerializer);
    this.u17_1 = new LinkedHashMapClassDesc(kSerializer.dz(), vSerializer.dz());
  }
  dz() {
    return this.u17_1;
  }
  v17(_this__u8e3s4) {
    return _this__u8e3s4.s2();
  }
  w17(_this__u8e3s4) {
    return this.v17((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, KtMap) : false) ? _this__u8e3s4 : THROW_CCE());
  }
  x17(_this__u8e3s4) {
    // Inline function 'kotlin.collections.iterator' call
    return _this__u8e3s4.i3().p1();
  }
  y17(_this__u8e3s4) {
    return this.x17((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, KtMap) : false) ? _this__u8e3s4 : THROW_CCE());
  }
  r16() {
    return LinkedHashMap.m7();
  }
  z17(_this__u8e3s4) {
    return imul(_this__u8e3s4.s2(), 2);
  }
  t16(_this__u8e3s4) {
    return this.z17(_this__u8e3s4 instanceof LinkedHashMap ? _this__u8e3s4 : THROW_CCE());
  }
  a18(_this__u8e3s4) {
    return _this__u8e3s4;
  }
  v16(_this__u8e3s4) {
    return this.a18(_this__u8e3s4 instanceof LinkedHashMap ? _this__u8e3s4 : THROW_CCE());
  }
  b18(_this__u8e3s4) {
    var tmp0_elvis_lhs = _this__u8e3s4 instanceof LinkedHashMap ? _this__u8e3s4 : null;
    return tmp0_elvis_lhs == null ? LinkedHashMap.dd(_this__u8e3s4) : tmp0_elvis_lhs;
  }
  x16(_this__u8e3s4) {
    return this.b18((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, KtMap) : false) ? _this__u8e3s4 : THROW_CCE());
  }
  c18(_this__u8e3s4, size) {
  }
  z16(_this__u8e3s4, size) {
    return this.c18(_this__u8e3s4 instanceof LinkedHashMap ? _this__u8e3s4 : THROW_CCE(), size);
  }
}
class HashSetSerializer extends CollectionSerializer {
  constructor(eSerializer) {
    super(eSerializer);
    this.i18_1 = new HashSetClassDesc(eSerializer.dz());
  }
  dz() {
    return this.i18_1;
  }
  r16() {
    return HashSet.mb();
  }
  j18(_this__u8e3s4) {
    return _this__u8e3s4.s2();
  }
  t16(_this__u8e3s4) {
    return this.j18(_this__u8e3s4 instanceof HashSet ? _this__u8e3s4 : THROW_CCE());
  }
  k18(_this__u8e3s4) {
    return _this__u8e3s4;
  }
  v16(_this__u8e3s4) {
    return this.k18(_this__u8e3s4 instanceof HashSet ? _this__u8e3s4 : THROW_CCE());
  }
  p17(_this__u8e3s4) {
    var tmp0_elvis_lhs = _this__u8e3s4 instanceof HashSet ? _this__u8e3s4 : null;
    return tmp0_elvis_lhs == null ? HashSet.nb(_this__u8e3s4) : tmp0_elvis_lhs;
  }
  x16(_this__u8e3s4) {
    return this.p17((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, KtSet) : false) ? _this__u8e3s4 : THROW_CCE());
  }
  l18(_this__u8e3s4, size) {
  }
  z16(_this__u8e3s4, size) {
    return this.l18(_this__u8e3s4 instanceof HashSet ? _this__u8e3s4 : THROW_CCE(), size);
  }
  m18(_this__u8e3s4, index, element) {
    _this__u8e3s4.d2(element);
  }
  b17(_this__u8e3s4, index, element) {
    return this.m18(_this__u8e3s4 instanceof HashSet ? _this__u8e3s4 : THROW_CCE(), index, element);
  }
}
class HashMapSerializer extends MapLikeSerializer {
  constructor(kSerializer, vSerializer) {
    super(kSerializer, vSerializer);
    this.p18_1 = new HashMapClassDesc(kSerializer.dz(), vSerializer.dz());
  }
  dz() {
    return this.p18_1;
  }
  v17(_this__u8e3s4) {
    return _this__u8e3s4.s2();
  }
  w17(_this__u8e3s4) {
    return this.v17((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, KtMap) : false) ? _this__u8e3s4 : THROW_CCE());
  }
  x17(_this__u8e3s4) {
    // Inline function 'kotlin.collections.iterator' call
    return _this__u8e3s4.i3().p1();
  }
  y17(_this__u8e3s4) {
    return this.x17((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, KtMap) : false) ? _this__u8e3s4 : THROW_CCE());
  }
  r16() {
    return HashMap.s9();
  }
  q18(_this__u8e3s4) {
    return imul(_this__u8e3s4.s2(), 2);
  }
  t16(_this__u8e3s4) {
    return this.q18(_this__u8e3s4 instanceof HashMap ? _this__u8e3s4 : THROW_CCE());
  }
  r18(_this__u8e3s4) {
    return _this__u8e3s4;
  }
  v16(_this__u8e3s4) {
    return this.r18(_this__u8e3s4 instanceof HashMap ? _this__u8e3s4 : THROW_CCE());
  }
  b18(_this__u8e3s4) {
    var tmp0_elvis_lhs = _this__u8e3s4 instanceof HashMap ? _this__u8e3s4 : null;
    return tmp0_elvis_lhs == null ? HashMap.ha(_this__u8e3s4) : tmp0_elvis_lhs;
  }
  x16(_this__u8e3s4) {
    return this.b18((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, KtMap) : false) ? _this__u8e3s4 : THROW_CCE());
  }
  s18(_this__u8e3s4, size) {
  }
  z16(_this__u8e3s4, size) {
    return this.s18(_this__u8e3s4 instanceof HashMap ? _this__u8e3s4 : THROW_CCE(), size);
  }
}
class ReferenceArraySerializer extends CollectionLikeSerializer {
  constructor(kClass, eSerializer) {
    super(eSerializer);
    this.u18_1 = kClass;
    this.v18_1 = new ArrayClassDesc(eSerializer.dz());
  }
  dz() {
    return this.v18_1;
  }
  w18(_this__u8e3s4) {
    return _this__u8e3s4.length;
  }
  w17(_this__u8e3s4) {
    return this.w18((!(_this__u8e3s4 == null) ? isArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
  }
  x18(_this__u8e3s4) {
    return arrayIterator(_this__u8e3s4);
  }
  y17(_this__u8e3s4) {
    return this.x18((!(_this__u8e3s4 == null) ? isArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
  }
  r16() {
    // Inline function 'kotlin.collections.arrayListOf' call
    return ArrayList.p2();
  }
  y18(_this__u8e3s4) {
    return _this__u8e3s4.s2();
  }
  t16(_this__u8e3s4) {
    return this.y18(_this__u8e3s4 instanceof ArrayList ? _this__u8e3s4 : THROW_CCE());
  }
  z18(_this__u8e3s4) {
    return toNativeArrayImpl(_this__u8e3s4, this.u18_1);
  }
  v16(_this__u8e3s4) {
    return this.z18(_this__u8e3s4 instanceof ArrayList ? _this__u8e3s4 : THROW_CCE());
  }
  a19(_this__u8e3s4) {
    return ArrayList.r2(asList(_this__u8e3s4));
  }
  x16(_this__u8e3s4) {
    return this.a19((!(_this__u8e3s4 == null) ? isArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
  }
  b19(_this__u8e3s4, size) {
    return _this__u8e3s4.i9(size);
  }
  z16(_this__u8e3s4, size) {
    return this.b19(_this__u8e3s4 instanceof ArrayList ? _this__u8e3s4 : THROW_CCE(), size);
  }
  c19(_this__u8e3s4, index, element) {
    _this__u8e3s4.f5(index, element);
  }
  b17(_this__u8e3s4, index, element) {
    return this.c19(_this__u8e3s4 instanceof ArrayList ? _this__u8e3s4 : THROW_CCE(), index, element);
  }
}
class PrimitiveArraySerializer extends CollectionLikeSerializer {
  constructor(primitiveSerializer) {
    super(primitiveSerializer);
    this.e19_1 = new PrimitiveArrayDescriptor(primitiveSerializer.dz());
  }
  dz() {
    return this.e19_1;
  }
  f19(_this__u8e3s4) {
    return _this__u8e3s4.g19();
  }
  t16(_this__u8e3s4) {
    return this.f19(_this__u8e3s4 instanceof PrimitiveArrayBuilder ? _this__u8e3s4 : THROW_CCE());
  }
  h19(_this__u8e3s4) {
    return _this__u8e3s4.i19();
  }
  v16(_this__u8e3s4) {
    return this.h19(_this__u8e3s4 instanceof PrimitiveArrayBuilder ? _this__u8e3s4 : THROW_CCE());
  }
  j19(_this__u8e3s4, size) {
    return _this__u8e3s4.k19(size);
  }
  z16(_this__u8e3s4, size) {
    return this.j19(_this__u8e3s4 instanceof PrimitiveArrayBuilder ? _this__u8e3s4 : THROW_CCE(), size);
  }
  l19(_this__u8e3s4) {
    // Inline function 'kotlin.error' call
    var message = 'This method lead to boxing and must not be used, use writeContents instead';
    throw IllegalStateException.o(toString(message));
  }
  y17(_this__u8e3s4) {
    return this.l19(_this__u8e3s4);
  }
  m19(_this__u8e3s4, index, element) {
    // Inline function 'kotlin.error' call
    var message = 'This method lead to boxing and must not be used, use Builder.append instead';
    throw IllegalStateException.o(toString(message));
  }
  b17(_this__u8e3s4, index, element) {
    return this.m19(_this__u8e3s4 instanceof PrimitiveArrayBuilder ? _this__u8e3s4 : THROW_CCE(), index, element);
  }
  r16() {
    return this.x16(this.n19());
  }
  q19(encoder, value) {
    var size = this.w17(value);
    // Inline function 'kotlinx.serialization.encoding.encodeCollection' call
    var descriptor = this.e19_1;
    var composite = encoder.l15(descriptor, size);
    this.p19(composite, value, size);
    composite.q13(descriptor);
  }
  ez(encoder, value) {
    return this.q19(encoder, value);
  }
  g17(encoder, value) {
    return this.q19(encoder, value);
  }
  fz(decoder) {
    return this.k17(decoder, null);
  }
}
class PrimitiveArrayBuilder {
  r19(requiredCapacity, $super) {
    requiredCapacity = requiredCapacity === VOID ? this.g19() + 1 | 0 : requiredCapacity;
    var tmp;
    if ($super === VOID) {
      this.k19(requiredCapacity);
      tmp = Unit_instance;
    } else {
      tmp = $super.k19.call(this, requiredCapacity);
    }
    return tmp;
  }
}
class Companion {
  constructor() {
    Companion_instance_0 = this;
    this.s19_1 = longArray(0);
  }
}
class ElementMarker {
  constructor(descriptor, readIfAbsent) {
    Companion_getInstance_8();
    this.t19_1 = descriptor;
    this.u19_1 = readIfAbsent;
    var elementsCount = this.t19_1.y11();
    if (elementsCount <= 64) {
      var tmp = this;
      var tmp_0;
      if (elementsCount === 64) {
        tmp_0 = new Long(0, 0);
      } else {
        tmp_0 = shiftLeft(new Long(-1, -1), elementsCount);
      }
      tmp.v19_1 = tmp_0;
      this.w19_1 = Companion_getInstance_8().s19_1;
    } else {
      this.v19_1 = new Long(0, 0);
      this.w19_1 = prepareHighMarksArray(this, elementsCount);
    }
  }
  x19(index) {
    if (index < 64) {
      this.v19_1 = bitwiseOr(this.v19_1, shiftLeft(new Long(1, 0), index));
    } else {
      markHigh(this, index);
    }
  }
  y19() {
    var elementsCount = this.t19_1.y11();
    while (!equalsLong(this.v19_1, new Long(-1, -1))) {
      var index = countTrailingZeroBits(invert(this.v19_1));
      this.v19_1 = bitwiseOr(this.v19_1, shiftLeft(new Long(1, 0), index));
      if (this.u19_1(this.t19_1, index)) {
        return index;
      }
    }
    if (elementsCount > 64) {
      return nextUnmarkedHighIndex(this);
    }
    return -1;
  }
}
class EnumSerializer {
  constructor(serialName, values) {
    return new.target.c1a(serialName, values);
  }
  static c1a(serialName, values) {
    var $this = createThis(this);
    $this.z19_1 = values;
    $this.a1a_1 = null;
    var tmp = $this;
    tmp.b1a_1 = lazy_0(EnumSerializer$descriptor$delegate$lambda($this, serialName));
    return $this;
  }
  static q1a(serialName, values, descriptor) {
    var $this = this.c1a(serialName, values);
    $this.a1a_1 = descriptor;
    return $this;
  }
  dz() {
    var tmp0 = this.b1a_1;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('descriptor', 1, tmp, EnumSerializer$_get_descriptor_$ref_j67dlw(), null);
    return tmp0.k3();
  }
  r1a(encoder, value) {
    var index = indexOf(this.z19_1, value);
    if (index === -1) {
      throw SerializationException.y10(toString(value) + ' is not a valid enum ' + this.dz().g10() + ', ' + ('must be one of ' + contentToString(this.z19_1)));
    }
    encoder.u14(this.dz(), index);
  }
  ez(encoder, value) {
    return this.r1a(encoder, value instanceof Enum ? value : THROW_CCE());
  }
  fz(decoder) {
    var index = decoder.l13(this.dz());
    if (!(0 <= index ? index <= (this.z19_1.length - 1 | 0) : false)) {
      throw SerializationException.y10('' + index + ' is not among valid ' + this.dz().g10() + ' enum values, ' + ('values size is ' + this.z19_1.length));
    }
    return this.z19_1[index];
  }
  toString() {
    return 'kotlinx.serialization.internal.EnumSerializer<' + this.dz().g10() + '>';
  }
}
class PluginGeneratedSerialDescriptor {
  constructor(serialName, generatedSerializer, elementsCount) {
    generatedSerializer = generatedSerializer === VOID ? null : generatedSerializer;
    this.d1a_1 = serialName;
    this.e1a_1 = generatedSerializer;
    this.f1a_1 = elementsCount;
    this.g1a_1 = -1;
    var tmp = this;
    var tmp_0 = 0;
    var tmp_1 = this.f1a_1;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_2 = Array(tmp_1);
    while (tmp_0 < tmp_1) {
      tmp_2[tmp_0] = '[UNINITIALIZED]';
      tmp_0 = tmp_0 + 1 | 0;
    }
    tmp.h1a_1 = tmp_2;
    var tmp_3 = this;
    // Inline function 'kotlin.arrayOfNulls' call
    var size = this.f1a_1;
    tmp_3.i1a_1 = Array(size);
    this.j1a_1 = null;
    this.k1a_1 = booleanArray(this.f1a_1);
    this.l1a_1 = emptyMap();
    var tmp_4 = this;
    var tmp_5 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp_4.m1a_1 = lazy(tmp_5, PluginGeneratedSerialDescriptor$childSerializers$delegate$lambda(this));
    var tmp_6 = this;
    var tmp_7 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp_6.n1a_1 = lazy(tmp_7, PluginGeneratedSerialDescriptor$typeParameterDescriptors$delegate$lambda(this));
    var tmp_8 = this;
    var tmp_9 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp_8.o1a_1 = lazy(tmp_9, PluginGeneratedSerialDescriptor$_hashCode$delegate$lambda(this));
  }
  g10() {
    return this.d1a_1;
  }
  y11() {
    return this.f1a_1;
  }
  w11() {
    return CLASS_getInstance();
  }
  z11() {
    var tmp0_elvis_lhs = this.j1a_1;
    return tmp0_elvis_lhs == null ? emptyList() : tmp0_elvis_lhs;
  }
  y12() {
    return this.l1a_1.x4();
  }
  g1b() {
    var tmp0 = this.n1a_1;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('typeParameterDescriptors', 1, tmp, PluginGeneratedSerialDescriptor$_get_typeParameterDescriptors_$ref_jk3pka(), null);
    return tmp0.k3();
  }
  h1b(name, isOptional) {
    this.g1a_1 = this.g1a_1 + 1 | 0;
    this.h1a_1[this.g1a_1] = name;
    this.k1a_1[this.g1a_1] = isOptional;
    this.i1a_1[this.g1a_1] = null;
    if (this.g1a_1 === (this.f1a_1 - 1 | 0)) {
      this.l1a_1 = buildIndices(this);
    }
  }
  p1a(name, isOptional, $super) {
    isOptional = isOptional === VOID ? false : isOptional;
    var tmp;
    if ($super === VOID) {
      this.h1b(name, isOptional);
      tmp = Unit_instance;
    } else {
      tmp = $super.h1b.call(this, name, isOptional);
    }
    return tmp;
  }
  i1b(annotation) {
    // Inline function 'kotlin.let' call
    var it = this.i1a_1[this.g1a_1];
    var tmp;
    if (it == null) {
      var result = ArrayList.n2(1);
      this.i1a_1[this.g1a_1] = result;
      tmp = result;
    } else {
      tmp = it;
    }
    var list = tmp;
    list.d2(annotation);
  }
  j1b(a) {
    if (this.j1a_1 == null) {
      this.j1a_1 = ArrayList.n2(1);
    }
    ensureNotNull(this.j1a_1).d2(a);
  }
  d12(index) {
    return getChecked(_get_childSerializers__7vnyfa(this), index).dz();
  }
  e12(index) {
    return getChecked_0(this.k1a_1, index);
  }
  c12(index) {
    var tmp0_elvis_lhs = getChecked(this.i1a_1, index);
    return tmp0_elvis_lhs == null ? emptyList() : tmp0_elvis_lhs;
  }
  a12(index) {
    return getChecked(this.h1a_1, index);
  }
  b12(name) {
    var tmp0_elvis_lhs = this.l1a_1.w4(name);
    return tmp0_elvis_lhs == null ? -3 : tmp0_elvis_lhs;
  }
  equals(other) {
    var tmp$ret$0;
    $l$block_5: {
      // Inline function 'kotlinx.serialization.internal.equalsImpl' call
      if (this === other) {
        tmp$ret$0 = true;
        break $l$block_5;
      }
      if (!(other instanceof PluginGeneratedSerialDescriptor)) {
        tmp$ret$0 = false;
        break $l$block_5;
      }
      if (!(this.g10() === other.g10())) {
        tmp$ret$0 = false;
        break $l$block_5;
      }
      if (!contentEquals(this.g1b(), other.g1b())) {
        tmp$ret$0 = false;
        break $l$block_5;
      }
      if (!(this.y11() === other.y11())) {
        tmp$ret$0 = false;
        break $l$block_5;
      }
      var inductionVariable = 0;
      var last = this.y11();
      if (inductionVariable < last)
        do {
          var index = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          if (!(this.d12(index).g10() === other.d12(index).g10())) {
            tmp$ret$0 = false;
            break $l$block_5;
          }
          if (!equals(this.d12(index).w11(), other.d12(index).w11())) {
            tmp$ret$0 = false;
            break $l$block_5;
          }
        }
         while (inductionVariable < last);
      tmp$ret$0 = true;
    }
    return tmp$ret$0;
  }
  hashCode() {
    return _get__hashCode__tgwhef_0(this);
  }
  toString() {
    return toStringImpl(this);
  }
}
class EnumDescriptor extends PluginGeneratedSerialDescriptor {
  constructor(name, elementsCount) {
    super(name, VOID, elementsCount);
    this.e1b_1 = ENUM_getInstance();
    var tmp = this;
    tmp.f1b_1 = lazy_0(EnumDescriptor$elementDescriptors$delegate$lambda(elementsCount, name, this));
  }
  w11() {
    return this.e1b_1;
  }
  d12(index) {
    return getChecked(_get_elementDescriptors__y23q9p(this), index);
  }
  equals(other) {
    if (this === other)
      return true;
    if (other == null)
      return false;
    if (!(!(other == null) ? isInterface(other, SerialDescriptor) : false))
      return false;
    if (!(other.w11() === ENUM_getInstance()))
      return false;
    if (!(this.g10() === other.g10()))
      return false;
    if (!equals(cachedSerialNames(this), cachedSerialNames(other)))
      return false;
    return true;
  }
  toString() {
    return joinToString(get_elementNames(this), ', ', this.g10() + '(', ')');
  }
  hashCode() {
    var result = getStringHashCode(this.g10());
    // Inline function 'kotlinx.serialization.internal.elementsHashCodeBy' call
    // Inline function 'kotlin.collections.fold' call
    var accumulator = 1;
    var _iterator__ex2g4s = get_elementNames(this).p1();
    while (_iterator__ex2g4s.q1()) {
      var element = _iterator__ex2g4s.r1();
      var hash = accumulator;
      var tmp = imul(31, hash);
      // Inline function 'kotlin.hashCode' call
      var tmp1_elvis_lhs = element == null ? null : hashCode(element);
      accumulator = tmp + (tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs) | 0;
    }
    var elementsHashCode = accumulator;
    result = imul(31, result) + elementsHashCode | 0;
    return result;
  }
}
class InlineClassDescriptor extends PluginGeneratedSerialDescriptor {
  constructor(name, generatedSerializer) {
    super(name, generatedSerializer, 1);
    this.w1b_1 = true;
  }
  x11() {
    return this.w1b_1;
  }
  hashCode() {
    return imul(super.hashCode(), 31);
  }
  equals(other) {
    var tmp$ret$0;
    $l$block_5: {
      // Inline function 'kotlinx.serialization.internal.equalsImpl' call
      if (this === other) {
        tmp$ret$0 = true;
        break $l$block_5;
      }
      if (!(other instanceof InlineClassDescriptor)) {
        tmp$ret$0 = false;
        break $l$block_5;
      }
      if (!(this.g10() === other.g10())) {
        tmp$ret$0 = false;
        break $l$block_5;
      }
      if (!(other.w1b_1 && contentEquals(this.g1b(), other.g1b()))) {
        tmp$ret$0 = false;
        break $l$block_5;
      }
      if (!(this.y11() === other.y11())) {
        tmp$ret$0 = false;
        break $l$block_5;
      }
      var inductionVariable = 0;
      var last = this.y11();
      if (inductionVariable < last)
        do {
          var index = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          if (!(this.d12(index).g10() === other.d12(index).g10())) {
            tmp$ret$0 = false;
            break $l$block_5;
          }
          if (!equals(this.d12(index).w11(), other.d12(index).w11())) {
            tmp$ret$0 = false;
            break $l$block_5;
          }
        }
         while (inductionVariable < last);
      tmp$ret$0 = true;
    }
    return tmp$ret$0;
  }
}
class GeneratedSerializer {}
function typeParametersSerializers() {
  return get_EMPTY_SERIALIZER_ARRAY();
}
class InlinePrimitiveDescriptor$1 {
  constructor($primitiveSerializer) {
    this.x1b_1 = $primitiveSerializer;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [this.x1b_1];
  }
  dz() {
    // Inline function 'kotlin.error' call
    var message = 'unsupported';
    throw IllegalStateException.o(toString(message));
  }
  ez(encoder, value) {
    // Inline function 'kotlin.error' call
    var message = 'unsupported';
    throw IllegalStateException.o(toString(message));
  }
  fz(decoder) {
    // Inline function 'kotlin.error' call
    var message = 'unsupported';
    throw IllegalStateException.o(toString(message));
  }
}
class NoOpEncoder extends AbstractEncoder {
  constructor() {
    return new.target.b1c();
  }
  static b1c() {
    NoOpEncoder_instance = null;
    var $this = this.h14();
    NoOpEncoder_instance = $this;
    $this.a1c_1 = EmptySerializersModule_0();
    return $this;
  }
  l10() {
    return this.a1c_1;
  }
  j14(value) {
    return Unit_instance;
  }
  k14() {
    return Unit_instance;
  }
  l14(value) {
    return Unit_instance;
  }
  m14(value) {
    return Unit_instance;
  }
  n14(value) {
    return Unit_instance;
  }
  o14(value) {
    return Unit_instance;
  }
  p14(value) {
    return Unit_instance;
  }
  q14(value) {
    return Unit_instance;
  }
  r14(value) {
    return Unit_instance;
  }
  s14(value) {
    return Unit_instance;
  }
  t14(value) {
    return Unit_instance;
  }
  u14(enumDescriptor, index) {
    return Unit_instance;
  }
}
class NothingSerialDescriptor {
  constructor() {
    NothingSerialDescriptor_instance = this;
    this.c1c_1 = OBJECT_getInstance();
    this.d1c_1 = 'kotlin.Nothing';
  }
  w11() {
    return this.c1c_1;
  }
  g10() {
    return this.d1c_1;
  }
  y11() {
    return 0;
  }
  a12(index) {
    error(this);
  }
  b12(name) {
    error(this);
  }
  e12(index) {
    error(this);
  }
  d12(index) {
    error(this);
  }
  c12(index) {
    error(this);
  }
  toString() {
    return 'NothingSerialDescriptor';
  }
  equals(other) {
    return this === other;
  }
  hashCode() {
    return getStringHashCode(this.d1c_1) + imul(31, this.c1c_1.hashCode()) | 0;
  }
}
class NullableSerializer {
  constructor(serializer) {
    this.e1c_1 = serializer;
    this.f1c_1 = new SerialDescriptorForNullable(this.e1c_1.dz());
  }
  dz() {
    return this.f1c_1;
  }
  g1c(encoder, value) {
    if (!(value == null)) {
      encoder.k15();
      encoder.h15(this.e1c_1, value);
    } else {
      encoder.k14();
    }
  }
  ez(encoder, value) {
    return this.g1c(encoder, value);
  }
  fz(decoder) {
    return decoder.a13() ? decoder.o13(this.e1c_1) : decoder.b13();
  }
  equals(other) {
    if (this === other)
      return true;
    if (other == null || !getKClassFromExpression(this).equals(getKClassFromExpression(other)))
      return false;
    if (!(other instanceof NullableSerializer))
      THROW_CCE();
    if (!equals(this.e1c_1, other.e1c_1))
      return false;
    return true;
  }
  hashCode() {
    return hashCode(this.e1c_1);
  }
}
class SerialDescriptorForNullable {
  constructor(original) {
    this.q11_1 = original;
    this.r11_1 = this.q11_1.g10() + '?';
    this.s11_1 = cachedSerialNames(this.q11_1);
  }
  g10() {
    return this.r11_1;
  }
  y12() {
    return this.s11_1;
  }
  p11() {
    return true;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof SerialDescriptorForNullable))
      return false;
    if (!equals(this.q11_1, other.q11_1))
      return false;
    return true;
  }
  toString() {
    return toString(this.q11_1) + '?';
  }
  hashCode() {
    return imul(hashCode(this.q11_1), 31);
  }
  w11() {
    return this.q11_1.w11();
  }
  x11() {
    return this.q11_1.x11();
  }
  y11() {
    return this.q11_1.y11();
  }
  z11() {
    return this.q11_1.z11();
  }
  a12(index) {
    return this.q11_1.a12(index);
  }
  b12(name) {
    return this.q11_1.b12(name);
  }
  c12(index) {
    return this.q11_1.c12(index);
  }
  d12(index) {
    return this.q11_1.d12(index);
  }
  e12(index) {
    return this.q11_1.e12(index);
  }
}
class ObjectSerializer {
  constructor(serialName, objectInstance) {
    return new.target.k1c(serialName, objectInstance);
  }
  static k1c(serialName, objectInstance) {
    var $this = createThis(this);
    $this.h1c_1 = objectInstance;
    $this.i1c_1 = emptyList();
    var tmp = $this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.j1c_1 = lazy(tmp_0, ObjectSerializer$descriptor$delegate$lambda(serialName, $this));
    return $this;
  }
  static l1c(serialName, objectInstance, classAnnotations) {
    var $this = this.k1c(serialName, objectInstance);
    $this.i1c_1 = asList(classAnnotations);
    return $this;
  }
  dz() {
    var tmp0 = this.j1c_1;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('descriptor', 1, tmp, ObjectSerializer$_get_descriptor_$ref_7z4xb6(), null);
    return tmp0.k3();
  }
  wz(encoder, value) {
    encoder.p13(this.dz()).q13(this.dz());
  }
  ez(encoder, value) {
    return this.wz(encoder, !(value == null) ? value : THROW_CCE());
  }
  fz(decoder) {
    // Inline function 'kotlinx.serialization.encoding.decodeStructure' call
    var descriptor = this.dz();
    var composite = decoder.p13(descriptor);
    var tmp$ret$1;
    $l$block_0: {
      if (composite.e14()) {
        tmp$ret$1 = Unit_instance;
        break $l$block_0;
      }
      var index = composite.f14(this.dz());
      if (index === -1) {
        tmp$ret$1 = Unit_instance;
        break $l$block_0;
      } else
        throw SerializationException.y10('Unexpected index ' + index);
    }
    var result = tmp$ret$1;
    composite.q13(descriptor);
    return this.h1c_1;
  }
}
class SerializerFactory {}
class CharArraySerializer extends PrimitiveArraySerializer {
  constructor() {
    CharArraySerializer_instance = null;
    super(serializer_9(Companion_getInstance_2()));
    CharArraySerializer_instance = this;
  }
  p1c(_this__u8e3s4) {
    return _this__u8e3s4.length;
  }
  w17(_this__u8e3s4) {
    return this.p1c((!(_this__u8e3s4 == null) ? isCharArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
  }
  q1c(_this__u8e3s4) {
    return new CharArrayBuilder(_this__u8e3s4);
  }
  x16(_this__u8e3s4) {
    return this.q1c((!(_this__u8e3s4 == null) ? isCharArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
  }
  n19() {
    return charArray(0);
  }
  r1c(decoder, index, builder, checkIndex) {
    builder.u1c(decoder.y13(this.e19_1, index));
  }
  i17(decoder, index, builder, checkIndex) {
    return this.r1c(decoder, index, builder instanceof CharArrayBuilder ? builder : THROW_CCE(), checkIndex);
  }
  o19(decoder, index, builder, checkIndex) {
    return this.r1c(decoder, index, builder instanceof CharArrayBuilder ? builder : THROW_CCE(), checkIndex);
  }
  v1c(encoder, content, size) {
    var inductionVariable = 0;
    if (inductionVariable < size)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        encoder.d15(this.e19_1, i, content[i]);
      }
       while (inductionVariable < size);
  }
  p19(encoder, content, size) {
    return this.v1c(encoder, (!(content == null) ? isCharArray(content) : false) ? content : THROW_CCE(), size);
  }
}
class DoubleArraySerializer extends PrimitiveArraySerializer {
  constructor() {
    DoubleArraySerializer_instance = null;
    super(serializer_10(DoubleCompanionObject_instance));
    DoubleArraySerializer_instance = this;
  }
  y1c(_this__u8e3s4) {
    return _this__u8e3s4.length;
  }
  w17(_this__u8e3s4) {
    return this.y1c((!(_this__u8e3s4 == null) ? isDoubleArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
  }
  z1c(_this__u8e3s4) {
    return new DoubleArrayBuilder(_this__u8e3s4);
  }
  x16(_this__u8e3s4) {
    return this.z1c((!(_this__u8e3s4 == null) ? isDoubleArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
  }
  n19() {
    return new Float64Array(0);
  }
  a1d(decoder, index, builder, checkIndex) {
    builder.d1d(decoder.x13(this.e19_1, index));
  }
  i17(decoder, index, builder, checkIndex) {
    return this.a1d(decoder, index, builder instanceof DoubleArrayBuilder ? builder : THROW_CCE(), checkIndex);
  }
  o19(decoder, index, builder, checkIndex) {
    return this.a1d(decoder, index, builder instanceof DoubleArrayBuilder ? builder : THROW_CCE(), checkIndex);
  }
  e1d(encoder, content, size) {
    var inductionVariable = 0;
    if (inductionVariable < size)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        encoder.c15(this.e19_1, i, content[i]);
      }
       while (inductionVariable < size);
  }
  p19(encoder, content, size) {
    return this.e1d(encoder, (!(content == null) ? isDoubleArray(content) : false) ? content : THROW_CCE(), size);
  }
}
class FloatArraySerializer extends PrimitiveArraySerializer {
  constructor() {
    FloatArraySerializer_instance = null;
    super(serializer_11(FloatCompanionObject_instance));
    FloatArraySerializer_instance = this;
  }
  h1d(_this__u8e3s4) {
    return _this__u8e3s4.length;
  }
  w17(_this__u8e3s4) {
    return this.h1d((!(_this__u8e3s4 == null) ? isFloatArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
  }
  i1d(_this__u8e3s4) {
    return new FloatArrayBuilder(_this__u8e3s4);
  }
  x16(_this__u8e3s4) {
    return this.i1d((!(_this__u8e3s4 == null) ? isFloatArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
  }
  n19() {
    return new Float32Array(0);
  }
  j1d(decoder, index, builder, checkIndex) {
    builder.m1d(decoder.w13(this.e19_1, index));
  }
  i17(decoder, index, builder, checkIndex) {
    return this.j1d(decoder, index, builder instanceof FloatArrayBuilder ? builder : THROW_CCE(), checkIndex);
  }
  o19(decoder, index, builder, checkIndex) {
    return this.j1d(decoder, index, builder instanceof FloatArrayBuilder ? builder : THROW_CCE(), checkIndex);
  }
  n1d(encoder, content, size) {
    var inductionVariable = 0;
    if (inductionVariable < size)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        encoder.b15(this.e19_1, i, content[i]);
      }
       while (inductionVariable < size);
  }
  p19(encoder, content, size) {
    return this.n1d(encoder, (!(content == null) ? isFloatArray(content) : false) ? content : THROW_CCE(), size);
  }
}
class LongArraySerializer extends PrimitiveArraySerializer {
  constructor() {
    LongArraySerializer_instance = null;
    super(serializer_5(Companion_getInstance_3()));
    LongArraySerializer_instance = this;
  }
  q1d(_this__u8e3s4) {
    return _this__u8e3s4.length;
  }
  w17(_this__u8e3s4) {
    return this.q1d((!(_this__u8e3s4 == null) ? isLongArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
  }
  r1d(_this__u8e3s4) {
    return new LongArrayBuilder(_this__u8e3s4);
  }
  x16(_this__u8e3s4) {
    return this.r1d((!(_this__u8e3s4 == null) ? isLongArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
  }
  n19() {
    return longArray(0);
  }
  s1d(decoder, index, builder, checkIndex) {
    builder.v1d(decoder.v13(this.e19_1, index));
  }
  i17(decoder, index, builder, checkIndex) {
    return this.s1d(decoder, index, builder instanceof LongArrayBuilder ? builder : THROW_CCE(), checkIndex);
  }
  o19(decoder, index, builder, checkIndex) {
    return this.s1d(decoder, index, builder instanceof LongArrayBuilder ? builder : THROW_CCE(), checkIndex);
  }
  w1d(encoder, content, size) {
    var inductionVariable = 0;
    if (inductionVariable < size)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        encoder.a15(this.e19_1, i, content[i]);
      }
       while (inductionVariable < size);
  }
  p19(encoder, content, size) {
    return this.w1d(encoder, (!(content == null) ? isLongArray(content) : false) ? content : THROW_CCE(), size);
  }
}
class ULongArraySerializer extends PrimitiveArraySerializer {
  constructor() {
    ULongArraySerializer_instance = null;
    super(serializer_1(Companion_getInstance_4()));
    ULongArraySerializer_instance = this;
  }
  z1d(_this__u8e3s4) {
    return _ULongArray___get_size__impl__ju6dtr(_this__u8e3s4);
  }
  w17(_this__u8e3s4) {
    return this.z1d(_this__u8e3s4 instanceof ULongArray ? _this__u8e3s4.d6_1 : THROW_CCE());
  }
  a1e(_this__u8e3s4) {
    return new ULongArrayBuilder(_this__u8e3s4);
  }
  x16(_this__u8e3s4) {
    return this.a1e(_this__u8e3s4 instanceof ULongArray ? _this__u8e3s4.d6_1 : THROW_CCE());
  }
  b1e() {
    return _ULongArray___init__impl__twm1l3(0);
  }
  n19() {
    return new ULongArray(this.b1e());
  }
  c1e(decoder, index, builder, checkIndex) {
    // Inline function 'kotlin.toULong' call
    var this_0 = decoder.a14(this.e19_1, index).g13();
    var tmp$ret$0 = _ULong___init__impl__c78o9k(this_0);
    builder.f1e(tmp$ret$0);
  }
  i17(decoder, index, builder, checkIndex) {
    return this.c1e(decoder, index, builder instanceof ULongArrayBuilder ? builder : THROW_CCE(), checkIndex);
  }
  o19(decoder, index, builder, checkIndex) {
    return this.c1e(decoder, index, builder instanceof ULongArrayBuilder ? builder : THROW_CCE(), checkIndex);
  }
  g1e(encoder, content, size) {
    var inductionVariable = 0;
    if (inductionVariable < size)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp = encoder.f15(this.e19_1, i);
        // Inline function 'kotlin.ULong.toLong' call
        var this_0 = ULongArray__get_impl_pr71q9(content, i);
        var tmp$ret$0 = _ULong___get_data__impl__fggpzb(this_0);
        tmp.p14(tmp$ret$0);
      }
       while (inductionVariable < size);
  }
  p19(encoder, content, size) {
    return this.g1e(encoder, content instanceof ULongArray ? content.d6_1 : THROW_CCE(), size);
  }
}
class IntArraySerializer extends PrimitiveArraySerializer {
  constructor() {
    IntArraySerializer_instance = null;
    super(serializer_6(IntCompanionObject_instance));
    IntArraySerializer_instance = this;
  }
  j1e(_this__u8e3s4) {
    return _this__u8e3s4.length;
  }
  w17(_this__u8e3s4) {
    return this.j1e((!(_this__u8e3s4 == null) ? isIntArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
  }
  k1e(_this__u8e3s4) {
    return new IntArrayBuilder(_this__u8e3s4);
  }
  x16(_this__u8e3s4) {
    return this.k1e((!(_this__u8e3s4 == null) ? isIntArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
  }
  n19() {
    return new Int32Array(0);
  }
  l1e(decoder, index, builder, checkIndex) {
    builder.o1e(decoder.u13(this.e19_1, index));
  }
  i17(decoder, index, builder, checkIndex) {
    return this.l1e(decoder, index, builder instanceof IntArrayBuilder ? builder : THROW_CCE(), checkIndex);
  }
  o19(decoder, index, builder, checkIndex) {
    return this.l1e(decoder, index, builder instanceof IntArrayBuilder ? builder : THROW_CCE(), checkIndex);
  }
  p1e(encoder, content, size) {
    var inductionVariable = 0;
    if (inductionVariable < size)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        encoder.z14(this.e19_1, i, content[i]);
      }
       while (inductionVariable < size);
  }
  p19(encoder, content, size) {
    return this.p1e(encoder, (!(content == null) ? isIntArray(content) : false) ? content : THROW_CCE(), size);
  }
}
class UIntArraySerializer extends PrimitiveArraySerializer {
  constructor() {
    UIntArraySerializer_instance = null;
    super(serializer_2(Companion_getInstance_5()));
    UIntArraySerializer_instance = this;
  }
  s1e(_this__u8e3s4) {
    return _UIntArray___get_size__impl__r6l8ci(_this__u8e3s4);
  }
  w17(_this__u8e3s4) {
    return this.s1e(_this__u8e3s4 instanceof UIntArray ? _this__u8e3s4.e6_1 : THROW_CCE());
  }
  t1e(_this__u8e3s4) {
    return new UIntArrayBuilder(_this__u8e3s4);
  }
  x16(_this__u8e3s4) {
    return this.t1e(_this__u8e3s4 instanceof UIntArray ? _this__u8e3s4.e6_1 : THROW_CCE());
  }
  u1e() {
    return _UIntArray___init__impl__ghjpc6(0);
  }
  n19() {
    return new UIntArray(this.u1e());
  }
  v1e(decoder, index, builder, checkIndex) {
    // Inline function 'kotlin.toUInt' call
    var this_0 = decoder.a14(this.e19_1, index).f13();
    var tmp$ret$0 = _UInt___init__impl__l7qpdl(this_0);
    builder.y1e(tmp$ret$0);
  }
  i17(decoder, index, builder, checkIndex) {
    return this.v1e(decoder, index, builder instanceof UIntArrayBuilder ? builder : THROW_CCE(), checkIndex);
  }
  o19(decoder, index, builder, checkIndex) {
    return this.v1e(decoder, index, builder instanceof UIntArrayBuilder ? builder : THROW_CCE(), checkIndex);
  }
  z1e(encoder, content, size) {
    var inductionVariable = 0;
    if (inductionVariable < size)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp = encoder.f15(this.e19_1, i);
        // Inline function 'kotlin.UInt.toInt' call
        var this_0 = UIntArray__get_impl_gp5kza(content, i);
        var tmp$ret$0 = _UInt___get_data__impl__f0vqqw(this_0);
        tmp.o14(tmp$ret$0);
      }
       while (inductionVariable < size);
  }
  p19(encoder, content, size) {
    return this.z1e(encoder, content instanceof UIntArray ? content.e6_1 : THROW_CCE(), size);
  }
}
class ShortArraySerializer extends PrimitiveArraySerializer {
  constructor() {
    ShortArraySerializer_instance = null;
    super(serializer_8(ShortCompanionObject_instance));
    ShortArraySerializer_instance = this;
  }
  c1f(_this__u8e3s4) {
    return _this__u8e3s4.length;
  }
  w17(_this__u8e3s4) {
    return this.c1f((!(_this__u8e3s4 == null) ? isShortArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
  }
  d1f(_this__u8e3s4) {
    return new ShortArrayBuilder(_this__u8e3s4);
  }
  x16(_this__u8e3s4) {
    return this.d1f((!(_this__u8e3s4 == null) ? isShortArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
  }
  n19() {
    return new Int16Array(0);
  }
  e1f(decoder, index, builder, checkIndex) {
    builder.h1f(decoder.t13(this.e19_1, index));
  }
  i17(decoder, index, builder, checkIndex) {
    return this.e1f(decoder, index, builder instanceof ShortArrayBuilder ? builder : THROW_CCE(), checkIndex);
  }
  o19(decoder, index, builder, checkIndex) {
    return this.e1f(decoder, index, builder instanceof ShortArrayBuilder ? builder : THROW_CCE(), checkIndex);
  }
  i1f(encoder, content, size) {
    var inductionVariable = 0;
    if (inductionVariable < size)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        encoder.y14(this.e19_1, i, content[i]);
      }
       while (inductionVariable < size);
  }
  p19(encoder, content, size) {
    return this.i1f(encoder, (!(content == null) ? isShortArray(content) : false) ? content : THROW_CCE(), size);
  }
}
class UShortArraySerializer extends PrimitiveArraySerializer {
  constructor() {
    UShortArraySerializer_instance = null;
    super(serializer_4(Companion_getInstance_6()));
    UShortArraySerializer_instance = this;
  }
  l1f(_this__u8e3s4) {
    return _UShortArray___get_size__impl__jqto1b(_this__u8e3s4);
  }
  w17(_this__u8e3s4) {
    return this.l1f(_this__u8e3s4 instanceof UShortArray ? _this__u8e3s4.f6_1 : THROW_CCE());
  }
  m1f(_this__u8e3s4) {
    return new UShortArrayBuilder(_this__u8e3s4);
  }
  x16(_this__u8e3s4) {
    return this.m1f(_this__u8e3s4 instanceof UShortArray ? _this__u8e3s4.f6_1 : THROW_CCE());
  }
  n1f() {
    return _UShortArray___init__impl__9b26ef(0);
  }
  n19() {
    return new UShortArray(this.n1f());
  }
  o1f(decoder, index, builder, checkIndex) {
    // Inline function 'kotlin.toUShort' call
    var this_0 = decoder.a14(this.e19_1, index).e13();
    var tmp$ret$0 = _UShort___init__impl__jigrne(this_0);
    builder.r1f(tmp$ret$0);
  }
  i17(decoder, index, builder, checkIndex) {
    return this.o1f(decoder, index, builder instanceof UShortArrayBuilder ? builder : THROW_CCE(), checkIndex);
  }
  o19(decoder, index, builder, checkIndex) {
    return this.o1f(decoder, index, builder instanceof UShortArrayBuilder ? builder : THROW_CCE(), checkIndex);
  }
  s1f(encoder, content, size) {
    var inductionVariable = 0;
    if (inductionVariable < size)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp = encoder.f15(this.e19_1, i);
        // Inline function 'kotlin.UShort.toShort' call
        var this_0 = UShortArray__get_impl_fnbhmx(content, i);
        var tmp$ret$0 = _UShort___get_data__impl__g0245(this_0);
        tmp.n14(tmp$ret$0);
      }
       while (inductionVariable < size);
  }
  p19(encoder, content, size) {
    return this.s1f(encoder, content instanceof UShortArray ? content.f6_1 : THROW_CCE(), size);
  }
}
class ByteArraySerializer extends PrimitiveArraySerializer {
  constructor() {
    ByteArraySerializer_instance = null;
    super(serializer_7(ByteCompanionObject_instance));
    ByteArraySerializer_instance = this;
  }
  v1f(_this__u8e3s4) {
    return _this__u8e3s4.length;
  }
  w17(_this__u8e3s4) {
    return this.v1f((!(_this__u8e3s4 == null) ? isByteArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
  }
  w1f(_this__u8e3s4) {
    return new ByteArrayBuilder(_this__u8e3s4);
  }
  x16(_this__u8e3s4) {
    return this.w1f((!(_this__u8e3s4 == null) ? isByteArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
  }
  n19() {
    return new Int8Array(0);
  }
  x1f(decoder, index, builder, checkIndex) {
    builder.a1g(decoder.s13(this.e19_1, index));
  }
  i17(decoder, index, builder, checkIndex) {
    return this.x1f(decoder, index, builder instanceof ByteArrayBuilder ? builder : THROW_CCE(), checkIndex);
  }
  o19(decoder, index, builder, checkIndex) {
    return this.x1f(decoder, index, builder instanceof ByteArrayBuilder ? builder : THROW_CCE(), checkIndex);
  }
  b1g(encoder, content, size) {
    var inductionVariable = 0;
    if (inductionVariable < size)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        encoder.x14(this.e19_1, i, content[i]);
      }
       while (inductionVariable < size);
  }
  p19(encoder, content, size) {
    return this.b1g(encoder, (!(content == null) ? isByteArray(content) : false) ? content : THROW_CCE(), size);
  }
}
class UByteArraySerializer extends PrimitiveArraySerializer {
  constructor() {
    UByteArraySerializer_instance = null;
    super(serializer_3(Companion_getInstance_7()));
    UByteArraySerializer_instance = this;
  }
  e1g(_this__u8e3s4) {
    return _UByteArray___get_size__impl__h6pkdv(_this__u8e3s4);
  }
  w17(_this__u8e3s4) {
    return this.e1g(_this__u8e3s4 instanceof UByteArray ? _this__u8e3s4.g6_1 : THROW_CCE());
  }
  f1g(_this__u8e3s4) {
    return new UByteArrayBuilder(_this__u8e3s4);
  }
  x16(_this__u8e3s4) {
    return this.f1g(_this__u8e3s4 instanceof UByteArray ? _this__u8e3s4.g6_1 : THROW_CCE());
  }
  g1g() {
    return _UByteArray___init__impl__ip4y9n(0);
  }
  n19() {
    return new UByteArray(this.g1g());
  }
  h1g(decoder, index, builder, checkIndex) {
    // Inline function 'kotlin.toUByte' call
    var this_0 = decoder.a14(this.e19_1, index).d13();
    var tmp$ret$0 = _UByte___init__impl__g9hnc4(this_0);
    builder.k1g(tmp$ret$0);
  }
  i17(decoder, index, builder, checkIndex) {
    return this.h1g(decoder, index, builder instanceof UByteArrayBuilder ? builder : THROW_CCE(), checkIndex);
  }
  o19(decoder, index, builder, checkIndex) {
    return this.h1g(decoder, index, builder instanceof UByteArrayBuilder ? builder : THROW_CCE(), checkIndex);
  }
  l1g(encoder, content, size) {
    var inductionVariable = 0;
    if (inductionVariable < size)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp = encoder.f15(this.e19_1, i);
        // Inline function 'kotlin.UByte.toByte' call
        var this_0 = UByteArray__get_impl_t5f3hv(content, i);
        var tmp$ret$0 = _UByte___get_data__impl__jof9qr(this_0);
        tmp.m14(tmp$ret$0);
      }
       while (inductionVariable < size);
  }
  p19(encoder, content, size) {
    return this.l1g(encoder, content instanceof UByteArray ? content.g6_1 : THROW_CCE(), size);
  }
}
class BooleanArraySerializer extends PrimitiveArraySerializer {
  constructor() {
    BooleanArraySerializer_instance = null;
    super(serializer_12(BooleanCompanionObject_instance));
    BooleanArraySerializer_instance = this;
  }
  o1g(_this__u8e3s4) {
    return _this__u8e3s4.length;
  }
  w17(_this__u8e3s4) {
    return this.o1g((!(_this__u8e3s4 == null) ? isBooleanArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
  }
  p1g(_this__u8e3s4) {
    return new BooleanArrayBuilder(_this__u8e3s4);
  }
  x16(_this__u8e3s4) {
    return this.p1g((!(_this__u8e3s4 == null) ? isBooleanArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
  }
  n19() {
    return booleanArray(0);
  }
  q1g(decoder, index, builder, checkIndex) {
    builder.t1g(decoder.r13(this.e19_1, index));
  }
  i17(decoder, index, builder, checkIndex) {
    return this.q1g(decoder, index, builder instanceof BooleanArrayBuilder ? builder : THROW_CCE(), checkIndex);
  }
  o19(decoder, index, builder, checkIndex) {
    return this.q1g(decoder, index, builder instanceof BooleanArrayBuilder ? builder : THROW_CCE(), checkIndex);
  }
  u1g(encoder, content, size) {
    var inductionVariable = 0;
    if (inductionVariable < size)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        encoder.w14(this.e19_1, i, content[i]);
      }
       while (inductionVariable < size);
  }
  p19(encoder, content, size) {
    return this.u1g(encoder, (!(content == null) ? isBooleanArray(content) : false) ? content : THROW_CCE(), size);
  }
}
class CharArrayBuilder extends PrimitiveArrayBuilder {
  constructor(bufferWithData) {
    super();
    this.s1c_1 = bufferWithData;
    this.t1c_1 = bufferWithData.length;
    this.k19(10);
  }
  g19() {
    return this.t1c_1;
  }
  k19(requiredCapacity) {
    if (this.s1c_1.length < requiredCapacity)
      this.s1c_1 = copyOf(this.s1c_1, coerceAtLeast(requiredCapacity, imul(this.s1c_1.length, 2)));
  }
  u1c(c) {
    this.r19();
    var tmp = this.s1c_1;
    var _unary__edvuaz = this.t1c_1;
    this.t1c_1 = _unary__edvuaz + 1 | 0;
    tmp[_unary__edvuaz] = c;
  }
  i19() {
    return copyOf(this.s1c_1, this.t1c_1);
  }
}
class DoubleArrayBuilder extends PrimitiveArrayBuilder {
  constructor(bufferWithData) {
    super();
    this.b1d_1 = bufferWithData;
    this.c1d_1 = bufferWithData.length;
    this.k19(10);
  }
  g19() {
    return this.c1d_1;
  }
  k19(requiredCapacity) {
    if (this.b1d_1.length < requiredCapacity)
      this.b1d_1 = copyOf_0(this.b1d_1, coerceAtLeast(requiredCapacity, imul(this.b1d_1.length, 2)));
  }
  d1d(c) {
    this.r19();
    var tmp = this.b1d_1;
    var _unary__edvuaz = this.c1d_1;
    this.c1d_1 = _unary__edvuaz + 1 | 0;
    tmp[_unary__edvuaz] = c;
  }
  i19() {
    return copyOf_0(this.b1d_1, this.c1d_1);
  }
}
class FloatArrayBuilder extends PrimitiveArrayBuilder {
  constructor(bufferWithData) {
    super();
    this.k1d_1 = bufferWithData;
    this.l1d_1 = bufferWithData.length;
    this.k19(10);
  }
  g19() {
    return this.l1d_1;
  }
  k19(requiredCapacity) {
    if (this.k1d_1.length < requiredCapacity)
      this.k1d_1 = copyOf_1(this.k1d_1, coerceAtLeast(requiredCapacity, imul(this.k1d_1.length, 2)));
  }
  m1d(c) {
    this.r19();
    var tmp = this.k1d_1;
    var _unary__edvuaz = this.l1d_1;
    this.l1d_1 = _unary__edvuaz + 1 | 0;
    tmp[_unary__edvuaz] = c;
  }
  i19() {
    return copyOf_1(this.k1d_1, this.l1d_1);
  }
}
class LongArrayBuilder extends PrimitiveArrayBuilder {
  constructor(bufferWithData) {
    super();
    this.t1d_1 = bufferWithData;
    this.u1d_1 = bufferWithData.length;
    this.k19(10);
  }
  g19() {
    return this.u1d_1;
  }
  k19(requiredCapacity) {
    if (this.t1d_1.length < requiredCapacity)
      this.t1d_1 = copyOf_2(this.t1d_1, coerceAtLeast(requiredCapacity, imul(this.t1d_1.length, 2)));
  }
  v1d(c) {
    this.r19();
    var tmp = this.t1d_1;
    var _unary__edvuaz = this.u1d_1;
    this.u1d_1 = _unary__edvuaz + 1 | 0;
    tmp[_unary__edvuaz] = c;
  }
  i19() {
    return copyOf_2(this.t1d_1, this.u1d_1);
  }
}
class ULongArrayBuilder extends PrimitiveArrayBuilder {
  constructor(bufferWithData) {
    super();
    this.d1e_1 = bufferWithData;
    this.e1e_1 = _ULongArray___get_size__impl__ju6dtr(bufferWithData);
    this.k19(10);
  }
  g19() {
    return this.e1e_1;
  }
  k19(requiredCapacity) {
    if (_ULongArray___get_size__impl__ju6dtr(this.d1e_1) < requiredCapacity) {
      var tmp = this;
      var tmp0 = this.d1e_1;
      // Inline function 'kotlin.collections.copyOf' call
      var newSize = coerceAtLeast(requiredCapacity, imul(_ULongArray___get_size__impl__ju6dtr(this.d1e_1), 2));
      tmp.d1e_1 = _ULongArray___init__impl__twm1l3_0(copyOf_2(_ULongArray___get_storage__impl__28e64j(tmp0), newSize));
    }
  }
  f1e(c) {
    this.r19();
    var tmp = this.d1e_1;
    var _unary__edvuaz = this.e1e_1;
    this.e1e_1 = _unary__edvuaz + 1 | 0;
    ULongArray__set_impl_z19mvh(tmp, _unary__edvuaz, c);
  }
  v1g() {
    var tmp0 = this.d1e_1;
    // Inline function 'kotlin.collections.copyOf' call
    var newSize = this.e1e_1;
    return _ULongArray___init__impl__twm1l3_0(copyOf_2(_ULongArray___get_storage__impl__28e64j(tmp0), newSize));
  }
  i19() {
    return new ULongArray(this.v1g());
  }
}
class IntArrayBuilder extends PrimitiveArrayBuilder {
  constructor(bufferWithData) {
    super();
    this.m1e_1 = bufferWithData;
    this.n1e_1 = bufferWithData.length;
    this.k19(10);
  }
  g19() {
    return this.n1e_1;
  }
  k19(requiredCapacity) {
    if (this.m1e_1.length < requiredCapacity)
      this.m1e_1 = copyOf_3(this.m1e_1, coerceAtLeast(requiredCapacity, imul(this.m1e_1.length, 2)));
  }
  o1e(c) {
    this.r19();
    var tmp = this.m1e_1;
    var _unary__edvuaz = this.n1e_1;
    this.n1e_1 = _unary__edvuaz + 1 | 0;
    tmp[_unary__edvuaz] = c;
  }
  i19() {
    return copyOf_3(this.m1e_1, this.n1e_1);
  }
}
class UIntArrayBuilder extends PrimitiveArrayBuilder {
  constructor(bufferWithData) {
    super();
    this.w1e_1 = bufferWithData;
    this.x1e_1 = _UIntArray___get_size__impl__r6l8ci(bufferWithData);
    this.k19(10);
  }
  g19() {
    return this.x1e_1;
  }
  k19(requiredCapacity) {
    if (_UIntArray___get_size__impl__r6l8ci(this.w1e_1) < requiredCapacity) {
      var tmp = this;
      var tmp0 = this.w1e_1;
      // Inline function 'kotlin.collections.copyOf' call
      var newSize = coerceAtLeast(requiredCapacity, imul(_UIntArray___get_size__impl__r6l8ci(this.w1e_1), 2));
      tmp.w1e_1 = _UIntArray___init__impl__ghjpc6_0(copyOf_3(_UIntArray___get_storage__impl__92a0v0(tmp0), newSize));
    }
  }
  y1e(c) {
    this.r19();
    var tmp = this.w1e_1;
    var _unary__edvuaz = this.x1e_1;
    this.x1e_1 = _unary__edvuaz + 1 | 0;
    UIntArray__set_impl_7f2zu2(tmp, _unary__edvuaz, c);
  }
  w1g() {
    var tmp0 = this.w1e_1;
    // Inline function 'kotlin.collections.copyOf' call
    var newSize = this.x1e_1;
    return _UIntArray___init__impl__ghjpc6_0(copyOf_3(_UIntArray___get_storage__impl__92a0v0(tmp0), newSize));
  }
  i19() {
    return new UIntArray(this.w1g());
  }
}
class ShortArrayBuilder extends PrimitiveArrayBuilder {
  constructor(bufferWithData) {
    super();
    this.f1f_1 = bufferWithData;
    this.g1f_1 = bufferWithData.length;
    this.k19(10);
  }
  g19() {
    return this.g1f_1;
  }
  k19(requiredCapacity) {
    if (this.f1f_1.length < requiredCapacity)
      this.f1f_1 = copyOf_4(this.f1f_1, coerceAtLeast(requiredCapacity, imul(this.f1f_1.length, 2)));
  }
  h1f(c) {
    this.r19();
    var tmp = this.f1f_1;
    var _unary__edvuaz = this.g1f_1;
    this.g1f_1 = _unary__edvuaz + 1 | 0;
    tmp[_unary__edvuaz] = c;
  }
  i19() {
    return copyOf_4(this.f1f_1, this.g1f_1);
  }
}
class UShortArrayBuilder extends PrimitiveArrayBuilder {
  constructor(bufferWithData) {
    super();
    this.p1f_1 = bufferWithData;
    this.q1f_1 = _UShortArray___get_size__impl__jqto1b(bufferWithData);
    this.k19(10);
  }
  g19() {
    return this.q1f_1;
  }
  k19(requiredCapacity) {
    if (_UShortArray___get_size__impl__jqto1b(this.p1f_1) < requiredCapacity) {
      var tmp = this;
      var tmp0 = this.p1f_1;
      // Inline function 'kotlin.collections.copyOf' call
      var newSize = coerceAtLeast(requiredCapacity, imul(_UShortArray___get_size__impl__jqto1b(this.p1f_1), 2));
      tmp.p1f_1 = _UShortArray___init__impl__9b26ef_0(copyOf_4(_UShortArray___get_storage__impl__t2jpv5(tmp0), newSize));
    }
  }
  r1f(c) {
    this.r19();
    var tmp = this.p1f_1;
    var _unary__edvuaz = this.q1f_1;
    this.q1f_1 = _unary__edvuaz + 1 | 0;
    UShortArray__set_impl_6d8whp(tmp, _unary__edvuaz, c);
  }
  x1g() {
    var tmp0 = this.p1f_1;
    // Inline function 'kotlin.collections.copyOf' call
    var newSize = this.q1f_1;
    return _UShortArray___init__impl__9b26ef_0(copyOf_4(_UShortArray___get_storage__impl__t2jpv5(tmp0), newSize));
  }
  i19() {
    return new UShortArray(this.x1g());
  }
}
class ByteArrayBuilder extends PrimitiveArrayBuilder {
  constructor(bufferWithData) {
    super();
    this.y1f_1 = bufferWithData;
    this.z1f_1 = bufferWithData.length;
    this.k19(10);
  }
  g19() {
    return this.z1f_1;
  }
  k19(requiredCapacity) {
    if (this.y1f_1.length < requiredCapacity)
      this.y1f_1 = copyOf_5(this.y1f_1, coerceAtLeast(requiredCapacity, imul(this.y1f_1.length, 2)));
  }
  a1g(c) {
    this.r19();
    var tmp = this.y1f_1;
    var _unary__edvuaz = this.z1f_1;
    this.z1f_1 = _unary__edvuaz + 1 | 0;
    tmp[_unary__edvuaz] = c;
  }
  i19() {
    return copyOf_5(this.y1f_1, this.z1f_1);
  }
}
class UByteArrayBuilder extends PrimitiveArrayBuilder {
  constructor(bufferWithData) {
    super();
    this.i1g_1 = bufferWithData;
    this.j1g_1 = _UByteArray___get_size__impl__h6pkdv(bufferWithData);
    this.k19(10);
  }
  g19() {
    return this.j1g_1;
  }
  k19(requiredCapacity) {
    if (_UByteArray___get_size__impl__h6pkdv(this.i1g_1) < requiredCapacity) {
      var tmp = this;
      var tmp0 = this.i1g_1;
      // Inline function 'kotlin.collections.copyOf' call
      var newSize = coerceAtLeast(requiredCapacity, imul(_UByteArray___get_size__impl__h6pkdv(this.i1g_1), 2));
      tmp.i1g_1 = _UByteArray___init__impl__ip4y9n_0(copyOf_5(_UByteArray___get_storage__impl__d4kctt(tmp0), newSize));
    }
  }
  k1g(c) {
    this.r19();
    var tmp = this.i1g_1;
    var _unary__edvuaz = this.j1g_1;
    this.j1g_1 = _unary__edvuaz + 1 | 0;
    UByteArray__set_impl_jvcicn(tmp, _unary__edvuaz, c);
  }
  y1g() {
    var tmp0 = this.i1g_1;
    // Inline function 'kotlin.collections.copyOf' call
    var newSize = this.j1g_1;
    return _UByteArray___init__impl__ip4y9n_0(copyOf_5(_UByteArray___get_storage__impl__d4kctt(tmp0), newSize));
  }
  i19() {
    return new UByteArray(this.y1g());
  }
}
class BooleanArrayBuilder extends PrimitiveArrayBuilder {
  constructor(bufferWithData) {
    super();
    this.r1g_1 = bufferWithData;
    this.s1g_1 = bufferWithData.length;
    this.k19(10);
  }
  g19() {
    return this.s1g_1;
  }
  k19(requiredCapacity) {
    if (this.r1g_1.length < requiredCapacity)
      this.r1g_1 = copyOf_6(this.r1g_1, coerceAtLeast(requiredCapacity, imul(this.r1g_1.length, 2)));
  }
  t1g(c) {
    this.r19();
    var tmp = this.r1g_1;
    var _unary__edvuaz = this.s1g_1;
    this.s1g_1 = _unary__edvuaz + 1 | 0;
    tmp[_unary__edvuaz] = c;
  }
  i19() {
    return copyOf_6(this.r1g_1, this.s1g_1);
  }
}
class IntSerializer {
  constructor() {
    IntSerializer_instance = this;
    this.z1g_1 = new PrimitiveSerialDescriptor('kotlin.Int', INT_getInstance());
  }
  dz() {
    return this.z1g_1;
  }
  a1h(encoder, value) {
    return encoder.o14(value);
  }
  ez(encoder, value) {
    return this.a1h(encoder, (!(value == null) ? typeof value === 'number' : false) ? value : THROW_CCE());
  }
  fz(decoder) {
    return decoder.f13();
  }
}
class BooleanSerializer {
  constructor() {
    BooleanSerializer_instance = this;
    this.b1h_1 = new PrimitiveSerialDescriptor('kotlin.Boolean', BOOLEAN_getInstance());
  }
  dz() {
    return this.b1h_1;
  }
  c1h(encoder, value) {
    return encoder.l14(value);
  }
  ez(encoder, value) {
    return this.c1h(encoder, (!(value == null) ? typeof value === 'boolean' : false) ? value : THROW_CCE());
  }
  fz(decoder) {
    return decoder.c13();
  }
}
class StringSerializer {
  constructor() {
    StringSerializer_instance = this;
    this.d1h_1 = new PrimitiveSerialDescriptor('kotlin.String', STRING_getInstance());
  }
  dz() {
    return this.d1h_1;
  }
  e1h(encoder, value) {
    return encoder.t14(value);
  }
  ez(encoder, value) {
    return this.e1h(encoder, (!(value == null) ? typeof value === 'string' : false) ? value : THROW_CCE());
  }
  fz(decoder) {
    return decoder.k13();
  }
}
class LongSerializer {
  constructor() {
    LongSerializer_instance = this;
    this.f1h_1 = new PrimitiveSerialDescriptor('kotlin.Long', LONG_getInstance());
  }
  dz() {
    return this.f1h_1;
  }
  g1h(encoder, value) {
    return encoder.p14(value);
  }
  ez(encoder, value) {
    return this.g1h(encoder, value instanceof Long ? value : THROW_CCE());
  }
  fz(decoder) {
    return decoder.g13();
  }
}
class PrimitiveSerialDescriptor {
  constructor(serialName, kind) {
    this.h1h_1 = serialName;
    this.i1h_1 = kind;
  }
  g10() {
    return this.h1h_1;
  }
  w11() {
    return this.i1h_1;
  }
  y11() {
    return 0;
  }
  a12(index) {
    error_0(this);
  }
  b12(name) {
    error_0(this);
  }
  e12(index) {
    error_0(this);
  }
  d12(index) {
    error_0(this);
  }
  c12(index) {
    error_0(this);
  }
  toString() {
    return 'PrimitiveDescriptor(' + this.h1h_1 + ')';
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof PrimitiveSerialDescriptor))
      return false;
    if (this.h1h_1 === other.h1h_1 && equals(this.i1h_1, other.i1h_1))
      return true;
    return false;
  }
  hashCode() {
    return getStringHashCode(this.h1h_1) + imul(31, this.i1h_1.hashCode()) | 0;
  }
}
class ByteSerializer {
  constructor() {
    ByteSerializer_instance = this;
    this.j1h_1 = new PrimitiveSerialDescriptor('kotlin.Byte', BYTE_getInstance());
  }
  dz() {
    return this.j1h_1;
  }
  k1h(encoder, value) {
    return encoder.m14(value);
  }
  ez(encoder, value) {
    return this.k1h(encoder, (!(value == null) ? typeof value === 'number' : false) ? value : THROW_CCE());
  }
  fz(decoder) {
    return decoder.d13();
  }
}
class ShortSerializer {
  constructor() {
    ShortSerializer_instance = this;
    this.l1h_1 = new PrimitiveSerialDescriptor('kotlin.Short', SHORT_getInstance());
  }
  dz() {
    return this.l1h_1;
  }
  m1h(encoder, value) {
    return encoder.n14(value);
  }
  ez(encoder, value) {
    return this.m1h(encoder, (!(value == null) ? typeof value === 'number' : false) ? value : THROW_CCE());
  }
  fz(decoder) {
    return decoder.e13();
  }
}
class CharSerializer {
  constructor() {
    CharSerializer_instance = this;
    this.n1h_1 = new PrimitiveSerialDescriptor('kotlin.Char', CHAR_getInstance());
  }
  dz() {
    return this.n1h_1;
  }
  o1h(encoder, value) {
    return encoder.s14(value);
  }
  ez(encoder, value) {
    return this.o1h(encoder, value instanceof Char ? value.f4_1 : THROW_CCE());
  }
  p1h(decoder) {
    return decoder.j13();
  }
  fz(decoder) {
    return new Char(this.p1h(decoder));
  }
}
class DoubleSerializer {
  constructor() {
    DoubleSerializer_instance = this;
    this.q1h_1 = new PrimitiveSerialDescriptor('kotlin.Double', DOUBLE_getInstance());
  }
  dz() {
    return this.q1h_1;
  }
  r1h(encoder, value) {
    return encoder.r14(value);
  }
  ez(encoder, value) {
    return this.r1h(encoder, (!(value == null) ? typeof value === 'number' : false) ? value : THROW_CCE());
  }
  fz(decoder) {
    return decoder.i13();
  }
}
class FloatSerializer {
  constructor() {
    FloatSerializer_instance = this;
    this.s1h_1 = new PrimitiveSerialDescriptor('kotlin.Float', FLOAT_getInstance());
  }
  dz() {
    return this.s1h_1;
  }
  t1h(encoder, value) {
    return encoder.q14(value);
  }
  ez(encoder, value) {
    return this.t1h(encoder, (!(value == null) ? typeof value === 'number' : false) ? value : THROW_CCE());
  }
  fz(decoder) {
    return decoder.h13();
  }
}
class UnitSerializer {
  constructor() {
    UnitSerializer_instance = this;
    this.u1h_1 = ObjectSerializer.k1c('kotlin.Unit', Unit_instance);
  }
  dz() {
    return this.u1h_1.dz();
  }
  v1h(encoder, value) {
    this.u1h_1.wz(encoder, Unit_instance);
  }
  ez(encoder, value) {
    return this.v1h(encoder, value instanceof Unit ? value : THROW_CCE());
  }
  w1h(decoder) {
    this.u1h_1.fz(decoder);
  }
  fz(decoder) {
    this.w1h(decoder);
    return Unit_instance;
  }
}
class TaggedDecoder {
  constructor() {
    var tmp = this;
    // Inline function 'kotlin.collections.arrayListOf' call
    tmp.c1i_1 = ArrayList.p2();
    this.d1i_1 = false;
  }
  l10() {
    return EmptySerializersModule_0();
  }
  h1i(tag) {
    throw SerializationException.y10(toString(getKClassFromExpression(this)) + " can't retrieve untyped values");
  }
  i1i(tag) {
    return true;
  }
  j1i(tag) {
    var tmp = this.h1i(tag);
    return typeof tmp === 'boolean' ? tmp : THROW_CCE();
  }
  k1i(tag) {
    var tmp = this.h1i(tag);
    return typeof tmp === 'number' ? tmp : THROW_CCE();
  }
  l1i(tag) {
    var tmp = this.h1i(tag);
    return typeof tmp === 'number' ? tmp : THROW_CCE();
  }
  m1i(tag) {
    var tmp = this.h1i(tag);
    return typeof tmp === 'number' ? tmp : THROW_CCE();
  }
  n1i(tag) {
    var tmp = this.h1i(tag);
    return tmp instanceof Long ? tmp : THROW_CCE();
  }
  o1i(tag) {
    var tmp = this.h1i(tag);
    return typeof tmp === 'number' ? tmp : THROW_CCE();
  }
  p1i(tag) {
    var tmp = this.h1i(tag);
    return typeof tmp === 'number' ? tmp : THROW_CCE();
  }
  q1i(tag) {
    var tmp = this.h1i(tag);
    return tmp instanceof Char ? tmp.f4_1 : THROW_CCE();
  }
  r1i(tag) {
    var tmp = this.h1i(tag);
    return typeof tmp === 'string' ? tmp : THROW_CCE();
  }
  s1i(tag, enumDescriptor) {
    var tmp = this.h1i(tag);
    return typeof tmp === 'number' ? tmp : THROW_CCE();
  }
  t1i(tag, inlineDescriptor) {
    // Inline function 'kotlin.apply' call
    this.u1i(tag);
    return this;
  }
  n13(deserializer, previousValue) {
    return this.o13(deserializer);
  }
  m13(descriptor) {
    return this.t1i(this.v1i(), descriptor);
  }
  a13() {
    var tmp0_elvis_lhs = this.e1i();
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return false;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var currentTag = tmp;
    return this.i1i(currentTag);
  }
  b13() {
    return null;
  }
  c13() {
    return this.j1i(this.v1i());
  }
  d13() {
    return this.k1i(this.v1i());
  }
  e13() {
    return this.l1i(this.v1i());
  }
  f13() {
    return this.m1i(this.v1i());
  }
  g13() {
    return this.n1i(this.v1i());
  }
  h13() {
    return this.o1i(this.v1i());
  }
  i13() {
    return this.p1i(this.v1i());
  }
  j13() {
    return this.q1i(this.v1i());
  }
  k13() {
    return this.r1i(this.v1i());
  }
  l13(enumDescriptor) {
    return this.s1i(this.v1i(), enumDescriptor);
  }
  p13(descriptor) {
    return this;
  }
  q13(descriptor) {
  }
  r13(descriptor, index) {
    return this.j1i(this.z1h(descriptor, index));
  }
  s13(descriptor, index) {
    return this.k1i(this.z1h(descriptor, index));
  }
  t13(descriptor, index) {
    return this.l1i(this.z1h(descriptor, index));
  }
  u13(descriptor, index) {
    return this.m1i(this.z1h(descriptor, index));
  }
  v13(descriptor, index) {
    return this.n1i(this.z1h(descriptor, index));
  }
  w13(descriptor, index) {
    return this.o1i(this.z1h(descriptor, index));
  }
  x13(descriptor, index) {
    return this.p1i(this.z1h(descriptor, index));
  }
  y13(descriptor, index) {
    return this.q1i(this.z1h(descriptor, index));
  }
  z13(descriptor, index) {
    return this.r1i(this.z1h(descriptor, index));
  }
  a14(descriptor, index) {
    return this.t1i(this.z1h(descriptor, index), descriptor.d12(index));
  }
  b14(descriptor, index, deserializer, previousValue) {
    var tmp = this.z1h(descriptor, index);
    return tagBlock(this, tmp, TaggedDecoder$decodeSerializableElement$lambda(this, deserializer, previousValue));
  }
  d14(descriptor, index, deserializer, previousValue) {
    var tmp = this.z1h(descriptor, index);
    return tagBlock(this, tmp, TaggedDecoder$decodeNullableSerializableElement$lambda(this, deserializer, previousValue));
  }
  e1i() {
    return lastOrNull(this.c1i_1);
  }
  u1i(name) {
    this.c1i_1.d2(name);
  }
  v1i() {
    var r = this.c1i_1.g5(get_lastIndex_0(this.c1i_1));
    this.d1i_1 = true;
    return r;
  }
}
class NamedValueDecoder extends TaggedDecoder {
  z1h(_this__u8e3s4, index) {
    return this.b1i(this.a1i(_this__u8e3s4, index));
  }
  b1i(nestedName) {
    var tmp0_elvis_lhs = this.e1i();
    return this.f1i(tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs, nestedName);
  }
  a1i(descriptor, index) {
    return descriptor.a12(index);
  }
  f1i(parentName, childName) {
    var tmp;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(parentName) === 0) {
      tmp = childName;
    } else {
      tmp = parentName + '.' + childName;
    }
    return tmp;
  }
  g1i() {
    return this.c1i_1.n1() ? '$' : joinToString(this.c1i_1, '.', '$.');
  }
}
class MapEntry {
  constructor(key, value) {
    this.w1i_1 = key;
    this.x1i_1 = value;
  }
  j3() {
    return this.w1i_1;
  }
  k3() {
    return this.x1i_1;
  }
  toString() {
    return 'MapEntry(key=' + toString_0(this.w1i_1) + ', value=' + toString_0(this.x1i_1) + ')';
  }
  hashCode() {
    var result = this.w1i_1 == null ? 0 : hashCode(this.w1i_1);
    result = imul(result, 31) + (this.x1i_1 == null ? 0 : hashCode(this.x1i_1)) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof MapEntry))
      return false;
    var tmp0_other_with_cast = other instanceof MapEntry ? other : THROW_CCE();
    if (!equals(this.w1i_1, tmp0_other_with_cast.w1i_1))
      return false;
    if (!equals(this.x1i_1, tmp0_other_with_cast.x1i_1))
      return false;
    return true;
  }
}
class KeyValueSerializer {
  constructor(keySerializer, valueSerializer) {
    this.g1j_1 = keySerializer;
    this.h1j_1 = valueSerializer;
  }
  i1j(encoder, value) {
    var structuredEncoder = encoder.p13(this.dz());
    structuredEncoder.g15(this.dz(), 0, this.g1j_1, this.c1j(value));
    structuredEncoder.g15(this.dz(), 1, this.h1j_1, this.e1j(value));
    structuredEncoder.q13(this.dz());
  }
  ez(encoder, value) {
    return this.i1j(encoder, value);
  }
  fz(decoder) {
    // Inline function 'kotlinx.serialization.encoding.decodeStructure' call
    var descriptor = this.dz();
    var composite = decoder.p13(descriptor);
    var tmp$ret$1;
    $l$block: {
      if (composite.e14()) {
        var key = composite.c14(this.dz(), 0, this.g1j_1);
        var value = composite.c14(this.dz(), 1, this.h1j_1);
        tmp$ret$1 = this.f1j(key, value);
        break $l$block;
      }
      var key_0 = get_NULL();
      var value_0 = get_NULL();
      mainLoop: while (true) {
        var idx = composite.f14(this.dz());
        switch (idx) {
          case -1:
            break mainLoop;
          case 0:
            key_0 = composite.c14(this.dz(), 0, this.g1j_1);
            break;
          case 1:
            value_0 = composite.c14(this.dz(), 1, this.h1j_1);
            break;
          default:
            throw SerializationException.y10('Invalid index: ' + idx);
        }
      }
      if (key_0 === get_NULL())
        throw SerializationException.y10("Element 'key' is missing");
      if (value_0 === get_NULL())
        throw SerializationException.y10("Element 'value' is missing");
      tmp$ret$1 = this.f1j(key_0, value_0);
    }
    var result = tmp$ret$1;
    composite.q13(descriptor);
    return result;
  }
}
class MapEntrySerializer extends KeyValueSerializer {
  constructor(keySerializer, valueSerializer) {
    super(keySerializer, valueSerializer);
    var tmp = this;
    var tmp_0 = MAP_getInstance();
    tmp.a1j_1 = buildSerialDescriptor('kotlin.collections.Map.Entry', tmp_0, [], MapEntrySerializer$descriptor$lambda(keySerializer, valueSerializer));
  }
  dz() {
    return this.a1j_1;
  }
  b1j(_this__u8e3s4) {
    return _this__u8e3s4.j3();
  }
  c1j(_this__u8e3s4) {
    return this.b1j((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, Entry) : false) ? _this__u8e3s4 : THROW_CCE());
  }
  d1j(_this__u8e3s4) {
    return _this__u8e3s4.k3();
  }
  e1j(_this__u8e3s4) {
    return this.d1j((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, Entry) : false) ? _this__u8e3s4 : THROW_CCE());
  }
  f1j(key, value) {
    return new MapEntry(key, value);
  }
}
class PairSerializer extends KeyValueSerializer {
  constructor(keySerializer, valueSerializer) {
    super(keySerializer, valueSerializer);
    var tmp = this;
    tmp.l1j_1 = buildClassSerialDescriptor('kotlin.Pair', [], PairSerializer$descriptor$lambda(keySerializer, valueSerializer));
  }
  dz() {
    return this.l1j_1;
  }
  m1j(_this__u8e3s4) {
    return _this__u8e3s4.pm_1;
  }
  c1j(_this__u8e3s4) {
    return this.m1j(_this__u8e3s4 instanceof Pair ? _this__u8e3s4 : THROW_CCE());
  }
  n1j(_this__u8e3s4) {
    return _this__u8e3s4.qm_1;
  }
  e1j(_this__u8e3s4) {
    return this.n1j(_this__u8e3s4 instanceof Pair ? _this__u8e3s4 : THROW_CCE());
  }
  f1j(key, value) {
    return to(key, value);
  }
}
class TripleSerializer {
  constructor(aSerializer, bSerializer, cSerializer) {
    this.o1j_1 = aSerializer;
    this.p1j_1 = bSerializer;
    this.q1j_1 = cSerializer;
    var tmp = this;
    tmp.r1j_1 = buildClassSerialDescriptor('kotlin.Triple', [], TripleSerializer$descriptor$lambda(this));
  }
  dz() {
    return this.r1j_1;
  }
  s1j(encoder, value) {
    var structuredEncoder = encoder.p13(this.r1j_1);
    structuredEncoder.g15(this.r1j_1, 0, this.o1j_1, value.cx_1);
    structuredEncoder.g15(this.r1j_1, 1, this.p1j_1, value.dx_1);
    structuredEncoder.g15(this.r1j_1, 2, this.q1j_1, value.ex_1);
    structuredEncoder.q13(this.r1j_1);
  }
  ez(encoder, value) {
    return this.s1j(encoder, value instanceof Triple ? value : THROW_CCE());
  }
  fz(decoder) {
    var composite = decoder.p13(this.r1j_1);
    if (composite.e14()) {
      return decodeSequentially_1(this, composite);
    }
    return decodeStructure(this, composite);
  }
}
class ULongSerializer {
  constructor() {
    ULongSerializer_instance = this;
    this.t1j_1 = InlinePrimitiveDescriptor('kotlin.ULong', serializer_5(Companion_getInstance_3()));
  }
  dz() {
    return this.t1j_1;
  }
  u1j(encoder, value) {
    var tmp = encoder.v14(this.t1j_1);
    // Inline function 'kotlin.ULong.toLong' call
    var tmp$ret$0 = _ULong___get_data__impl__fggpzb(value);
    tmp.p14(tmp$ret$0);
  }
  ez(encoder, value) {
    return this.u1j(encoder, value instanceof ULong ? value.ly_1 : THROW_CCE());
  }
  v1j(decoder) {
    // Inline function 'kotlin.toULong' call
    var this_0 = decoder.m13(this.t1j_1).g13();
    return _ULong___init__impl__c78o9k(this_0);
  }
  fz(decoder) {
    return new ULong(this.v1j(decoder));
  }
}
class UIntSerializer {
  constructor() {
    UIntSerializer_instance = this;
    this.w1j_1 = InlinePrimitiveDescriptor('kotlin.UInt', serializer_6(IntCompanionObject_instance));
  }
  dz() {
    return this.w1j_1;
  }
  x1j(encoder, value) {
    var tmp = encoder.v14(this.w1j_1);
    // Inline function 'kotlin.UInt.toInt' call
    var tmp$ret$0 = _UInt___get_data__impl__f0vqqw(value);
    tmp.o14(tmp$ret$0);
  }
  ez(encoder, value) {
    return this.x1j(encoder, value instanceof UInt ? value.ay_1 : THROW_CCE());
  }
  y1j(decoder) {
    // Inline function 'kotlin.toUInt' call
    var this_0 = decoder.m13(this.w1j_1).f13();
    return _UInt___init__impl__l7qpdl(this_0);
  }
  fz(decoder) {
    return new UInt(this.y1j(decoder));
  }
}
class UByteSerializer {
  constructor() {
    UByteSerializer_instance = this;
    this.z1j_1 = InlinePrimitiveDescriptor('kotlin.UByte', serializer_7(ByteCompanionObject_instance));
  }
  dz() {
    return this.z1j_1;
  }
  a1k(encoder, value) {
    var tmp = encoder.v14(this.z1j_1);
    // Inline function 'kotlin.UByte.toByte' call
    var tmp$ret$0 = _UByte___get_data__impl__jof9qr(value);
    tmp.m14(tmp$ret$0);
  }
  ez(encoder, value) {
    return this.a1k(encoder, value instanceof UByte ? value.px_1 : THROW_CCE());
  }
  b1k(decoder) {
    // Inline function 'kotlin.toUByte' call
    var this_0 = decoder.m13(this.z1j_1).d13();
    return _UByte___init__impl__g9hnc4(this_0);
  }
  fz(decoder) {
    return new UByte(this.b1k(decoder));
  }
}
class UShortSerializer {
  constructor() {
    UShortSerializer_instance = this;
    this.c1k_1 = InlinePrimitiveDescriptor('kotlin.UShort', serializer_8(ShortCompanionObject_instance));
  }
  dz() {
    return this.c1k_1;
  }
  d1k(encoder, value) {
    var tmp = encoder.v14(this.c1k_1);
    // Inline function 'kotlin.UShort.toShort' call
    var tmp$ret$0 = _UShort___get_data__impl__g0245(value);
    tmp.n14(tmp$ret$0);
  }
  ez(encoder, value) {
    return this.d1k(encoder, value instanceof UShort ? value.wy_1 : THROW_CCE());
  }
  e1k(decoder) {
    // Inline function 'kotlin.toUShort' call
    var this_0 = decoder.m13(this.c1k_1).e13();
    return _UShort___init__impl__jigrne(this_0);
  }
  fz(decoder) {
    return new UShort(this.e1k(decoder));
  }
}
class SerializersModule {
  l11(kClass, typeArgumentsSerializers, $super) {
    typeArgumentsSerializers = typeArgumentsSerializers === VOID ? emptyList() : typeArgumentsSerializers;
    return $super === VOID ? this.m11(kClass, typeArgumentsSerializers) : $super.m11.call(this, kClass, typeArgumentsSerializers);
  }
}
class SerialModuleImpl extends SerializersModule {
  constructor(class2ContextualFactory, polyBase2Serializers, polyBase2DefaultSerializerProvider, polyBase2NamedSerializers, polyBase2DefaultDeserializerProvider, hasInterfaceContextualSerializers) {
    super();
    this.g1k_1 = class2ContextualFactory;
    this.h1k_1 = polyBase2Serializers;
    this.i1k_1 = polyBase2DefaultSerializerProvider;
    this.j1k_1 = polyBase2NamedSerializers;
    this.k1k_1 = polyBase2DefaultDeserializerProvider;
    this.l1k_1 = hasInterfaceContextualSerializers;
  }
  k11() {
    return this.l1k_1;
  }
  o15(baseClass, value) {
    if (!baseClass.sf(value))
      return null;
    var tmp0_safe_receiver = this.h1k_1.w4(baseClass);
    var tmp = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.w4(getKClassFromExpression(value));
    var registered = (!(tmp == null) ? isInterface(tmp, SerializationStrategy) : false) ? tmp : null;
    if (!(registered == null))
      return registered;
    var tmp_0 = this.i1k_1.w4(baseClass);
    var tmp1_safe_receiver = (!(tmp_0 == null) ? typeof tmp_0 === 'function' : false) ? tmp_0 : null;
    return tmp1_safe_receiver == null ? null : tmp1_safe_receiver(value);
  }
  n15(baseClass, serializedClassName) {
    var tmp0_safe_receiver = this.j1k_1.w4(baseClass);
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.collections.get' call
      tmp = (isInterface(tmp0_safe_receiver, KtMap) ? tmp0_safe_receiver : THROW_CCE()).w4(serializedClassName);
    }
    var tmp_0 = tmp;
    var registered = (!(tmp_0 == null) ? isInterface(tmp_0, KSerializer) : false) ? tmp_0 : null;
    if (!(registered == null))
      return registered;
    var tmp_1 = this.k1k_1.w4(baseClass);
    var tmp1_safe_receiver = (!(tmp_1 == null) ? typeof tmp_1 === 'function' : false) ? tmp_1 : null;
    return tmp1_safe_receiver == null ? null : tmp1_safe_receiver(serializedClassName);
  }
  m11(kClass, typeArgumentsSerializers) {
    var tmp0_safe_receiver = this.g1k_1.w4(kClass);
    var tmp = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.m1k(typeArgumentsSerializers);
    return (tmp == null ? true : isInterface(tmp, KSerializer)) ? tmp : null;
  }
  f1k(collector) {
    // Inline function 'kotlin.collections.forEach' call
    // Inline function 'kotlin.collections.iterator' call
    var _iterator__ex2g4s = this.g1k_1.i3().p1();
    while (_iterator__ex2g4s.q1()) {
      var element = _iterator__ex2g4s.r1();
      // Inline function 'kotlin.collections.component1' call
      var kclass = element.j3();
      // Inline function 'kotlin.collections.component2' call
      var serial = element.k3();
      if (serial instanceof Argless) {
        var tmp = isInterface(kclass, KClass) ? kclass : THROW_CCE();
        var tmp_0 = serial.p1k_1;
        collector.q1k(tmp, isInterface(tmp_0, KSerializer) ? tmp_0 : THROW_CCE());
      } else {
        if (serial instanceof WithTypeArguments) {
          collector.o1k(kclass, serial.n1k_1);
        } else {
          noWhenBranchMatchedException();
        }
      }
    }
    // Inline function 'kotlin.collections.forEach' call
    // Inline function 'kotlin.collections.iterator' call
    var _iterator__ex2g4s_0 = this.h1k_1.i3().p1();
    while (_iterator__ex2g4s_0.q1()) {
      var element_0 = _iterator__ex2g4s_0.r1();
      // Inline function 'kotlin.collections.component1' call
      var baseClass = element_0.j3();
      // Inline function 'kotlin.collections.component2' call
      var classMap = element_0.k3();
      // Inline function 'kotlin.collections.forEach' call
      // Inline function 'kotlin.collections.iterator' call
      var _iterator__ex2g4s_1 = classMap.i3().p1();
      while (_iterator__ex2g4s_1.q1()) {
        var element_1 = _iterator__ex2g4s_1.r1();
        // Inline function 'kotlin.collections.component1' call
        var actualClass = element_1.j3();
        // Inline function 'kotlin.collections.component2' call
        var serializer = element_1.k3();
        var tmp_1 = isInterface(baseClass, KClass) ? baseClass : THROW_CCE();
        var tmp_2 = isInterface(actualClass, KClass) ? actualClass : THROW_CCE();
        // Inline function 'kotlinx.serialization.internal.cast' call
        var tmp$ret$15 = isInterface(serializer, KSerializer) ? serializer : THROW_CCE();
        collector.r1k(tmp_1, tmp_2, tmp$ret$15);
      }
    }
    // Inline function 'kotlin.collections.forEach' call
    // Inline function 'kotlin.collections.iterator' call
    var _iterator__ex2g4s_2 = this.i1k_1.i3().p1();
    while (_iterator__ex2g4s_2.q1()) {
      var element_2 = _iterator__ex2g4s_2.r1();
      // Inline function 'kotlin.collections.component1' call
      var baseClass_0 = element_2.j3();
      // Inline function 'kotlin.collections.component2' call
      var provider = element_2.k3();
      var tmp_3 = isInterface(baseClass_0, KClass) ? baseClass_0 : THROW_CCE();
      collector.s1k(tmp_3, typeof provider === 'function' ? provider : THROW_CCE());
    }
    // Inline function 'kotlin.collections.forEach' call
    // Inline function 'kotlin.collections.iterator' call
    var _iterator__ex2g4s_3 = this.k1k_1.i3().p1();
    while (_iterator__ex2g4s_3.q1()) {
      var element_3 = _iterator__ex2g4s_3.r1();
      // Inline function 'kotlin.collections.component1' call
      var baseClass_1 = element_3.j3();
      // Inline function 'kotlin.collections.component2' call
      var provider_0 = element_3.k3();
      var tmp_4 = isInterface(baseClass_1, KClass) ? baseClass_1 : THROW_CCE();
      collector.t1k(tmp_4, typeof provider_0 === 'function' ? provider_0 : THROW_CCE());
    }
  }
}
class ContextualProvider {}
class Argless extends ContextualProvider {
  constructor(serializer) {
    super();
    this.p1k_1 = serializer;
  }
  m1k(typeArgumentsSerializers) {
    return this.p1k_1;
  }
  equals(other) {
    var tmp;
    if (other instanceof Argless) {
      tmp = equals(other.p1k_1, this.p1k_1);
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    return hashCode(this.p1k_1);
  }
}
class WithTypeArguments extends ContextualProvider {
  constructor(provider) {
    super();
    this.n1k_1 = provider;
  }
  m1k(typeArgumentsSerializers) {
    return this.n1k_1(typeArgumentsSerializers);
  }
}
class SerializersModuleCollector {}
function contextual(kClass, serializer) {
  return this.o1k(kClass, SerializersModuleCollector$contextual$lambda(serializer));
}
class SerializersModuleBuilder {
  constructor() {
    var tmp = this;
    // Inline function 'kotlin.collections.hashMapOf' call
    tmp.u1k_1 = HashMap.s9();
    var tmp_0 = this;
    // Inline function 'kotlin.collections.hashMapOf' call
    tmp_0.v1k_1 = HashMap.s9();
    var tmp_1 = this;
    // Inline function 'kotlin.collections.hashMapOf' call
    tmp_1.w1k_1 = HashMap.s9();
    var tmp_2 = this;
    // Inline function 'kotlin.collections.hashMapOf' call
    tmp_2.x1k_1 = HashMap.s9();
    var tmp_3 = this;
    // Inline function 'kotlin.collections.hashMapOf' call
    tmp_3.y1k_1 = HashMap.s9();
    this.z1k_1 = false;
  }
  q1k(kClass, serializer) {
    return this.b1l(kClass, new Argless(serializer));
  }
  o1k(kClass, provider) {
    return this.b1l(kClass, new WithTypeArguments(provider));
  }
  r1k(baseClass, actualClass, actualSerializer) {
    this.c1l(baseClass, actualClass, actualSerializer);
  }
  s1k(baseClass, defaultSerializerProvider) {
    this.d1l(baseClass, defaultSerializerProvider, false);
  }
  t1k(baseClass, defaultDeserializerProvider) {
    this.e1l(baseClass, defaultDeserializerProvider, false);
  }
  a1l(module_0) {
    module_0.f1k(this);
  }
  f1l(forClass, provider, allowOverwrite) {
    if (!allowOverwrite) {
      var previous = this.u1k_1.w4(forClass);
      if (!(previous == null) && !equals(previous, provider)) {
        throw SerializerAlreadyRegisteredException.k1l('Contextual serializer or serializer provider for ' + toString(forClass) + ' already registered in this module');
      }
    }
    // Inline function 'kotlin.collections.set' call
    this.u1k_1.b5(forClass, provider);
    if (isInterface_0(forClass))
      this.z1k_1 = true;
  }
  b1l(forClass, provider, allowOverwrite, $super) {
    allowOverwrite = allowOverwrite === VOID ? false : allowOverwrite;
    var tmp;
    if ($super === VOID) {
      this.f1l(forClass, provider, allowOverwrite);
      tmp = Unit_instance;
    } else {
      tmp = $super.f1l.call(this, forClass, provider, allowOverwrite);
    }
    return tmp;
  }
  d1l(baseClass, defaultSerializerProvider, allowOverwrite) {
    var previous = this.w1k_1.w4(baseClass);
    if (!(previous == null) && !equals(previous, defaultSerializerProvider) && !allowOverwrite) {
      throw IllegalArgumentException.h2('Default serializers provider for ' + toString(baseClass) + ' is already registered: ' + toString_0(previous));
    }
    // Inline function 'kotlin.collections.set' call
    this.w1k_1.b5(baseClass, defaultSerializerProvider);
  }
  e1l(baseClass, defaultDeserializerProvider, allowOverwrite) {
    var previous = this.y1k_1.w4(baseClass);
    if (!(previous == null) && !equals(previous, defaultDeserializerProvider) && !allowOverwrite) {
      throw IllegalArgumentException.h2('Default deserializers provider for ' + toString(baseClass) + ' is already registered: ' + toString_0(previous));
    }
    // Inline function 'kotlin.collections.set' call
    this.y1k_1.b5(baseClass, defaultDeserializerProvider);
  }
  l1l(baseClass, concreteClass, concreteSerializer, allowOverwrite) {
    var name = concreteSerializer.dz().g10();
    // Inline function 'kotlin.collections.getOrPut' call
    var this_0 = this.v1k_1;
    var value = this_0.w4(baseClass);
    var tmp;
    if (value == null) {
      // Inline function 'kotlin.collections.hashMapOf' call
      var answer = HashMap.s9();
      this_0.b5(baseClass, answer);
      tmp = answer;
    } else {
      tmp = value;
    }
    var baseClassSerializers = tmp;
    // Inline function 'kotlin.collections.getOrPut' call
    var this_1 = this.x1k_1;
    var value_0 = this_1.w4(baseClass);
    var tmp_0;
    if (value_0 == null) {
      // Inline function 'kotlin.collections.hashMapOf' call
      var answer_0 = HashMap.s9();
      this_1.b5(baseClass, answer_0);
      tmp_0 = answer_0;
    } else {
      tmp_0 = value_0;
    }
    var names = tmp_0;
    var previousSerializer = baseClassSerializers.w4(concreteClass);
    if (!(previousSerializer == null) && !equals(previousSerializer, concreteSerializer)) {
      if (allowOverwrite)
        names.c5(previousSerializer.dz().g10());
      else
        throw SerializerAlreadyRegisteredException.m1l(baseClass, concreteClass);
    }
    var previousByName = names.w4(name);
    if (!(previousByName == null) && !equals(previousByName, concreteSerializer)) {
      // Inline function 'kotlin.sequences.find' call
      var tmp0 = asSequence(baseClassSerializers);
      var tmp$ret$7;
      $l$block: {
        // Inline function 'kotlin.sequences.firstOrNull' call
        var _iterator__ex2g4s = tmp0.p1();
        while (_iterator__ex2g4s.q1()) {
          var element = _iterator__ex2g4s.r1();
          if (element.k3() === previousByName) {
            tmp$ret$7 = element;
            break $l$block;
          }
        }
        tmp$ret$7 = null;
      }
      var tmp0_safe_receiver = tmp$ret$7;
      var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.j3();
      var tmp_1;
      if (tmp1_elvis_lhs == null) {
        // Inline function 'kotlin.error' call
        var message = 'Name ' + name + ' is registered in the module but no Kotlin class is associated with it.';
        throw IllegalStateException.o(toString(message));
      } else {
        tmp_1 = tmp1_elvis_lhs;
      }
      var previousClass = tmp_1;
      if (allowOverwrite)
        baseClassSerializers.c5(previousClass);
      else
        throw IllegalArgumentException.h2("Multiple polymorphic serializers in a scope of '" + toString(baseClass) + "' " + ("have the same serial name '" + name + "': " + toString(concreteSerializer) + " for '" + toString(concreteClass) + "' and " + toString_0(previousByName) + " for '" + toString(previousClass) + "'"));
    }
    // Inline function 'kotlin.collections.set' call
    baseClassSerializers.b5(concreteClass, concreteSerializer);
    // Inline function 'kotlin.collections.set' call
    names.b5(name, concreteSerializer);
  }
  c1l(baseClass, concreteClass, concreteSerializer, allowOverwrite, $super) {
    allowOverwrite = allowOverwrite === VOID ? false : allowOverwrite;
    var tmp;
    if ($super === VOID) {
      this.l1l(baseClass, concreteClass, concreteSerializer, allowOverwrite);
      tmp = Unit_instance;
    } else {
      tmp = $super.l1l.call(this, baseClass, concreteClass, concreteSerializer, allowOverwrite);
    }
    return tmp;
  }
  i19() {
    return new SerialModuleImpl(this.u1k_1, this.v1k_1, this.w1k_1, this.x1k_1, this.y1k_1, this.z1k_1);
  }
}
class SerializerAlreadyRegisteredException extends IllegalArgumentException {
  constructor(msg) {
    return new.target.k1l(msg);
  }
  static k1l(msg) {
    var $this = this.h2(msg);
    captureStack($this, $this.j1l_1);
    return $this;
  }
  static m1l(baseClass, concreteClass) {
    return this.k1l('Serializer for ' + toString(concreteClass) + ' already registered in the scope of ' + toString(baseClass));
  }
}
class SerializableWith {
  constructor(serializer) {
    this.n1l_1 = serializer;
  }
  equals(other) {
    if (!(other instanceof SerializableWith))
      return false;
    var tmp0_other_with_cast = other instanceof SerializableWith ? other : THROW_CCE();
    if (!this.n1l_1.equals(tmp0_other_with_cast.n1l_1))
      return false;
    return true;
  }
  hashCode() {
    return imul(getStringHashCode('serializer'), 127) ^ this.n1l_1.hashCode();
  }
  toString() {
    return '@kotlinx.serialization.SerializableWith(' + 'serializer=' + toString(this.n1l_1) + ')';
  }
}
class createCache$1 {
  constructor($factory) {
    this.o1l_1 = $factory;
  }
  n11(key) {
    return this.o1l_1(key);
  }
}
class createParametrizedCache$1 {
  constructor($factory) {
    this.p1l_1 = $factory;
  }
  o11(key, types) {
    // Inline function 'kotlin.runCatching' call
    var tmp;
    try {
      // Inline function 'kotlin.Companion.success' call
      var value = this.p1l_1(key, types);
      tmp = _Result___init__impl__xyqfz8(value);
    } catch ($p) {
      var tmp_0;
      if ($p instanceof Error) {
        var e = $p;
        // Inline function 'kotlin.Companion.failure' call
        tmp_0 = _Result___init__impl__xyqfz8(createFailure(e));
      } else {
        throw $p;
      }
      tmp = tmp_0;
    }
    return tmp;
  }
}
//endregion
function PolymorphicSerializer$descriptor$delegate$lambda$lambda(this$0) {
  return ($this$buildSerialDescriptor) => {
    $this$buildSerialDescriptor.oz('type', serializer_0(StringCompanionObject_instance).dz());
    $this$buildSerialDescriptor.oz('value', buildSerialDescriptor('kotlinx.serialization.Polymorphic<' + this$0.pz_1.j1() + '>', CONTEXTUAL_getInstance(), []));
    $this$buildSerialDescriptor.iz_1 = this$0.qz_1;
    return Unit_instance;
  };
}
function PolymorphicSerializer$descriptor$delegate$lambda(this$0) {
  return () => {
    var tmp = OPEN_getInstance();
    return withContext(buildSerialDescriptor('kotlinx.serialization.Polymorphic', tmp, [], PolymorphicSerializer$descriptor$delegate$lambda$lambda(this$0)), this$0.pz_1);
  };
}
function PolymorphicSerializer$_get_descriptor_$ref_8tw9if() {
  return constructCallableReference((p0) => p0.dz(), 1, 0, 0);
}
function findPolymorphicSerializer(_this__u8e3s4, decoder, klassName) {
  var tmp0_elvis_lhs = _this__u8e3s4.xz(decoder, klassName);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    throwSubtypeNotRegistered(klassName, _this__u8e3s4.uz());
  } else {
    tmp = tmp0_elvis_lhs;
  }
  return tmp;
}
function findPolymorphicSerializer_0(_this__u8e3s4, encoder, value) {
  var tmp0_elvis_lhs = _this__u8e3s4.yz(encoder, value);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    throwSubtypeNotRegistered_0(getKClassFromExpression(value), _this__u8e3s4.uz());
  } else {
    tmp = tmp0_elvis_lhs;
  }
  return tmp;
}
function SealedClassSerializer$descriptor$delegate$lambda$lambda$lambda(this$0) {
  return ($this$buildSerialDescriptor) => {
    // Inline function 'kotlin.collections.forEach' call
    // Inline function 'kotlin.collections.iterator' call
    var _iterator__ex2g4s = this$0.d10_1.i3().p1();
    while (_iterator__ex2g4s.q1()) {
      var element = _iterator__ex2g4s.r1();
      // Inline function 'kotlin.collections.component1' call
      var name = element.j3();
      // Inline function 'kotlin.collections.component2' call
      var serializer = element.k3();
      $this$buildSerialDescriptor.oz(name, serializer.dz());
    }
    return Unit_instance;
  };
}
function SealedClassSerializer$descriptor$delegate$lambda$lambda(this$0) {
  return ($this$buildSerialDescriptor) => {
    $this$buildSerialDescriptor.oz('type', serializer_0(StringCompanionObject_instance).dz());
    var tmp = 'kotlinx.serialization.Sealed<' + this$0.zz_1.j1() + '>';
    var tmp_0 = CONTEXTUAL_getInstance();
    var elementDescriptor = buildSerialDescriptor(tmp, tmp_0, [], SealedClassSerializer$descriptor$delegate$lambda$lambda$lambda(this$0));
    $this$buildSerialDescriptor.oz('value', elementDescriptor);
    $this$buildSerialDescriptor.iz_1 = this$0.a10_1;
    return Unit_instance;
  };
}
function SealedClassSerializer$descriptor$delegate$lambda($serialName, this$0) {
  return () => {
    var tmp = SEALED_getInstance();
    return buildSerialDescriptor($serialName, tmp, [], SealedClassSerializer$descriptor$delegate$lambda$lambda(this$0));
  };
}
function SealedClassSerializer$_get_descriptor_$ref_m511rz() {
  return constructCallableReference((p0) => p0.dz(), 1, 0, 1);
}
function init_kotlinx_serialization_SerializationException(_this__u8e3s4) {
  captureStack(_this__u8e3s4, _this__u8e3s4.x10_1);
}
function serializer(_this__u8e3s4, type) {
  var tmp0_elvis_lhs = serializerByKTypeImpl(_this__u8e3s4, type, true);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    platformSpecificSerializerNotRegistered(kclass(type));
  } else {
    tmp = tmp0_elvis_lhs;
  }
  return tmp;
}
function serializerByKTypeImpl(_this__u8e3s4, type, failOnMissingTypeArgSerializer) {
  var rootClass = kclass(type);
  var isNullable = type.g1();
  // Inline function 'kotlin.collections.map' call
  var this_0 = type.f1();
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList.n2(collectionSizeOrDefault(this_0, 10));
  var _iterator__ex2g4s = this_0.p1();
  while (_iterator__ex2g4s.q1()) {
    var item = _iterator__ex2g4s.r1();
    var tmp$ret$2 = typeOrThrow(item);
    destination.d2(tmp$ret$2);
  }
  var typeArguments = destination;
  var tmp;
  if (typeArguments.n1()) {
    var tmp_0;
    if (isInterface_0(rootClass) && !(_this__u8e3s4.l11(rootClass) == null)) {
      tmp_0 = null;
    } else {
      tmp_0 = findCachedSerializer(rootClass, isNullable);
    }
    tmp = tmp_0;
  } else {
    var tmp_1;
    if (_this__u8e3s4.k11()) {
      tmp_1 = null;
    } else {
      // Inline function 'kotlin.Result.getOrNull' call
      var this_1 = findParametrizedCachedSerializer(rootClass, typeArguments, isNullable);
      tmp_1 = _Result___get_isFailure__impl__jpiriv(this_1) ? null : _Result___get_value__impl__bjfvqg(this_1);
    }
    tmp = tmp_1;
  }
  var cachedSerializer = tmp;
  if (!(cachedSerializer == null))
    return cachedSerializer;
  var tmp_2;
  if (typeArguments.n1()) {
    var tmp0_elvis_lhs = serializerOrNull(rootClass);
    var tmp1_elvis_lhs = tmp0_elvis_lhs == null ? _this__u8e3s4.l11(rootClass) : tmp0_elvis_lhs;
    var tmp_3;
    if (tmp1_elvis_lhs == null) {
      // Inline function 'kotlinx.serialization.polymorphicIfInterface' call
      tmp_3 = isInterface_0(rootClass) ? PolymorphicSerializer.sz(rootClass) : null;
    } else {
      tmp_3 = tmp1_elvis_lhs;
    }
    tmp_2 = tmp_3;
  } else {
    var tmp2_elvis_lhs = serializersForParameters(_this__u8e3s4, typeArguments, failOnMissingTypeArgSerializer);
    var tmp_4;
    if (tmp2_elvis_lhs == null) {
      return null;
    } else {
      tmp_4 = tmp2_elvis_lhs;
    }
    var serializers = tmp_4;
    var tmp3_elvis_lhs = parametrizedSerializerOrNull(rootClass, serializers, serializerByKTypeImpl$lambda(typeArguments));
    var tmp4_elvis_lhs = tmp3_elvis_lhs == null ? _this__u8e3s4.m11(rootClass, serializers) : tmp3_elvis_lhs;
    var tmp_5;
    if (tmp4_elvis_lhs == null) {
      // Inline function 'kotlinx.serialization.polymorphicIfInterface' call
      tmp_5 = isInterface_0(rootClass) ? PolymorphicSerializer.sz(rootClass) : null;
    } else {
      tmp_5 = tmp4_elvis_lhs;
    }
    tmp_2 = tmp_5;
  }
  var contextualSerializer = tmp_2;
  var tmp_6;
  if (contextualSerializer == null) {
    tmp_6 = null;
  } else {
    // Inline function 'kotlinx.serialization.internal.cast' call
    tmp_6 = isInterface(contextualSerializer, KSerializer) ? contextualSerializer : THROW_CCE();
  }
  var tmp6_safe_receiver = tmp_6;
  return tmp6_safe_receiver == null ? null : nullable(tmp6_safe_receiver, isNullable);
}
function serializerOrNull(_this__u8e3s4) {
  var tmp0_elvis_lhs = compiledSerializerImpl(_this__u8e3s4);
  return tmp0_elvis_lhs == null ? builtinSerializerOrNull(_this__u8e3s4) : tmp0_elvis_lhs;
}
function serializersForParameters(_this__u8e3s4, typeArguments, failOnMissingTypeArgSerializer) {
  var tmp;
  if (failOnMissingTypeArgSerializer) {
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.n2(collectionSizeOrDefault(typeArguments, 10));
    var _iterator__ex2g4s = typeArguments.p1();
    while (_iterator__ex2g4s.q1()) {
      var item = _iterator__ex2g4s.r1();
      var tmp$ret$2 = serializer(_this__u8e3s4, item);
      destination.d2(tmp$ret$2);
    }
    tmp = destination;
  } else {
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination_0 = ArrayList.n2(collectionSizeOrDefault(typeArguments, 10));
    var _iterator__ex2g4s_0 = typeArguments.p1();
    while (_iterator__ex2g4s_0.q1()) {
      var item_0 = _iterator__ex2g4s_0.r1();
      var tmp0_elvis_lhs = serializerOrNull_0(_this__u8e3s4, item_0);
      var tmp_0;
      if (tmp0_elvis_lhs == null) {
        return null;
      } else {
        tmp_0 = tmp0_elvis_lhs;
      }
      var tmp$ret$5 = tmp_0;
      destination_0.d2(tmp$ret$5);
    }
    tmp = destination_0;
  }
  var serializers = tmp;
  return serializers;
}
function parametrizedSerializerOrNull(_this__u8e3s4, serializers, elementClassifierIfArray) {
  var tmp0_elvis_lhs = builtinParametrizedSerializer(_this__u8e3s4, serializers, elementClassifierIfArray);
  return tmp0_elvis_lhs == null ? compiledParametrizedSerializer(_this__u8e3s4, serializers) : tmp0_elvis_lhs;
}
function nullable(_this__u8e3s4, shouldBeNullable) {
  if (shouldBeNullable)
    return get_nullable(_this__u8e3s4);
  return isInterface(_this__u8e3s4, KSerializer) ? _this__u8e3s4 : THROW_CCE();
}
function serializerOrNull_0(_this__u8e3s4, type) {
  return serializerByKTypeImpl(_this__u8e3s4, type, false);
}
function builtinParametrizedSerializer(_this__u8e3s4, serializers, elementClassifierIfArray) {
  var tmp;
  if (_this__u8e3s4.equals(getKClass(Collection)) || _this__u8e3s4.equals(getKClass(KtList)) || (_this__u8e3s4.equals(getKClass(KtMutableList)) || _this__u8e3s4.equals(getKClass(ArrayList)))) {
    tmp = new ArrayListSerializer(serializers.u2(0));
  } else if (_this__u8e3s4.equals(getKClass(HashSet))) {
    tmp = new HashSetSerializer(serializers.u2(0));
  } else if (_this__u8e3s4.equals(getKClass(KtSet)) || (_this__u8e3s4.equals(getKClass(KtMutableSet)) || _this__u8e3s4.equals(getKClass(LinkedHashSet)))) {
    tmp = new LinkedHashSetSerializer(serializers.u2(0));
  } else if (_this__u8e3s4.equals(getKClass(HashMap))) {
    tmp = new HashMapSerializer(serializers.u2(0), serializers.u2(1));
  } else if (_this__u8e3s4.equals(getKClass(KtMap)) || (_this__u8e3s4.equals(getKClass(KtMutableMap)) || _this__u8e3s4.equals(getKClass(LinkedHashMap)))) {
    tmp = new LinkedHashMapSerializer(serializers.u2(0), serializers.u2(1));
  } else if (_this__u8e3s4.equals(getKClass(Entry))) {
    tmp = MapEntrySerializer_0(serializers.u2(0), serializers.u2(1));
  } else if (_this__u8e3s4.equals(getKClass(Pair))) {
    tmp = PairSerializer_0(serializers.u2(0), serializers.u2(1));
  } else if (_this__u8e3s4.equals(getKClass(Triple))) {
    tmp = TripleSerializer_0(serializers.u2(0), serializers.u2(1), serializers.u2(2));
  } else {
    var tmp_0;
    if (isReferenceArray(_this__u8e3s4)) {
      var tmp_1 = elementClassifierIfArray();
      tmp_0 = ArraySerializer((!(tmp_1 == null) ? isInterface(tmp_1, KClass) : false) ? tmp_1 : THROW_CCE(), serializers.u2(0));
    } else {
      tmp_0 = null;
    }
    tmp = tmp_0;
  }
  return tmp;
}
function compiledParametrizedSerializer(_this__u8e3s4, serializers) {
  // Inline function 'kotlin.collections.toTypedArray' call
  var tmp$ret$0 = copyToArray(serializers);
  return constructSerializerForGivenTypeArgs(_this__u8e3s4, tmp$ret$0.slice());
}
function serializerByKTypeImpl$lambda($typeArguments) {
  return () => $typeArguments.u2(0).e1();
}
function get_SERIALIZERS_CACHE() {
  _init_properties_SerializersCache_kt__hgwi2p();
  return SERIALIZERS_CACHE;
}
var SERIALIZERS_CACHE;
function get_SERIALIZERS_CACHE_NULLABLE() {
  _init_properties_SerializersCache_kt__hgwi2p();
  return SERIALIZERS_CACHE_NULLABLE;
}
var SERIALIZERS_CACHE_NULLABLE;
function get_PARAMETRIZED_SERIALIZERS_CACHE() {
  _init_properties_SerializersCache_kt__hgwi2p();
  return PARAMETRIZED_SERIALIZERS_CACHE;
}
var PARAMETRIZED_SERIALIZERS_CACHE;
function get_PARAMETRIZED_SERIALIZERS_CACHE_NULLABLE() {
  _init_properties_SerializersCache_kt__hgwi2p();
  return PARAMETRIZED_SERIALIZERS_CACHE_NULLABLE;
}
var PARAMETRIZED_SERIALIZERS_CACHE_NULLABLE;
function findCachedSerializer(clazz, isNullable) {
  _init_properties_SerializersCache_kt__hgwi2p();
  var tmp;
  if (!isNullable) {
    var tmp0_safe_receiver = get_SERIALIZERS_CACHE().n11(clazz);
    var tmp_0;
    if (tmp0_safe_receiver == null) {
      tmp_0 = null;
    } else {
      // Inline function 'kotlinx.serialization.internal.cast' call
      tmp_0 = isInterface(tmp0_safe_receiver, KSerializer) ? tmp0_safe_receiver : THROW_CCE();
    }
    tmp = tmp_0;
  } else {
    tmp = get_SERIALIZERS_CACHE_NULLABLE().n11(clazz);
  }
  return tmp;
}
function findParametrizedCachedSerializer(clazz, types, isNullable) {
  _init_properties_SerializersCache_kt__hgwi2p();
  var tmp;
  if (!isNullable) {
    var tmp_0 = get_PARAMETRIZED_SERIALIZERS_CACHE().o11(clazz, types);
    tmp = new Result(tmp_0) instanceof Result ? tmp_0 : THROW_CCE();
  } else {
    tmp = get_PARAMETRIZED_SERIALIZERS_CACHE_NULLABLE().o11(clazz, types);
  }
  return tmp;
}
function SERIALIZERS_CACHE$lambda(it) {
  _init_properties_SerializersCache_kt__hgwi2p();
  var tmp0_elvis_lhs = serializerOrNull(it);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    // Inline function 'kotlinx.serialization.polymorphicIfInterface' call
    tmp = isInterface_0(it) ? PolymorphicSerializer.sz(it) : null;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  return tmp;
}
function SERIALIZERS_CACHE_NULLABLE$lambda(it) {
  _init_properties_SerializersCache_kt__hgwi2p();
  var tmp0_elvis_lhs = serializerOrNull(it);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    // Inline function 'kotlinx.serialization.polymorphicIfInterface' call
    tmp = isInterface_0(it) ? PolymorphicSerializer.sz(it) : null;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var tmp1_safe_receiver = tmp;
  var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : get_nullable(tmp1_safe_receiver);
  var tmp_0;
  if (tmp2_safe_receiver == null) {
    tmp_0 = null;
  } else {
    // Inline function 'kotlinx.serialization.internal.cast' call
    tmp_0 = isInterface(tmp2_safe_receiver, KSerializer) ? tmp2_safe_receiver : THROW_CCE();
  }
  return tmp_0;
}
function PARAMETRIZED_SERIALIZERS_CACHE$lambda(clazz, types) {
  _init_properties_SerializersCache_kt__hgwi2p();
  var serializers = ensureNotNull(serializersForParameters(EmptySerializersModule_0(), types, true));
  return parametrizedSerializerOrNull(clazz, serializers, PARAMETRIZED_SERIALIZERS_CACHE$lambda$lambda(types));
}
function PARAMETRIZED_SERIALIZERS_CACHE$lambda$lambda($types) {
  return () => $types.u2(0).e1();
}
function PARAMETRIZED_SERIALIZERS_CACHE_NULLABLE$lambda(clazz, types) {
  _init_properties_SerializersCache_kt__hgwi2p();
  var serializers = ensureNotNull(serializersForParameters(EmptySerializersModule_0(), types, true));
  var tmp0_safe_receiver = parametrizedSerializerOrNull(clazz, serializers, PARAMETRIZED_SERIALIZERS_CACHE_NULLABLE$lambda$lambda(types));
  var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : get_nullable(tmp0_safe_receiver);
  var tmp;
  if (tmp1_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlinx.serialization.internal.cast' call
    tmp = isInterface(tmp1_safe_receiver, KSerializer) ? tmp1_safe_receiver : THROW_CCE();
  }
  return tmp;
}
function PARAMETRIZED_SERIALIZERS_CACHE_NULLABLE$lambda$lambda($types) {
  return () => $types.u2(0).e1();
}
var properties_initialized_SerializersCache_kt_q8kf25;
function _init_properties_SerializersCache_kt__hgwi2p() {
  if (!properties_initialized_SerializersCache_kt_q8kf25) {
    properties_initialized_SerializersCache_kt_q8kf25 = true;
    SERIALIZERS_CACHE = createCache(SERIALIZERS_CACHE$lambda);
    SERIALIZERS_CACHE_NULLABLE = createCache(SERIALIZERS_CACHE_NULLABLE$lambda);
    PARAMETRIZED_SERIALIZERS_CACHE = createParametrizedCache(PARAMETRIZED_SERIALIZERS_CACHE$lambda);
    PARAMETRIZED_SERIALIZERS_CACHE_NULLABLE = createParametrizedCache(PARAMETRIZED_SERIALIZERS_CACHE_NULLABLE$lambda);
  }
}
function get_nullable(_this__u8e3s4) {
  var tmp;
  if (_this__u8e3s4.dz().p11()) {
    tmp = isInterface(_this__u8e3s4, KSerializer) ? _this__u8e3s4 : THROW_CCE();
  } else {
    tmp = new NullableSerializer(_this__u8e3s4);
  }
  return tmp;
}
function serializer_0(_this__u8e3s4) {
  return StringSerializer_getInstance();
}
function serializer_1(_this__u8e3s4) {
  return ULongSerializer_getInstance();
}
function MapSerializer(keySerializer, valueSerializer) {
  return new LinkedHashMapSerializer(keySerializer, valueSerializer);
}
function ListSerializer(elementSerializer) {
  return new ArrayListSerializer(elementSerializer);
}
function serializer_2(_this__u8e3s4) {
  return UIntSerializer_getInstance();
}
function serializer_3(_this__u8e3s4) {
  return UByteSerializer_getInstance();
}
function serializer_4(_this__u8e3s4) {
  return UShortSerializer_getInstance();
}
function MapEntrySerializer_0(keySerializer, valueSerializer) {
  return new MapEntrySerializer(keySerializer, valueSerializer);
}
function PairSerializer_0(keySerializer, valueSerializer) {
  return new PairSerializer(keySerializer, valueSerializer);
}
function TripleSerializer_0(aSerializer, bSerializer, cSerializer) {
  return new TripleSerializer(aSerializer, bSerializer, cSerializer);
}
function ArraySerializer(kClass, elementSerializer) {
  return new ReferenceArraySerializer(kClass, elementSerializer);
}
function serializer_5(_this__u8e3s4) {
  return LongSerializer_getInstance();
}
function serializer_6(_this__u8e3s4) {
  return IntSerializer_getInstance();
}
function serializer_7(_this__u8e3s4) {
  return ByteSerializer_getInstance();
}
function serializer_8(_this__u8e3s4) {
  return ShortSerializer_getInstance();
}
function serializer_9(_this__u8e3s4) {
  return CharSerializer_getInstance();
}
function CharArraySerializer_0() {
  return CharArraySerializer_getInstance();
}
function serializer_10(_this__u8e3s4) {
  return DoubleSerializer_getInstance();
}
function DoubleArraySerializer_0() {
  return DoubleArraySerializer_getInstance();
}
function serializer_11(_this__u8e3s4) {
  return FloatSerializer_getInstance();
}
function FloatArraySerializer_0() {
  return FloatArraySerializer_getInstance();
}
function LongArraySerializer_0() {
  return LongArraySerializer_getInstance();
}
function ULongArraySerializer_0() {
  return ULongArraySerializer_getInstance();
}
function IntArraySerializer_0() {
  return IntArraySerializer_getInstance();
}
function UIntArraySerializer_0() {
  return UIntArraySerializer_getInstance();
}
function ShortArraySerializer_0() {
  return ShortArraySerializer_getInstance();
}
function UShortArraySerializer_0() {
  return UShortArraySerializer_getInstance();
}
function ByteArraySerializer_0() {
  return ByteArraySerializer_getInstance();
}
function UByteArraySerializer_0() {
  return UByteArraySerializer_getInstance();
}
function serializer_12(_this__u8e3s4) {
  return BooleanSerializer_getInstance();
}
function BooleanArraySerializer_0() {
  return BooleanArraySerializer_getInstance();
}
function serializer_13(_this__u8e3s4) {
  return UnitSerializer_getInstance();
}
function NothingSerializer_0() {
  return NothingSerializer_getInstance();
}
function serializer_14(_this__u8e3s4) {
  return DurationSerializer_getInstance();
}
function serializer_15(_this__u8e3s4) {
  return InstantSerializer_getInstance();
}
function serializer_16(_this__u8e3s4) {
  return UuidSerializer_getInstance();
}
function getContextualDescriptor(_this__u8e3s4, descriptor) {
  var tmp0_safe_receiver = get_capturedKClass(descriptor);
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    var tmp0_safe_receiver_0 = _this__u8e3s4.l11(tmp0_safe_receiver);
    tmp = tmp0_safe_receiver_0 == null ? null : tmp0_safe_receiver_0.dz();
  }
  return tmp;
}
function withContext(_this__u8e3s4, context) {
  return new ContextDescriptor(_this__u8e3s4, context);
}
function get_capturedKClass(_this__u8e3s4) {
  var tmp;
  if (_this__u8e3s4 instanceof ContextDescriptor) {
    tmp = _this__u8e3s4.u11_1;
  } else {
    if (_this__u8e3s4 instanceof SerialDescriptorForNullable) {
      tmp = get_capturedKClass(_this__u8e3s4.q11_1);
    } else {
      tmp = null;
    }
  }
  return tmp;
}
function get_elementNames(_this__u8e3s4) {
  // Inline function 'kotlin.collections.Iterable' call
  return new elementNames$$inlined$Iterable$1(_this__u8e3s4);
}
function get_elementDescriptors(_this__u8e3s4) {
  // Inline function 'kotlin.collections.Iterable' call
  return new elementDescriptors$$inlined$Iterable$1(_this__u8e3s4);
}
function PrimitiveSerialDescriptor_0(serialName, kind) {
  // Inline function 'kotlin.text.isNotBlank' call
  // Inline function 'kotlin.require' call
  if (!!isBlank(serialName)) {
    var message = 'Blank serial names are prohibited';
    throw IllegalArgumentException.h2(toString(message));
  }
  return PrimitiveDescriptorSafe(serialName, kind);
}
function buildSerialDescriptor(serialName, kind, typeParameters, builder) {
  var tmp;
  if (builder === VOID) {
    tmp = buildSerialDescriptor$lambda;
  } else {
    tmp = builder;
  }
  builder = tmp;
  // Inline function 'kotlin.text.isNotBlank' call
  // Inline function 'kotlin.require' call
  if (!!isBlank(serialName)) {
    var message = 'Blank serial names are prohibited';
    throw IllegalArgumentException.h2(toString(message));
  }
  // Inline function 'kotlin.require' call
  if (!!equals(kind, CLASS_getInstance())) {
    var message_0 = "For StructureKind.CLASS please use 'buildClassSerialDescriptor' instead";
    throw IllegalArgumentException.h2(toString(message_0));
  }
  var sdBuilder = new ClassSerialDescriptorBuilder(serialName);
  builder(sdBuilder);
  return new SerialDescriptorImpl(serialName, kind, sdBuilder.jz_1.s2(), toList(typeParameters), sdBuilder);
}
function _get__hashCode__tgwhef($this) {
  var tmp0 = $this.x12_1;
  var tmp = KProperty1;
  // Inline function 'kotlin.getValue' call
  getPropertyCallableRef('_hashCode', 1, tmp, SerialDescriptorImpl$_get__hashCode_$ref_2v7wzp(), null);
  return tmp0.k3();
}
function SerialDescriptorImpl$_hashCode$delegate$lambda(this$0) {
  return () => hashCodeImpl(this$0, this$0.w12_1);
}
function SerialDescriptorImpl$_get__hashCode_$ref_2v7wzp() {
  return constructCallableReference((p0) => _get__hashCode__tgwhef(p0), 1, 0, 2);
}
function buildClassSerialDescriptor(serialName, typeParameters, builderAction) {
  var tmp;
  if (builderAction === VOID) {
    tmp = buildClassSerialDescriptor$lambda;
  } else {
    tmp = builderAction;
  }
  builderAction = tmp;
  // Inline function 'kotlin.text.isNotBlank' call
  // Inline function 'kotlin.require' call
  if (!!isBlank(serialName)) {
    var message = 'Blank serial names are prohibited';
    throw IllegalArgumentException.h2(toString(message));
  }
  var sdBuilder = new ClassSerialDescriptorBuilder(serialName);
  builderAction(sdBuilder);
  return new SerialDescriptorImpl(serialName, CLASS_getInstance(), sdBuilder.jz_1.s2(), toList(typeParameters), sdBuilder);
}
function buildSerialDescriptor$lambda(_this__u8e3s4) {
  return Unit_instance;
}
function buildClassSerialDescriptor$lambda(_this__u8e3s4) {
  return Unit_instance;
}
var BOOLEAN_instance;
function BOOLEAN_getInstance() {
  if (BOOLEAN_instance === VOID)
    new BOOLEAN();
  return BOOLEAN_instance;
}
var BYTE_instance;
function BYTE_getInstance() {
  if (BYTE_instance === VOID)
    new BYTE();
  return BYTE_instance;
}
var CHAR_instance;
function CHAR_getInstance() {
  if (CHAR_instance === VOID)
    new CHAR();
  return CHAR_instance;
}
var SHORT_instance;
function SHORT_getInstance() {
  if (SHORT_instance === VOID)
    new SHORT();
  return SHORT_instance;
}
var INT_instance;
function INT_getInstance() {
  if (INT_instance === VOID)
    new INT();
  return INT_instance;
}
var LONG_instance;
function LONG_getInstance() {
  if (LONG_instance === VOID)
    new LONG();
  return LONG_instance;
}
var FLOAT_instance;
function FLOAT_getInstance() {
  if (FLOAT_instance === VOID)
    new FLOAT();
  return FLOAT_instance;
}
var DOUBLE_instance;
function DOUBLE_getInstance() {
  if (DOUBLE_instance === VOID)
    new DOUBLE();
  return DOUBLE_instance;
}
var STRING_instance;
function STRING_getInstance() {
  if (STRING_instance === VOID)
    new STRING();
  return STRING_instance;
}
var SEALED_instance;
function SEALED_getInstance() {
  if (SEALED_instance === VOID)
    new SEALED();
  return SEALED_instance;
}
var OPEN_instance;
function OPEN_getInstance() {
  if (OPEN_instance === VOID)
    new OPEN();
  return OPEN_instance;
}
var ENUM_instance;
function ENUM_getInstance() {
  if (ENUM_instance === VOID)
    new ENUM();
  return ENUM_instance;
}
var CONTEXTUAL_instance;
function CONTEXTUAL_getInstance() {
  if (CONTEXTUAL_instance === VOID)
    new CONTEXTUAL();
  return CONTEXTUAL_instance;
}
var CLASS_instance;
function CLASS_getInstance() {
  if (CLASS_instance === VOID)
    new CLASS();
  return CLASS_instance;
}
var LIST_instance;
function LIST_getInstance() {
  if (LIST_instance === VOID)
    new LIST();
  return LIST_instance;
}
var MAP_instance;
function MAP_getInstance() {
  if (MAP_instance === VOID)
    new MAP();
  return MAP_instance;
}
var OBJECT_instance;
function OBJECT_getInstance() {
  if (OBJECT_instance === VOID)
    new OBJECT();
  return OBJECT_instance;
}
function decodeSequentially_0($this, compositeDecoder) {
  var klassName = compositeDecoder.z13($this.dz(), 0);
  var serializer = findPolymorphicSerializer($this, compositeDecoder, klassName);
  return compositeDecoder.c14($this.dz(), 1, serializer);
}
function throwSubtypeNotRegistered(subClassName, baseClass) {
  var scope = "in the polymorphic scope of '" + baseClass.j1() + "'";
  throw SerializationException.y10(subClassName == null ? 'Class discriminator was missing and no default serializers were registered ' + scope + '.' : "Serializer for subclass '" + subClassName + "' is not found " + scope + '.\n' + ("Check if class with serial name '" + subClassName + "' exists and serializer is registered in a corresponding SerializersModule.\n") + ("To be registered automatically, class '" + subClassName + "' has to be '@Serializable', and the base class '" + baseClass.j1() + "' has to be sealed and '@Serializable'."));
}
function throwSubtypeNotRegistered_0(subClass, baseClass) {
  var tmp0_elvis_lhs = subClass.j1();
  throwSubtypeNotRegistered(tmp0_elvis_lhs == null ? toString(subClass) : tmp0_elvis_lhs, baseClass);
}
var NothingSerializer_instance;
function NothingSerializer_getInstance() {
  if (NothingSerializer_instance === VOID)
    new NothingSerializer();
  return NothingSerializer_instance;
}
var DurationSerializer_instance;
function DurationSerializer_getInstance() {
  if (DurationSerializer_instance === VOID)
    new DurationSerializer();
  return DurationSerializer_instance;
}
var InstantSerializer_instance;
function InstantSerializer_getInstance() {
  if (InstantSerializer_instance === VOID)
    new InstantSerializer();
  return InstantSerializer_instance;
}
var UuidSerializer_instance;
function UuidSerializer_getInstance() {
  if (UuidSerializer_instance === VOID)
    new UuidSerializer();
  return UuidSerializer_instance;
}
function readSize($this, decoder, builder) {
  var size = decoder.g14($this.dz());
  $this.z16(builder, size);
  return size;
}
var Companion_instance_0;
function Companion_getInstance_8() {
  if (Companion_instance_0 === VOID)
    new Companion();
  return Companion_instance_0;
}
function prepareHighMarksArray($this, elementsCount) {
  var slotsCount = (elementsCount - 1 | 0) >>> 6 | 0;
  var elementsInLastSlot = elementsCount & 63;
  var highMarks = longArray(slotsCount);
  if (!(elementsInLastSlot === 0)) {
    highMarks[get_lastIndex(highMarks)] = shiftLeft(new Long(-1, -1), elementsCount);
  }
  return highMarks;
}
function markHigh($this, index) {
  var slot = (index >>> 6 | 0) - 1 | 0;
  var offsetInSlot = index & 63;
  $this.w19_1[slot] = bitwiseOr($this.w19_1[slot], shiftLeft(new Long(1, 0), offsetInSlot));
}
function nextUnmarkedHighIndex($this) {
  var inductionVariable = 0;
  var last = $this.w19_1.length - 1 | 0;
  if (inductionVariable <= last)
    do {
      var slot = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var slotOffset = imul(slot + 1 | 0, 64);
      var slotMarks = $this.w19_1[slot];
      while (!equalsLong(slotMarks, new Long(-1, -1))) {
        var indexInSlot = countTrailingZeroBits(invert(slotMarks));
        slotMarks = bitwiseOr(slotMarks, shiftLeft(new Long(1, 0), indexInSlot));
        var index = slotOffset + indexInSlot | 0;
        if ($this.u19_1($this.t19_1, index)) {
          $this.w19_1[slot] = slotMarks;
          return index;
        }
      }
      $this.w19_1[slot] = slotMarks;
    }
     while (inductionVariable <= last);
  return -1;
}
function createSimpleEnumSerializer(serialName, values) {
  return EnumSerializer.c1a(serialName, values);
}
function createUnmarkedDescriptor($this, serialName) {
  var d = new EnumDescriptor(serialName, $this.z19_1.length);
  // Inline function 'kotlin.collections.forEach' call
  var indexedObject = $this.z19_1;
  var inductionVariable = 0;
  var last = indexedObject.length;
  while (inductionVariable < last) {
    var element = indexedObject[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    d.p1a(element.v1_1);
  }
  return d;
}
function EnumSerializer$descriptor$delegate$lambda(this$0, $serialName) {
  return () => {
    var tmp0_elvis_lhs = this$0.a1a_1;
    return tmp0_elvis_lhs == null ? createUnmarkedDescriptor(this$0, $serialName) : tmp0_elvis_lhs;
  };
}
function EnumSerializer$_get_descriptor_$ref_j67dlw() {
  return constructCallableReference((p0) => p0.dz(), 1, 0, 3);
}
function _get_elementDescriptors__y23q9p($this) {
  var tmp0 = $this.f1b_1;
  var tmp = KProperty1;
  // Inline function 'kotlin.getValue' call
  getPropertyCallableRef('elementDescriptors', 1, tmp, EnumDescriptor$_get_elementDescriptors_$ref_5lvk4a(), null);
  return tmp0.k3();
}
function EnumDescriptor$elementDescriptors$delegate$lambda($elementsCount, $name, this$0) {
  return () => {
    var tmp = 0;
    var tmp_0 = $elementsCount;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_1 = Array(tmp_0);
    while (tmp < tmp_0) {
      var tmp_2 = tmp;
      tmp_1[tmp_2] = buildSerialDescriptor($name + '.' + this$0.a12(tmp_2), OBJECT_getInstance(), []);
      tmp = tmp + 1 | 0;
    }
    return tmp_1;
  };
}
function EnumDescriptor$_get_elementDescriptors_$ref_5lvk4a() {
  return constructCallableReference((p0) => _get_elementDescriptors__y23q9p(p0), 1, 0, 4);
}
function createAnnotatedEnumSerializer(serialName, values, names, entryAnnotations, classAnnotations) {
  var descriptor = new EnumDescriptor(serialName, values.length);
  if (classAnnotations == null)
    null;
  else {
    // Inline function 'kotlin.collections.forEach' call
    var inductionVariable = 0;
    var last = classAnnotations.length;
    while (inductionVariable < last) {
      var element = classAnnotations[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      descriptor.j1b(element);
    }
  }
  // Inline function 'kotlin.collections.forEachIndexed' call
  var index = 0;
  var inductionVariable_0 = 0;
  var last_0 = values.length;
  while (inductionVariable_0 < last_0) {
    var item = values[inductionVariable_0];
    inductionVariable_0 = inductionVariable_0 + 1 | 0;
    var _unary__edvuaz = index;
    index = _unary__edvuaz + 1 | 0;
    var tmp0_elvis_lhs = getOrNull(names, _unary__edvuaz);
    var elementName = tmp0_elvis_lhs == null ? item.v1_1 : tmp0_elvis_lhs;
    descriptor.p1a(elementName);
    var tmp1_safe_receiver = getOrNull(entryAnnotations, _unary__edvuaz);
    if (tmp1_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.collections.forEach' call
      var inductionVariable_1 = 0;
      var last_1 = tmp1_safe_receiver.length;
      while (inductionVariable_1 < last_1) {
        var element_0 = tmp1_safe_receiver[inductionVariable_1];
        inductionVariable_1 = inductionVariable_1 + 1 | 0;
        descriptor.i1b(element_0);
      }
    }
  }
  return EnumSerializer.q1a(serialName, values, descriptor);
}
function InlinePrimitiveDescriptor(name, primitiveSerializer) {
  return new InlineClassDescriptor(name, new InlinePrimitiveDescriptor$1(primitiveSerializer));
}
function jsonCachedSerialNames(_this__u8e3s4) {
  return cachedSerialNames(_this__u8e3s4);
}
var NoOpEncoder_instance;
function NoOpEncoder_getInstance() {
  if (NoOpEncoder_instance === VOID)
    NoOpEncoder.b1c();
  return NoOpEncoder_instance;
}
function error($this) {
  throw IllegalStateException.o('Descriptor for type `kotlin.Nothing` does not have elements');
}
var NothingSerialDescriptor_instance;
function NothingSerialDescriptor_getInstance() {
  if (NothingSerialDescriptor_instance === VOID)
    new NothingSerialDescriptor();
  return NothingSerialDescriptor_instance;
}
function ObjectSerializer$descriptor$delegate$lambda$lambda(this$0) {
  return ($this$buildSerialDescriptor) => {
    $this$buildSerialDescriptor.iz_1 = this$0.i1c_1;
    return Unit_instance;
  };
}
function ObjectSerializer$descriptor$delegate$lambda($serialName, this$0) {
  return () => {
    var tmp = OBJECT_getInstance();
    return buildSerialDescriptor($serialName, tmp, [], ObjectSerializer$descriptor$delegate$lambda$lambda(this$0));
  };
}
function ObjectSerializer$_get_descriptor_$ref_7z4xb6() {
  return constructCallableReference((p0) => p0.dz(), 1, 0, 5);
}
function get_EMPTY_DESCRIPTOR_ARRAY() {
  _init_properties_Platform_common_kt__3qzecs();
  return EMPTY_DESCRIPTOR_ARRAY;
}
var EMPTY_DESCRIPTOR_ARRAY;
function kclass(_this__u8e3s4) {
  _init_properties_Platform_common_kt__3qzecs();
  var t = _this__u8e3s4.e1();
  var tmp;
  if (!(t == null) ? isInterface(t, KClass) : false) {
    tmp = t;
  } else {
    if (!(t == null) ? isInterface(t, KTypeParameter) : false) {
      throw IllegalArgumentException.h2('Captured type parameter ' + toString(t) + ' from generic non-reified function. ' + ('Such functionality cannot be supported because ' + toString(t) + ' is erased, either specify serializer explicitly or make ') + ('calling function inline with reified ' + toString(t) + '.'));
    } else {
      throw IllegalArgumentException.h2('Only KClass supported as classifier, got ' + toString_0(t));
    }
  }
  var tmp_0 = tmp;
  return isInterface(tmp_0, KClass) ? tmp_0 : THROW_CCE();
}
function typeOrThrow(_this__u8e3s4) {
  _init_properties_Platform_common_kt__3qzecs();
  var tmp0 = _this__u8e3s4.ft_1;
  var tmp$ret$0;
  $l$block: {
    // Inline function 'kotlin.requireNotNull' call
    if (tmp0 == null) {
      var message = 'Star projections in type arguments are not allowed, but had ' + toString_0(_this__u8e3s4.ft_1);
      throw IllegalArgumentException.h2(toString(message));
    } else {
      tmp$ret$0 = tmp0;
      break $l$block;
    }
  }
  return tmp$ret$0;
}
function compactArray(_this__u8e3s4) {
  _init_properties_Platform_common_kt__3qzecs();
  // Inline function 'kotlin.takeUnless' call
  var tmp;
  // Inline function 'kotlin.collections.isNullOrEmpty' call
  if (!(_this__u8e3s4 == null || _this__u8e3s4.n1())) {
    tmp = _this__u8e3s4;
  } else {
    tmp = null;
  }
  var tmp0_safe_receiver = tmp;
  var tmp_0;
  if (tmp0_safe_receiver == null) {
    tmp_0 = null;
  } else {
    // Inline function 'kotlin.collections.toTypedArray' call
    tmp_0 = copyToArray(tmp0_safe_receiver);
  }
  var tmp1_elvis_lhs = tmp_0;
  return tmp1_elvis_lhs == null ? get_EMPTY_DESCRIPTOR_ARRAY() : tmp1_elvis_lhs;
}
function cachedSerialNames(_this__u8e3s4) {
  _init_properties_Platform_common_kt__3qzecs();
  if (isInterface(_this__u8e3s4, CachedNames))
    return _this__u8e3s4.y12();
  var result = HashSet.b3(_this__u8e3s4.y11());
  var inductionVariable = 0;
  var last = _this__u8e3s4.y11();
  if (inductionVariable < last)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'kotlin.collections.plusAssign' call
      var element = _this__u8e3s4.a12(i);
      result.d2(element);
    }
     while (inductionVariable < last);
  return result;
}
function notRegisteredMessage(_this__u8e3s4) {
  _init_properties_Platform_common_kt__3qzecs();
  var tmp0_elvis_lhs = _this__u8e3s4.j1();
  return notRegisteredMessage_0(tmp0_elvis_lhs == null ? '<local class name not available>' : tmp0_elvis_lhs);
}
function notRegisteredMessage_0(className) {
  _init_properties_Platform_common_kt__3qzecs();
  return "Serializer for class '" + className + "' is not found.\n" + "Please ensure that class is marked as '@Serializable' and that the serialization compiler plugin is applied.\n";
}
var properties_initialized_Platform_common_kt_i7q4ty;
function _init_properties_Platform_common_kt__3qzecs() {
  if (!properties_initialized_Platform_common_kt_i7q4ty) {
    properties_initialized_Platform_common_kt_i7q4ty = true;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    EMPTY_DESCRIPTOR_ARRAY = [];
  }
}
function throwMissingFieldException(seen, goldenMask, descriptor) {
  // Inline function 'kotlin.collections.mutableListOf' call
  var missingFields = ArrayList.p2();
  var missingFieldsBits = goldenMask & ~seen;
  var inductionVariable = 0;
  if (inductionVariable < 32)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      if (!((missingFieldsBits & 1) === 0)) {
        // Inline function 'kotlin.collections.plusAssign' call
        var element = descriptor.a12(i);
        missingFields.d2(element);
      }
      missingFieldsBits = missingFieldsBits >>> 1 | 0;
    }
     while (inductionVariable < 32);
  throw MissingFieldException.j11(missingFields, descriptor.g10());
}
function throwArrayMissingFieldException(seenArray, goldenMaskArray, descriptor) {
  // Inline function 'kotlin.collections.mutableListOf' call
  var missingFields = ArrayList.p2();
  var inductionVariable = 0;
  var last = goldenMaskArray.length - 1 | 0;
  if (inductionVariable <= last)
    do {
      var maskSlot = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var missingFieldsBits = goldenMaskArray[maskSlot] & ~seenArray[maskSlot];
      if (!(missingFieldsBits === 0)) {
        var inductionVariable_0 = 0;
        if (inductionVariable_0 < 32)
          do {
            var i = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            if (!((missingFieldsBits & 1) === 0)) {
              // Inline function 'kotlin.collections.plusAssign' call
              var element = descriptor.a12(imul(maskSlot, 32) + i | 0);
              missingFields.d2(element);
            }
            missingFieldsBits = missingFieldsBits >>> 1 | 0;
          }
           while (inductionVariable_0 < 32);
      }
    }
     while (inductionVariable <= last);
  throw MissingFieldException.j11(missingFields, descriptor.g10());
}
function _get_childSerializers__7vnyfa($this) {
  var tmp0 = $this.m1a_1;
  var tmp = KProperty1;
  // Inline function 'kotlin.getValue' call
  getPropertyCallableRef('childSerializers', 1, tmp, PluginGeneratedSerialDescriptor$_get_childSerializers_$ref_e7suca(), null);
  return tmp0.k3();
}
function _get__hashCode__tgwhef_0($this) {
  var tmp0 = $this.o1a_1;
  var tmp = KProperty1;
  // Inline function 'kotlin.getValue' call
  getPropertyCallableRef('_hashCode', 1, tmp, PluginGeneratedSerialDescriptor$_get__hashCode_$ref_cmj4vz(), null);
  return tmp0.k3();
}
function buildIndices($this) {
  var indices = HashMap.s9();
  var inductionVariable = 0;
  var last = $this.h1a_1.length - 1 | 0;
  if (inductionVariable <= last)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'kotlin.collections.set' call
      var key = $this.h1a_1[i];
      indices.b5(key, i);
    }
     while (inductionVariable <= last);
  return indices;
}
function PluginGeneratedSerialDescriptor$childSerializers$delegate$lambda(this$0) {
  return () => {
    var tmp0_safe_receiver = this$0.e1a_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.y1b();
    return tmp1_elvis_lhs == null ? get_EMPTY_SERIALIZER_ARRAY() : tmp1_elvis_lhs;
  };
}
function PluginGeneratedSerialDescriptor$_get_childSerializers_$ref_e7suca() {
  return constructCallableReference((p0) => _get_childSerializers__7vnyfa(p0), 1, 0, 6);
}
function PluginGeneratedSerialDescriptor$typeParameterDescriptors$delegate$lambda(this$0) {
  return () => {
    var tmp0_safe_receiver = this$0.e1a_1;
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.z1b();
    var tmp;
    if (tmp1_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.collections.map' call
      // Inline function 'kotlin.collections.mapTo' call
      var destination = ArrayList.n2(tmp1_safe_receiver.length);
      var inductionVariable = 0;
      var last = tmp1_safe_receiver.length;
      while (inductionVariable < last) {
        var item = tmp1_safe_receiver[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        var tmp$ret$2 = item.dz();
        destination.d2(tmp$ret$2);
      }
      tmp = destination;
    }
    return compactArray(tmp);
  };
}
function PluginGeneratedSerialDescriptor$_get_typeParameterDescriptors_$ref_jk3pka() {
  return constructCallableReference((p0) => p0.g1b(), 1, 0, 7);
}
function PluginGeneratedSerialDescriptor$_hashCode$delegate$lambda(this$0) {
  return () => hashCodeImpl(this$0, this$0.g1b());
}
function PluginGeneratedSerialDescriptor$_get__hashCode_$ref_cmj4vz() {
  return constructCallableReference((p0) => _get__hashCode__tgwhef_0(p0), 1, 0, 8);
}
function hashCodeImpl(_this__u8e3s4, typeParams) {
  var result = getStringHashCode(_this__u8e3s4.g10());
  result = imul(31, result) + contentHashCode(typeParams) | 0;
  var elementDescriptors = get_elementDescriptors(_this__u8e3s4);
  // Inline function 'kotlinx.serialization.internal.elementsHashCodeBy' call
  // Inline function 'kotlin.collections.fold' call
  var accumulator = 1;
  var _iterator__ex2g4s = elementDescriptors.p1();
  while (_iterator__ex2g4s.q1()) {
    var element = _iterator__ex2g4s.r1();
    var hash = accumulator;
    var tmp = imul(31, hash);
    // Inline function 'kotlin.hashCode' call
    var tmp0_safe_receiver = element.g10();
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : hashCode(tmp0_safe_receiver);
    accumulator = tmp + (tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs) | 0;
  }
  var namesHash = accumulator;
  // Inline function 'kotlinx.serialization.internal.elementsHashCodeBy' call
  // Inline function 'kotlin.collections.fold' call
  var accumulator_0 = 1;
  var _iterator__ex2g4s_0 = elementDescriptors.p1();
  while (_iterator__ex2g4s_0.q1()) {
    var element_0 = _iterator__ex2g4s_0.r1();
    var hash_0 = accumulator_0;
    var tmp_0 = imul(31, hash_0);
    // Inline function 'kotlin.hashCode' call
    var tmp0_safe_receiver_0 = element_0.w11();
    var tmp1_elvis_lhs_0 = tmp0_safe_receiver_0 == null ? null : hashCode(tmp0_safe_receiver_0);
    accumulator_0 = tmp_0 + (tmp1_elvis_lhs_0 == null ? 0 : tmp1_elvis_lhs_0) | 0;
  }
  var kindHash = accumulator_0;
  result = imul(31, result) + namesHash | 0;
  result = imul(31, result) + kindHash | 0;
  return result;
}
function toStringImpl(_this__u8e3s4) {
  var tmp = until(0, _this__u8e3s4.y11());
  var tmp_0 = _this__u8e3s4.g10() + '(';
  return joinToString(tmp, ', ', tmp_0, ')', VOID, VOID, toStringImpl$lambda(_this__u8e3s4));
}
function toStringImpl$lambda($this_toStringImpl) {
  return (i) => $this_toStringImpl.a12(i) + ': ' + $this_toStringImpl.d12(i).g10();
}
function get_EMPTY_SERIALIZER_ARRAY() {
  _init_properties_PluginHelperInterfaces_kt__xgvzfp();
  return EMPTY_SERIALIZER_ARRAY;
}
var EMPTY_SERIALIZER_ARRAY;
var properties_initialized_PluginHelperInterfaces_kt_ap8in1;
function _init_properties_PluginHelperInterfaces_kt__xgvzfp() {
  if (!properties_initialized_PluginHelperInterfaces_kt_ap8in1) {
    properties_initialized_PluginHelperInterfaces_kt_ap8in1 = true;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    EMPTY_SERIALIZER_ARRAY = [];
  }
}
var CharArraySerializer_instance;
function CharArraySerializer_getInstance() {
  if (CharArraySerializer_instance === VOID)
    new CharArraySerializer();
  return CharArraySerializer_instance;
}
var DoubleArraySerializer_instance;
function DoubleArraySerializer_getInstance() {
  if (DoubleArraySerializer_instance === VOID)
    new DoubleArraySerializer();
  return DoubleArraySerializer_instance;
}
var FloatArraySerializer_instance;
function FloatArraySerializer_getInstance() {
  if (FloatArraySerializer_instance === VOID)
    new FloatArraySerializer();
  return FloatArraySerializer_instance;
}
var LongArraySerializer_instance;
function LongArraySerializer_getInstance() {
  if (LongArraySerializer_instance === VOID)
    new LongArraySerializer();
  return LongArraySerializer_instance;
}
var ULongArraySerializer_instance;
function ULongArraySerializer_getInstance() {
  if (ULongArraySerializer_instance === VOID)
    new ULongArraySerializer();
  return ULongArraySerializer_instance;
}
var IntArraySerializer_instance;
function IntArraySerializer_getInstance() {
  if (IntArraySerializer_instance === VOID)
    new IntArraySerializer();
  return IntArraySerializer_instance;
}
var UIntArraySerializer_instance;
function UIntArraySerializer_getInstance() {
  if (UIntArraySerializer_instance === VOID)
    new UIntArraySerializer();
  return UIntArraySerializer_instance;
}
var ShortArraySerializer_instance;
function ShortArraySerializer_getInstance() {
  if (ShortArraySerializer_instance === VOID)
    new ShortArraySerializer();
  return ShortArraySerializer_instance;
}
var UShortArraySerializer_instance;
function UShortArraySerializer_getInstance() {
  if (UShortArraySerializer_instance === VOID)
    new UShortArraySerializer();
  return UShortArraySerializer_instance;
}
var ByteArraySerializer_instance;
function ByteArraySerializer_getInstance() {
  if (ByteArraySerializer_instance === VOID)
    new ByteArraySerializer();
  return ByteArraySerializer_instance;
}
var UByteArraySerializer_instance;
function UByteArraySerializer_getInstance() {
  if (UByteArraySerializer_instance === VOID)
    new UByteArraySerializer();
  return UByteArraySerializer_instance;
}
var BooleanArraySerializer_instance;
function BooleanArraySerializer_getInstance() {
  if (BooleanArraySerializer_instance === VOID)
    new BooleanArraySerializer();
  return BooleanArraySerializer_instance;
}
function get_BUILTIN_SERIALIZERS() {
  _init_properties_Primitives_kt__k0eto4();
  return BUILTIN_SERIALIZERS;
}
var BUILTIN_SERIALIZERS;
var IntSerializer_instance;
function IntSerializer_getInstance() {
  if (IntSerializer_instance === VOID)
    new IntSerializer();
  return IntSerializer_instance;
}
var BooleanSerializer_instance;
function BooleanSerializer_getInstance() {
  if (BooleanSerializer_instance === VOID)
    new BooleanSerializer();
  return BooleanSerializer_instance;
}
var StringSerializer_instance;
function StringSerializer_getInstance() {
  if (StringSerializer_instance === VOID)
    new StringSerializer();
  return StringSerializer_instance;
}
var LongSerializer_instance;
function LongSerializer_getInstance() {
  if (LongSerializer_instance === VOID)
    new LongSerializer();
  return LongSerializer_instance;
}
function builtinSerializerOrNull(_this__u8e3s4) {
  _init_properties_Primitives_kt__k0eto4();
  var tmp = get_BUILTIN_SERIALIZERS().w4(_this__u8e3s4);
  return (tmp == null ? true : isInterface(tmp, KSerializer)) ? tmp : THROW_CCE();
}
function PrimitiveDescriptorSafe(serialName, kind) {
  _init_properties_Primitives_kt__k0eto4();
  checkNameIsNotAPrimitive(serialName);
  return new PrimitiveSerialDescriptor(serialName, kind);
}
function error_0($this) {
  throw IllegalStateException.o('Primitive descriptor ' + $this.h1h_1 + ' does not have elements');
}
function checkNameIsNotAPrimitive(serialName) {
  _init_properties_Primitives_kt__k0eto4();
  var values = get_BUILTIN_SERIALIZERS().y4();
  var _iterator__ex2g4s = values.p1();
  while (_iterator__ex2g4s.q1()) {
    var primitive = _iterator__ex2g4s.r1();
    var primitiveName = primitive.dz().g10();
    if (serialName === primitiveName) {
      throw IllegalArgumentException.h2(trimIndent('\n                The name of serial descriptor should uniquely identify associated serializer.\n                For serial name ' + serialName + ' there already exists ' + getKClassFromExpression(primitive).j1() + '.\n                Please refer to SerialDescriptor documentation for additional information.\n            '));
    }
  }
}
var ByteSerializer_instance;
function ByteSerializer_getInstance() {
  if (ByteSerializer_instance === VOID)
    new ByteSerializer();
  return ByteSerializer_instance;
}
var ShortSerializer_instance;
function ShortSerializer_getInstance() {
  if (ShortSerializer_instance === VOID)
    new ShortSerializer();
  return ShortSerializer_instance;
}
var CharSerializer_instance;
function CharSerializer_getInstance() {
  if (CharSerializer_instance === VOID)
    new CharSerializer();
  return CharSerializer_instance;
}
var DoubleSerializer_instance;
function DoubleSerializer_getInstance() {
  if (DoubleSerializer_instance === VOID)
    new DoubleSerializer();
  return DoubleSerializer_instance;
}
var FloatSerializer_instance;
function FloatSerializer_getInstance() {
  if (FloatSerializer_instance === VOID)
    new FloatSerializer();
  return FloatSerializer_instance;
}
var UnitSerializer_instance;
function UnitSerializer_getInstance() {
  if (UnitSerializer_instance === VOID)
    new UnitSerializer();
  return UnitSerializer_instance;
}
var properties_initialized_Primitives_kt_6dpii6;
function _init_properties_Primitives_kt__k0eto4() {
  if (!properties_initialized_Primitives_kt_6dpii6) {
    properties_initialized_Primitives_kt_6dpii6 = true;
    BUILTIN_SERIALIZERS = initBuiltins();
  }
}
function tagBlock($this, tag, block) {
  $this.u1i(tag);
  var r = block();
  if (!$this.d1i_1) {
    $this.v1i();
  }
  $this.d1i_1 = false;
  return r;
}
function TaggedDecoder$decodeSerializableElement$lambda(this$0, $deserializer, $previousValue) {
  return () => this$0.n13($deserializer, $previousValue);
}
function TaggedDecoder$decodeNullableSerializableElement$lambda(this$0, $deserializer, $previousValue) {
  return () => {
    var tmp0 = this$0;
    // Inline function 'kotlinx.serialization.encoding.decodeIfNullable' call
    var isNullabilitySupported = $deserializer.dz().p11();
    var tmp;
    if (isNullabilitySupported || tmp0.a13()) {
      tmp = this$0.n13($deserializer, $previousValue);
    } else {
      tmp = tmp0.b13();
    }
    return tmp;
  };
}
function get_NULL() {
  _init_properties_Tuples_kt__dz0qyd();
  return NULL;
}
var NULL;
function MapEntrySerializer$descriptor$lambda($keySerializer, $valueSerializer) {
  return ($this$buildSerialDescriptor) => {
    $this$buildSerialDescriptor.oz('key', $keySerializer.dz());
    $this$buildSerialDescriptor.oz('value', $valueSerializer.dz());
    return Unit_instance;
  };
}
function PairSerializer$descriptor$lambda($keySerializer, $valueSerializer) {
  return ($this$buildClassSerialDescriptor) => {
    $this$buildClassSerialDescriptor.oz('first', $keySerializer.dz());
    $this$buildClassSerialDescriptor.oz('second', $valueSerializer.dz());
    return Unit_instance;
  };
}
function decodeSequentially_1($this, composite) {
  var a = composite.c14($this.r1j_1, 0, $this.o1j_1);
  var b = composite.c14($this.r1j_1, 1, $this.p1j_1);
  var c = composite.c14($this.r1j_1, 2, $this.q1j_1);
  composite.q13($this.r1j_1);
  return new Triple(a, b, c);
}
function decodeStructure($this, composite) {
  var a = get_NULL();
  var b = get_NULL();
  var c = get_NULL();
  mainLoop: while (true) {
    var index = composite.f14($this.r1j_1);
    switch (index) {
      case -1:
        break mainLoop;
      case 0:
        a = composite.c14($this.r1j_1, 0, $this.o1j_1);
        break;
      case 1:
        b = composite.c14($this.r1j_1, 1, $this.p1j_1);
        break;
      case 2:
        c = composite.c14($this.r1j_1, 2, $this.q1j_1);
        break;
      default:
        throw SerializationException.y10('Unexpected index ' + index);
    }
  }
  composite.q13($this.r1j_1);
  if (a === get_NULL())
    throw SerializationException.y10("Element 'first' is missing");
  if (b === get_NULL())
    throw SerializationException.y10("Element 'second' is missing");
  if (c === get_NULL())
    throw SerializationException.y10("Element 'third' is missing");
  return new Triple(a, b, c);
}
function TripleSerializer$descriptor$lambda(this$0) {
  return ($this$buildClassSerialDescriptor) => {
    $this$buildClassSerialDescriptor.oz('first', this$0.o1j_1.dz());
    $this$buildClassSerialDescriptor.oz('second', this$0.p1j_1.dz());
    $this$buildClassSerialDescriptor.oz('third', this$0.q1j_1.dz());
    return Unit_instance;
  };
}
var properties_initialized_Tuples_kt_3vs7ar;
function _init_properties_Tuples_kt__dz0qyd() {
  if (!properties_initialized_Tuples_kt_3vs7ar) {
    properties_initialized_Tuples_kt_3vs7ar = true;
    NULL = new Object();
  }
}
var ULongSerializer_instance;
function ULongSerializer_getInstance() {
  if (ULongSerializer_instance === VOID)
    new ULongSerializer();
  return ULongSerializer_instance;
}
var UIntSerializer_instance;
function UIntSerializer_getInstance() {
  if (UIntSerializer_instance === VOID)
    new UIntSerializer();
  return UIntSerializer_instance;
}
var UByteSerializer_instance;
function UByteSerializer_getInstance() {
  if (UByteSerializer_instance === VOID)
    new UByteSerializer();
  return UByteSerializer_instance;
}
var UShortSerializer_instance;
function UShortSerializer_getInstance() {
  if (UShortSerializer_instance === VOID)
    new UShortSerializer();
  return UShortSerializer_instance;
}
function get_EmptySerializersModuleLegacyJs() {
  _init_properties_SerializersModule_kt__u78ha3();
  return EmptySerializersModule;
}
var EmptySerializersModule;
function plus(_this__u8e3s4, other) {
  _init_properties_SerializersModule_kt__u78ha3();
  // Inline function 'kotlinx.serialization.modules.SerializersModule' call
  var builder = new SerializersModuleBuilder();
  builder.a1l(_this__u8e3s4);
  builder.a1l(other);
  return builder.i19();
}
var properties_initialized_SerializersModule_kt_fjigjn;
function _init_properties_SerializersModule_kt__u78ha3() {
  if (!properties_initialized_SerializersModule_kt_fjigjn) {
    properties_initialized_SerializersModule_kt_fjigjn = true;
    EmptySerializersModule = new SerialModuleImpl(emptyMap(), emptyMap(), emptyMap(), emptyMap(), emptyMap(), false);
  }
}
function EmptySerializersModule_0() {
  return get_EmptySerializersModuleLegacyJs();
}
function SerializersModuleCollector$contextual$lambda($serializer) {
  return (it) => $serializer;
}
function platformSpecificSerializerNotRegistered(_this__u8e3s4) {
  throw SerializationException.y10(notRegisteredMessage(_this__u8e3s4) + 'To get enum serializer on Kotlin/JS, it should be annotated with @Serializable annotation.');
}
function isInterface_0(_this__u8e3s4) {
  return get_isInterfaceHack(_this__u8e3s4);
}
function compiledSerializerImpl(_this__u8e3s4) {
  var tmp0_elvis_lhs = constructSerializerForGivenTypeArgs(_this__u8e3s4, []);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    var tmp_0;
    if (_this__u8e3s4 === PrimitiveClasses_getInstance().jg()) {
      tmp_0 = NothingSerializer_getInstance();
    } else {
      // Inline function 'kotlin.js.asDynamic' call
      var tmp1_safe_receiver = get_js(_this__u8e3s4).Companion;
      tmp_0 = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.serializer();
    }
    var tmp_1 = tmp_0;
    tmp = (!(tmp_1 == null) ? isInterface(tmp_1, KSerializer) : false) ? tmp_1 : null;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  return tmp;
}
function isReferenceArray(rootClass) {
  return rootClass.equals(PrimitiveClasses_getInstance().rg());
}
function constructSerializerForGivenTypeArgs(_this__u8e3s4, args) {
  var tmp;
  try {
    // Inline function 'kotlin.reflect.findAssociatedObject' call
    var assocObject = findAssociatedObject(_this__u8e3s4, getKClass(SerializableWith));
    var tmp_0;
    if (!(assocObject == null) ? isInterface(assocObject, KSerializer) : false) {
      tmp_0 = isInterface(assocObject, KSerializer) ? assocObject : THROW_CCE();
    } else {
      if (!(assocObject == null) ? isInterface(assocObject, SerializerFactory) : false) {
        var tmp_1 = assocObject.m1c(args.slice());
        tmp_0 = isInterface(tmp_1, KSerializer) ? tmp_1 : THROW_CCE();
      } else {
        tmp_0 = null;
      }
    }
    tmp = tmp_0;
  } catch ($p) {
    var tmp_2;
    var e = $p;
    tmp_2 = null;
    tmp = tmp_2;
  }
  return tmp;
}
function createCache(factory) {
  return new createCache$1(factory);
}
function createParametrizedCache(factory) {
  return new createParametrizedCache$1(factory);
}
function getChecked(_this__u8e3s4, index) {
  if (!(0 <= index ? index <= (_this__u8e3s4.length - 1 | 0) : false))
    throw IndexOutOfBoundsException.h3('Index ' + index + ' out of bounds ' + get_indices(_this__u8e3s4).toString());
  return _this__u8e3s4[index];
}
function getChecked_0(_this__u8e3s4, index) {
  if (!(0 <= index ? index <= (_this__u8e3s4.length - 1 | 0) : false))
    throw IndexOutOfBoundsException.h3('Index ' + index + ' out of bounds ' + get_indices_0(_this__u8e3s4).toString());
  return _this__u8e3s4[index];
}
function toNativeArrayImpl(_this__u8e3s4, eClass) {
  // Inline function 'kotlin.collections.toTypedArray' call
  return copyToArray(_this__u8e3s4);
}
function initBuiltins() {
  return mapOf([to(PrimitiveClasses_getInstance().sg(), serializer_0(StringCompanionObject_instance)), to(getKClass(Char), serializer_9(Companion_getInstance_2())), to(PrimitiveClasses_getInstance().vg(), CharArraySerializer_0()), to(PrimitiveClasses_getInstance().qg(), serializer_10(DoubleCompanionObject_instance)), to(PrimitiveClasses_getInstance().bh(), DoubleArraySerializer_0()), to(PrimitiveClasses_getInstance().pg(), serializer_11(FloatCompanionObject_instance)), to(PrimitiveClasses_getInstance().ah(), FloatArraySerializer_0()), to(getKClass(Long), serializer_5(Companion_getInstance_3())), to(get_longArrayClass(), LongArraySerializer_0()), to(getKClass(ULong), serializer_1(Companion_getInstance_4())), to(getKClass(ULongArray), ULongArraySerializer_0()), to(PrimitiveClasses_getInstance().ng(), serializer_6(IntCompanionObject_instance)), to(PrimitiveClasses_getInstance().yg(), IntArraySerializer_0()), to(getKClass(UInt), serializer_2(Companion_getInstance_5())), to(getKClass(UIntArray), UIntArraySerializer_0()), to(PrimitiveClasses_getInstance().mg(), serializer_8(ShortCompanionObject_instance)), to(PrimitiveClasses_getInstance().xg(), ShortArraySerializer_0()), to(getKClass(UShort), serializer_4(Companion_getInstance_6())), to(getKClass(UShortArray), UShortArraySerializer_0()), to(PrimitiveClasses_getInstance().lg(), serializer_7(ByteCompanionObject_instance)), to(PrimitiveClasses_getInstance().wg(), ByteArraySerializer_0()), to(getKClass(UByte), serializer_3(Companion_getInstance_7())), to(getKClass(UByteArray), UByteArraySerializer_0()), to(PrimitiveClasses_getInstance().kg(), serializer_12(BooleanCompanionObject_instance)), to(PrimitiveClasses_getInstance().ug(), BooleanArraySerializer_0()), to(getKClass(Unit), serializer_13(Unit_instance)), to(PrimitiveClasses_getInstance().jg(), NothingSerializer_0()), to(getKClass(Duration), serializer_14(Companion_getInstance())), to(getKClass(Instant), serializer_15(Companion_getInstance_0())), to(getKClass(Uuid), serializer_16(Companion_getInstance_1()))]);
}
function get_isInterfaceHack(_this__u8e3s4) {
  if (_this__u8e3s4 === PrimitiveClasses_getInstance().jg())
    return false;
  // Inline function 'kotlin.js.asDynamic' call
  var tmp0_safe_receiver = get_js(_this__u8e3s4).$metadata$;
  return (tmp0_safe_receiver == null ? null : tmp0_safe_receiver.kind) == 'interface';
}
//region block: post-declaration
initMetadataForClass(Serializable, 'Serializable');
initMetadataForInterface(SerializationStrategy, 'SerializationStrategy');
initMetadataForInterface(DeserializationStrategy, 'DeserializationStrategy');
initMetadataForInterface(KSerializer, 'KSerializer', VOID, VOID, [SerializationStrategy, DeserializationStrategy]);
initMetadataForClass(AbstractPolymorphicSerializer, 'AbstractPolymorphicSerializer', VOID, VOID, [KSerializer]);
initMetadataForClass(PolymorphicSerializer, 'PolymorphicSerializer');
initMetadataForClass(SealedClassSerializer$$inlined$groupingBy$1);
initMetadataForClass(SealedClassSerializer, 'SealedClassSerializer');
initMetadataForInterface(BinaryFormat, 'BinaryFormat');
initMetadataForInterface(StringFormat, 'StringFormat');
initMetadataForClass(SerializationException, 'SerializationException', SerializationException.a11);
initMetadataForClass(UnknownFieldException, 'UnknownFieldException');
initMetadataForClass(MissingFieldException, 'MissingFieldException');
initMetadataForInterface(SerialDescriptor, 'SerialDescriptor');
initMetadataForClass(ContextDescriptor, 'ContextDescriptor', VOID, VOID, [SerialDescriptor]);
initMetadataForClass(elementNames$1);
initMetadataForClass(elementNames$$inlined$Iterable$1, VOID, VOID, VOID, [Iterable]);
initMetadataForClass(elementDescriptors$1);
initMetadataForClass(elementDescriptors$$inlined$Iterable$1, VOID, VOID, VOID, [Iterable]);
initMetadataForClass(ClassSerialDescriptorBuilder, 'ClassSerialDescriptorBuilder');
initMetadataForInterface(CachedNames, 'CachedNames');
protoOf(SerialDescriptorImpl).p11 = get_isNullable;
protoOf(SerialDescriptorImpl).x11 = get_isInline;
initMetadataForClass(SerialDescriptorImpl, 'SerialDescriptorImpl', VOID, VOID, [SerialDescriptor, CachedNames]);
initMetadataForClass(SerialKind, 'SerialKind');
initMetadataForClass(PrimitiveKind, 'PrimitiveKind');
initMetadataForObject(BOOLEAN, 'BOOLEAN');
initMetadataForObject(BYTE, 'BYTE');
initMetadataForObject(CHAR, 'CHAR');
initMetadataForObject(SHORT, 'SHORT');
initMetadataForObject(INT, 'INT');
initMetadataForObject(LONG, 'LONG');
initMetadataForObject(FLOAT, 'FLOAT');
initMetadataForObject(DOUBLE, 'DOUBLE');
initMetadataForObject(STRING, 'STRING');
initMetadataForClass(PolymorphicKind, 'PolymorphicKind');
initMetadataForObject(SEALED, 'SEALED');
initMetadataForObject(OPEN, 'OPEN');
initMetadataForObject(ENUM, 'ENUM');
initMetadataForObject(CONTEXTUAL, 'CONTEXTUAL');
initMetadataForClass(StructureKind, 'StructureKind');
initMetadataForObject(CLASS, 'CLASS');
initMetadataForObject(LIST, 'LIST');
initMetadataForObject(MAP, 'MAP');
initMetadataForObject(OBJECT, 'OBJECT');
initMetadataForInterface(Decoder, 'Decoder');
initMetadataForInterface(CompositeDecoder, 'CompositeDecoder');
protoOf(AbstractDecoder).c14 = decodeSerializableElement$default;
protoOf(AbstractDecoder).o13 = decodeSerializableValue;
protoOf(AbstractDecoder).e14 = decodeSequentially;
protoOf(AbstractDecoder).g14 = decodeCollectionSize;
initMetadataForClass(AbstractDecoder, 'AbstractDecoder', VOID, VOID, [Decoder, CompositeDecoder]);
initMetadataForInterface(Encoder, 'Encoder');
initMetadataForInterface(CompositeEncoder, 'CompositeEncoder');
protoOf(AbstractEncoder).k15 = encodeNotNullMark;
protoOf(AbstractEncoder).l15 = beginCollection;
protoOf(AbstractEncoder).h15 = encodeSerializableValue;
protoOf(AbstractEncoder).j15 = encodeNullableSerializableValue;
protoOf(AbstractEncoder).m15 = shouldEncodeElementDefault;
initMetadataForClass(AbstractEncoder, 'AbstractEncoder', VOID, VOID, [Encoder, CompositeEncoder]);
initMetadataForObject(NothingSerializer, 'NothingSerializer', VOID, VOID, [KSerializer]);
initMetadataForObject(DurationSerializer, 'DurationSerializer', VOID, VOID, [KSerializer]);
initMetadataForObject(InstantSerializer, 'InstantSerializer', VOID, VOID, [KSerializer]);
initMetadataForObject(UuidSerializer, 'UuidSerializer', VOID, VOID, [KSerializer]);
protoOf(ListLikeDescriptor).p11 = get_isNullable;
protoOf(ListLikeDescriptor).x11 = get_isInline;
protoOf(ListLikeDescriptor).z11 = get_annotations;
initMetadataForClass(ListLikeDescriptor, 'ListLikeDescriptor', VOID, VOID, [SerialDescriptor]);
initMetadataForClass(ArrayListClassDesc, 'ArrayListClassDesc');
initMetadataForClass(LinkedHashSetClassDesc, 'LinkedHashSetClassDesc');
protoOf(MapLikeDescriptor).p11 = get_isNullable;
protoOf(MapLikeDescriptor).x11 = get_isInline;
protoOf(MapLikeDescriptor).z11 = get_annotations;
initMetadataForClass(MapLikeDescriptor, 'MapLikeDescriptor', VOID, VOID, [SerialDescriptor]);
initMetadataForClass(LinkedHashMapClassDesc, 'LinkedHashMapClassDesc');
initMetadataForClass(HashSetClassDesc, 'HashSetClassDesc');
initMetadataForClass(HashMapClassDesc, 'HashMapClassDesc');
initMetadataForClass(ArrayClassDesc, 'ArrayClassDesc');
initMetadataForClass(PrimitiveArrayDescriptor, 'PrimitiveArrayDescriptor');
initMetadataForClass(AbstractCollectionSerializer, 'AbstractCollectionSerializer', VOID, VOID, [KSerializer]);
initMetadataForClass(CollectionLikeSerializer, 'CollectionLikeSerializer');
initMetadataForClass(CollectionSerializer, 'CollectionSerializer');
initMetadataForClass(ArrayListSerializer, 'ArrayListSerializer');
initMetadataForClass(LinkedHashSetSerializer, 'LinkedHashSetSerializer');
initMetadataForClass(MapLikeSerializer, 'MapLikeSerializer');
initMetadataForClass(LinkedHashMapSerializer, 'LinkedHashMapSerializer');
initMetadataForClass(HashSetSerializer, 'HashSetSerializer');
initMetadataForClass(HashMapSerializer, 'HashMapSerializer');
initMetadataForClass(ReferenceArraySerializer, 'ReferenceArraySerializer');
initMetadataForClass(PrimitiveArraySerializer, 'PrimitiveArraySerializer');
initMetadataForClass(PrimitiveArrayBuilder, 'PrimitiveArrayBuilder');
initMetadataForCompanion(Companion);
initMetadataForClass(ElementMarker, 'ElementMarker');
initMetadataForClass(EnumSerializer, 'EnumSerializer', VOID, VOID, [KSerializer]);
protoOf(PluginGeneratedSerialDescriptor).p11 = get_isNullable;
protoOf(PluginGeneratedSerialDescriptor).x11 = get_isInline;
initMetadataForClass(PluginGeneratedSerialDescriptor, 'PluginGeneratedSerialDescriptor', VOID, VOID, [SerialDescriptor, CachedNames]);
initMetadataForClass(EnumDescriptor, 'EnumDescriptor');
initMetadataForClass(InlineClassDescriptor, 'InlineClassDescriptor');
initMetadataForInterface(GeneratedSerializer, 'GeneratedSerializer', VOID, VOID, [KSerializer]);
protoOf(InlinePrimitiveDescriptor$1).z1b = typeParametersSerializers;
initMetadataForClass(InlinePrimitiveDescriptor$1, VOID, VOID, VOID, [GeneratedSerializer]);
initMetadataForObject(NoOpEncoder, 'NoOpEncoder');
protoOf(NothingSerialDescriptor).p11 = get_isNullable;
protoOf(NothingSerialDescriptor).x11 = get_isInline;
protoOf(NothingSerialDescriptor).z11 = get_annotations;
initMetadataForObject(NothingSerialDescriptor, 'NothingSerialDescriptor', VOID, VOID, [SerialDescriptor]);
initMetadataForClass(NullableSerializer, 'NullableSerializer', VOID, VOID, [KSerializer]);
initMetadataForClass(SerialDescriptorForNullable, 'SerialDescriptorForNullable', VOID, VOID, [SerialDescriptor, CachedNames]);
initMetadataForClass(ObjectSerializer, 'ObjectSerializer', VOID, VOID, [KSerializer]);
initMetadataForInterface(SerializerFactory, 'SerializerFactory');
initMetadataForObject(CharArraySerializer, 'CharArraySerializer', VOID, VOID, [KSerializer]);
initMetadataForObject(DoubleArraySerializer, 'DoubleArraySerializer', VOID, VOID, [KSerializer]);
initMetadataForObject(FloatArraySerializer, 'FloatArraySerializer', VOID, VOID, [KSerializer]);
initMetadataForObject(LongArraySerializer, 'LongArraySerializer', VOID, VOID, [KSerializer]);
initMetadataForObject(ULongArraySerializer, 'ULongArraySerializer', VOID, VOID, [KSerializer]);
initMetadataForObject(IntArraySerializer, 'IntArraySerializer', VOID, VOID, [KSerializer]);
initMetadataForObject(UIntArraySerializer, 'UIntArraySerializer', VOID, VOID, [KSerializer]);
initMetadataForObject(ShortArraySerializer, 'ShortArraySerializer', VOID, VOID, [KSerializer]);
initMetadataForObject(UShortArraySerializer, 'UShortArraySerializer', VOID, VOID, [KSerializer]);
initMetadataForObject(ByteArraySerializer, 'ByteArraySerializer', VOID, VOID, [KSerializer]);
initMetadataForObject(UByteArraySerializer, 'UByteArraySerializer', VOID, VOID, [KSerializer]);
initMetadataForObject(BooleanArraySerializer, 'BooleanArraySerializer', VOID, VOID, [KSerializer]);
initMetadataForClass(CharArrayBuilder, 'CharArrayBuilder');
initMetadataForClass(DoubleArrayBuilder, 'DoubleArrayBuilder');
initMetadataForClass(FloatArrayBuilder, 'FloatArrayBuilder');
initMetadataForClass(LongArrayBuilder, 'LongArrayBuilder');
initMetadataForClass(ULongArrayBuilder, 'ULongArrayBuilder');
initMetadataForClass(IntArrayBuilder, 'IntArrayBuilder');
initMetadataForClass(UIntArrayBuilder, 'UIntArrayBuilder');
initMetadataForClass(ShortArrayBuilder, 'ShortArrayBuilder');
initMetadataForClass(UShortArrayBuilder, 'UShortArrayBuilder');
initMetadataForClass(ByteArrayBuilder, 'ByteArrayBuilder');
initMetadataForClass(UByteArrayBuilder, 'UByteArrayBuilder');
initMetadataForClass(BooleanArrayBuilder, 'BooleanArrayBuilder');
initMetadataForObject(IntSerializer, 'IntSerializer', VOID, VOID, [KSerializer]);
initMetadataForObject(BooleanSerializer, 'BooleanSerializer', VOID, VOID, [KSerializer]);
initMetadataForObject(StringSerializer, 'StringSerializer', VOID, VOID, [KSerializer]);
initMetadataForObject(LongSerializer, 'LongSerializer', VOID, VOID, [KSerializer]);
protoOf(PrimitiveSerialDescriptor).p11 = get_isNullable;
protoOf(PrimitiveSerialDescriptor).x11 = get_isInline;
protoOf(PrimitiveSerialDescriptor).z11 = get_annotations;
initMetadataForClass(PrimitiveSerialDescriptor, 'PrimitiveSerialDescriptor', VOID, VOID, [SerialDescriptor]);
initMetadataForObject(ByteSerializer, 'ByteSerializer', VOID, VOID, [KSerializer]);
initMetadataForObject(ShortSerializer, 'ShortSerializer', VOID, VOID, [KSerializer]);
initMetadataForObject(CharSerializer, 'CharSerializer', VOID, VOID, [KSerializer]);
initMetadataForObject(DoubleSerializer, 'DoubleSerializer', VOID, VOID, [KSerializer]);
initMetadataForObject(FloatSerializer, 'FloatSerializer', VOID, VOID, [KSerializer]);
initMetadataForObject(UnitSerializer, 'UnitSerializer', VOID, VOID, [KSerializer]);
protoOf(TaggedDecoder).c14 = decodeSerializableElement$default;
protoOf(TaggedDecoder).o13 = decodeSerializableValue;
protoOf(TaggedDecoder).e14 = decodeSequentially;
protoOf(TaggedDecoder).g14 = decodeCollectionSize;
initMetadataForClass(TaggedDecoder, 'TaggedDecoder', VOID, VOID, [Decoder, CompositeDecoder]);
initMetadataForClass(NamedValueDecoder, 'NamedValueDecoder');
initMetadataForClass(MapEntry, 'MapEntry', VOID, VOID, [Entry]);
initMetadataForClass(KeyValueSerializer, 'KeyValueSerializer', VOID, VOID, [KSerializer]);
initMetadataForClass(MapEntrySerializer, 'MapEntrySerializer');
initMetadataForClass(PairSerializer, 'PairSerializer');
initMetadataForClass(TripleSerializer, 'TripleSerializer', VOID, VOID, [KSerializer]);
initMetadataForObject(ULongSerializer, 'ULongSerializer', VOID, VOID, [KSerializer]);
initMetadataForObject(UIntSerializer, 'UIntSerializer', VOID, VOID, [KSerializer]);
initMetadataForObject(UByteSerializer, 'UByteSerializer', VOID, VOID, [KSerializer]);
initMetadataForObject(UShortSerializer, 'UShortSerializer', VOID, VOID, [KSerializer]);
initMetadataForClass(SerializersModule, 'SerializersModule');
initMetadataForClass(SerialModuleImpl, 'SerialModuleImpl');
initMetadataForClass(ContextualProvider, 'ContextualProvider');
initMetadataForClass(Argless, 'Argless');
initMetadataForClass(WithTypeArguments, 'WithTypeArguments');
initMetadataForInterface(SerializersModuleCollector, 'SerializersModuleCollector');
initMetadataForClass(SerializersModuleBuilder, 'SerializersModuleBuilder', VOID, VOID, [SerializersModuleCollector]);
initMetadataForClass(SerializerAlreadyRegisteredException, 'SerializerAlreadyRegisteredException');
initMetadataForClass(SerializableWith, 'SerializableWith', VOID, VOID, VOID, VOID, 0);
initMetadataForClass(createCache$1);
initMetadataForClass(createParametrizedCache$1);
//endregion
//region block: exports
export {
  SEALED_getInstance as SEALED_getInstance2pc3convncp73,
  SHORT_getInstance as SHORT_getInstance1w4976erfyxry,
  STRING_getInstance as STRING_getInstance1ov5zayfui8fl,
  CONTEXTUAL_getInstance as CONTEXTUAL_getInstance2bsxm25kydylq,
  ENUM_getInstance as ENUM_getInstance1f3d4zr61j5rk,
  CLASS_getInstance as CLASS_getInstance3ax1g1upf6nuo,
  LIST_getInstance as LIST_getInstance2xmlsct1exo3w,
  MAP_getInstance as MAP_getInstance173r3f2itu405,
  OBJECT_getInstance as OBJECT_getInstance2hwgzvvdc8p80,
  BooleanSerializer_getInstance as BooleanSerializer_getInstance3sa31xxwvx0ks,
  ByteArraySerializer_getInstance as ByteArraySerializer_getInstance3p3rwnvaterxj,
  IntSerializer_getInstance as IntSerializer_getInstance3hkg1llvt1c0z,
  LongSerializer_getInstance as LongSerializer_getInstance1q1voa3zes72d,
  StringSerializer_getInstance as StringSerializer_getInstancerxlnwnlbnwri,
  ListSerializer as ListSerializer1hxuk9dx5n9du,
  MapSerializer as MapSerializer11kmegt3g5c1g,
  get_nullable as get_nullable197rfua9r7fsz,
  serializer_0 as serializer1x79l67jvwntn,
  serializer_4 as serializer1q7c5q67ysppr,
  serializer_2 as serializer3ikrxnm8b29d6,
  serializer_3 as serializer36584sjyg5661,
  serializer_1 as serializer2lw83vwvpnyms,
  PolymorphicKind as PolymorphicKindla9gurooefwb,
  PrimitiveKind as PrimitiveKindndgbuh6is7ze,
  PrimitiveSerialDescriptor_0 as PrimitiveSerialDescriptor3egfp53lutxj2,
  get_annotations as get_annotationshjxdbdcl8kmv,
  get_isInline as get_isInline5x26qrhi9qs6,
  get_isNullable as get_isNullable36pbikm8xb7bz,
  SerialDescriptor as SerialDescriptor2pelqekb5ic3a,
  ENUM as ENUMlmq49cvwy4ow,
  buildClassSerialDescriptor as buildClassSerialDescriptors2a6xdp6mrtw,
  buildSerialDescriptor as buildSerialDescriptor2873qmkp8r2ib,
  getContextualDescriptor as getContextualDescriptor2n1gf3b895yb8,
  AbstractDecoder as AbstractDecoder35guh02ubh2hm,
  AbstractEncoder as AbstractEncoder2gxtu3xmy3f8j,
  CompositeDecoder as CompositeDecoder2tzm7wpwkr0og,
  CompositeEncoder as CompositeEncoderknecpkexzn3v,
  Decoder as Decoder23nde051s631g,
  Encoder as Encoderqvmrpqtq8hnu,
  AbstractPolymorphicSerializer as AbstractPolymorphicSerializer1ccxwp48nfy58,
  ArrayListSerializer as ArrayListSerializer7k5wnrulb3y6,
  ElementMarker as ElementMarker33ojvsajwmzts,
  typeParametersSerializers as typeParametersSerializers2likxjr48tr7y,
  GeneratedSerializer as GeneratedSerializer1f7t7hssdd2ws,
  InlineClassDescriptor as InlineClassDescriptor2odlvyasjrmr0,
  InlinePrimitiveDescriptor as InlinePrimitiveDescriptor3i6ccn1a4fw94,
  LinkedHashMapSerializer as LinkedHashMapSerializermaoj2nyji7op,
  LinkedHashSetSerializer as LinkedHashSetSerializer3ncla559t2lx7,
  NamedValueDecoder as NamedValueDecoderzk26ztf92xbq,
  ObjectSerializer as ObjectSerializer2kjkucmygguwd,
  PluginGeneratedSerialDescriptor as PluginGeneratedSerialDescriptorqdzeg5asqhfg,
  SerializerFactory as SerializerFactory1qv9hivitncuv,
  createAnnotatedEnumSerializer as createAnnotatedEnumSerializer20ay4pme9p2h9,
  createSimpleEnumSerializer as createSimpleEnumSerializer2guioz11kk1m0,
  jsonCachedSerialNames as jsonCachedSerialNameslxufy2gu43jt,
  throwArrayMissingFieldException as throwArrayMissingFieldExceptionbk1mj238w44a,
  throwMissingFieldException as throwMissingFieldException2cmke0v3ynf14,
  EmptySerializersModule_0 as EmptySerializersModule991ju6pz9b79,
  SerializersModuleBuilder as SerializersModuleBuilderfxsfdohcdipc,
  contextual as contextual3hpp1gupsu4al,
  SerializersModuleCollector as SerializersModuleCollector3dddz14wd7brg,
  plus as plus1c7xncg0dvi6w,
  BinaryFormat as BinaryFormat3f3aelhmz0ro1,
  DeserializationStrategy as DeserializationStrategy1z3z5pj9f7zc8,
  KSerializer as KSerializerzf77vz1967fq,
  MissingFieldException as MissingFieldException24tqif29emcmi,
  PolymorphicSerializer as PolymorphicSerializer3p3fzpdobi8hh,
  SealedClassSerializer as SealedClassSerializeriwipiibk55zc,
  SerializableWith as SerializableWithd2dap36updxd,
  Serializable as Serializable1wyi8gijab9yh,
  SerializationException as SerializationExceptioneqrdve3ts2n9,
  SerializationStrategy as SerializationStrategyh6ouydnm6hci,
  StringFormat as StringFormat2r2ka8mzcb3mi,
  UnknownFieldException as UnknownFieldExceptiona60e3a6v1xqo,
  findPolymorphicSerializer as findPolymorphicSerializer1nm87hvemahcj,
  findPolymorphicSerializer_0 as findPolymorphicSerializerk638ixyjovk5,
  serializer as serializer1i4e9ym37oxmo,
};
//endregion
